import {JsonFragmentName} from './fragments'

// @ts-nocheck
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Scalars = {
    String: string,
    Boolean: boolean,
    Int: number,
    Json: any,
    ID: string,
    Float: number,
}

export interface CommonError {
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'CommonError'
}

export type ErrorInterface = (CommonError | RateError | OtpError | AccessError | FormError | ExternalServiceError | ProtocolError | InternalError | UserError | VorderError) & { __isUnion?: true }

export type ErrorTypeEnum = 'common' | 'rate' | 'otp' | 'access' | 'form' | 'external_service' | 'protocol' | 'internal' | 'user' | 'vorder'

export type ErrorNameEnum = 'common' | 'common_not_found' | 'common_input_error' | 'common_invalid_format' | 'rate_limited' | 'otp_common' | 'otp_code_wrong' | 'otp_attempts_limit' | 'access_not_authorized' | 'access_restricted' | 'form_field_format_invalid' | 'form_field_required' | 'es_blocked' | 'es_rate_limit' | 'es_rejected' | 'protocol_socket_fail' | 'protocol_request_fail' | 'internal' | 'user_common' | 'vorder_restriction' | 'vorder_field_required' | 'vorder_basket_item_restricted' | 'vorder_basket_item_schedule' | 'vorder_basket_empty' | 'vorder_time_busy' | 'vorder_coupon_invalid' | 'vorder_coupon_min_price' | 'vorder_bonus_lager_then_max_percent' | 'vorder_submit_failed' | 'vorder_save_failed'

export interface RateError {
    ttl: (Scalars['Int'] | null)
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'RateError'
}

export interface OtpError {
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'OtpError'
}

export interface AccessError {
    authRedirect: (Scalars['Boolean'] | null)
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'AccessError'
}

export interface FormError {
    fieldName: (Scalars['String'] | null)
    fieldLabel: (Scalars['String'] | null)
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'FormError'
}

export interface ExternalServiceError {
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'ExternalServiceError'
}

export interface ProtocolError {
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'ProtocolError'
}

export interface InternalError {
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'InternalError'
}

export interface UserError {
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'UserError'
}

export interface BasketRuleBenefitDiscount {
    UID: (Scalars['String'] | null)
    TYPE: BasketRuleBenefitTypeEnum
    DISCOUNT_PERCENT: (Scalars['Int'] | null)
    __typename: 'BasketRuleBenefitDiscount'
}

export type BasketRuleBenefitInterface = (BasketRuleBenefitDiscount | BasketRuleBenefitGift) & { __isUnion?: true }

export type BasketRuleBenefitTypeEnum = 'discount' | 'gift' | 'special'

export interface BasketRuleBenefitGift {
    UID: (Scalars['String'] | null)
    TYPE: BasketRuleBenefitTypeEnum
    PRODUCT_ID: (Scalars['Int'] | null)
    __typename: 'BasketRuleBenefitGift'
}

export interface VorderError {
    itemUuid: (Scalars['String'] | null)
    fieldName: (Scalars['String'] | null)
    fieldLabel: (Scalars['String'] | null)
    section: (VOrderSectionEnum | null)
    type: (ErrorTypeEnum | null)
    name: (ErrorNameEnum | null)
    message: (Scalars['String'] | null)
    messages: (Scalars['String'] | null)[]
    alertShow: (Scalars['Boolean'] | null)
    alertMessage: (Scalars['String'] | null)
    alertDuration: (Scalars['Int'] | null)
    targetShow: (Scalars['Boolean'] | null)
    targetMessage: (Scalars['String'] | null)
    debug: (Scalars['Json'] | null)
    rel: (Scalars['Json'] | null)
    data: (Scalars['Json'] | null)
    __typename: 'VorderError'
}

export type VOrderSectionEnum = 'delivery_courier' | 'delivery_pickup' | 'payment' | 'time' | 'basket' | 'basket_item' | 'cultery' | 'comment' | 'benefit' | 'benefit_prize' | 'benefit_coupon' | 'benefit_bonus' | 'benefit_discount' | 'benefit_gift' | 'common' | 'operator'

export interface Query {
    testPublicpublic: (TestItem | null)
    testOptionalAuthlist: ((TestItem | null)[] | null)
    testRequiredAuthauthorized: (TestItem | null)
    testAdminOnlyadminOnly: (TestItem | null)
    testCombinedadminOnly: (TestItem | null)
    testCombinedlist: ((TestItem | null)[] | null)
    hook_query: (Scalars['Boolean'] | null)
    entity_options: EntityOption[]
    entity_type_list: EntityType[]
    entity_type: (EntityType | null)
    entity_provider_types: (EntityProviderType | null)
    entity_computed_fields: EntityComputedField[]
    menu_menus: ((Menu | null)[] | null)
    list: ((ClientEmit | null)[] | null)
    notice_pub_list: ClientNotice[]
    user_session: (UserSession | null)
    user_fetch: (User | null)
    user_app_client: (AppClient | null)
    page_single: Page
    page_list: Page[]
    page_recordset: (PageRecordset | null)
    page_route: (Page | null)
    company_office_single: CompanyOffice
    company_office_list: CompanyOffice[]
    company_office_recordset: (OfficeRecordset | null)
    company_vacancy_single: CompanyVacancy
    company_vacancy_list: CompanyVacancy[]
    company_vacancy_recordset: (VacancyRecordset | null)
    faq_element_single: FaqQuestion
    faq_element_list: FaqQuestion[]
    faq_element_recordset: (FaqQuestionRecordset | null)
    geo_geocoder_locations_by_coords: ((GeoObject | null)[] | null)
    geo_geocoder_location_by_address: (GeoObject | null)
    search_suggestions_popular: SearchSuggestion[]
    search_suggestions: SearchSuggestion[]
    offer_single: Offer
    offer_list: Offer[]
    offer_recordset: (OfferRecordset | null)
    offer_user_list: Offer[]
    offer_common_list: Offer[]
    push_vapid_public_key: (Scalars['String'] | null)
    push_user_subscribers: ((PushSubscriber | null)[] | null)
    fortune_prizes: FortunePrize[]
    fortune_user_prize: (FortuneUserPrize | null)
    telegram_single: TelegramChat
    telegram_list: TelegramChat[]
    telegram_recordset: (TelegramChatRecordset | null)
    telegram_chat_by_id: (TelegramChat | null)
    telegram_active_chats: TelegramChat[]
    camera_element_list: Webcam[]
    review_list: Review[]
    catalog_product_single: Product
    catalog_product_list: Product[]
    catalog_product_recordset: (AppProductRecordset | null)
    catalog_product_all: Product[]
    catalog_product_fav_list: Product[]
    catalog_product_fav_list2: Product[]
    catalog_product_search: (SearchResult | null)
    catalog_product_search_new: Product[]
    sale_order_active_list: Order[]
    sale_order_ensure_payment: (Payment | null)
    vorder_current: (VorderCurrent | null)
    vorder_summary: (VorderSummary | null)
    vorder_basket_products: ((Product | null)[] | null)
    sale_profile_single: OrderProfile
    sale_profile_list: OrderProfile[]
    sale_profile_recordset: (OrderProfileRecordset | null)
    sale_client_card_single: SaleClientCard
    sale_client_card_list: SaleClientCard[]
    sale_client_card_recordset: (ClientCardRecordset | null)
    sale_client_card_fetch: (SaleClientCard | null)
    sale_client_card_apply_by_phone: (SaleClientCard | null)
    sale_delivery_zones: DeliveryZone[]
    sale_order_statuses: (OrderStatus[] | null)
    basket_rule_list: BasketRule[]
    sale_bonus_level_list: BonusLevel[]
    product_ingredient_list: ProductIngredient[]
    product_modificator_list: Modificator[]
    product_flag_list: ProductFlag[]
    order_restriction_list: OrderRestriction[]
    catalog_product_section_list: ProductSection[]
    order_history: Order[]
    client_segment_single: ClientSegment
    client_segment_list: ClientSegment[]
    client_segment_recordset: (ClientSegmentRecordset | null)
    feature_single: Feature
    feature_list: Feature[]
    feature_recordset: (FeatureRecordset | null)
    feature_list_for_user: ((Feature | null)[] | null)
    call_tracking_phone: (CallTrackingPhone | null)
    yandex_metric_goal_single: YandexMetricGoal
    yandex_metric_goal_list: YandexMetricGoal[]
    yandex_metric_goal_recordset: (YandexMetricGoalRecordset | null)
    __typename: 'Query'
}

export interface TestItem {
    id: Scalars['Int']
    name: Scalars['String']
    description: (Scalars['String'] | null)
    createdAt: (Scalars['String'] | null)
    __typename: 'TestItem'
}

export interface EntityOption {
    UID: (Scalars['String'] | null)
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    TAXONOMY_TERM_ID: (Scalars['Int'] | null)
    TAXONOMY_TERM_IDS: Scalars['Int'][]
    PARENT_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    __typename: 'EntityOption'
}

export interface EntityType {
    UID: Scalars['String']
    PROVIDER_TYPE: Scalars['String']
    PROVIDER_TYPE_NAME: Scalars['String']
    PROVIDER: Scalars['String']
    PROVIDER_NAME: Scalars['String']
    BUNDLE_CODE: (Scalars['String'] | null)
    BUNDLE_ID: (Scalars['Int'] | null)
    ENTITY_TYPE: Scalars['String']
    TAXONOMY_TYPE: (Scalars['String'] | null)
    TAXONOMY_MEMBER_TYPE: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    ROLE: (Scalars['String'] | null)
    CLASS: (Scalars['String'] | null)
    RIGHTS: Scalars['String'][]
    TAXONOMY_TERMS: EntityOption[]
    OPTIONS: EntityOption[]
    __typename: 'EntityType'
}

export interface EntityProviderType {
    CODE: Scalars['String']
    NAME: Scalars['String']
    __typename: 'EntityProviderType'
}

export interface EntityComputedField {
    entityType: (Scalars['String'] | null)
    entityBundleCode: (Scalars['String'] | null)
    entityBundleId: (Scalars['Int'] | null)
    name: (Scalars['String'] | null)
    type: (Scalars['String'] | null)
    conditionDate: (Scalars['Boolean'] | null)
    valueType: (Scalars['String'] | null)
    round: (Scalars['Boolean'] | null)
    valueOptions: (EntityComputedFieldValueOption[] | null)
    entityField: (Scalars['String'] | null)
    __typename: 'EntityComputedField'
}

export interface EntityComputedFieldValueOption {
    label: (Scalars['String'] | null)
    value: (Scalars['Json'] | null)
    __typename: 'EntityComputedFieldValueOption'
}

export interface Menu {
    id: (Scalars['String'] | null)
    code: (Scalars['String'] | null)
    children: ((MenuItem | null)[] | null)
    __typename: 'Menu'
}

export interface MenuItem {
    id: (Scalars['String'] | null)
    parent: (Scalars['String'] | null)
    label: (Scalars['String'] | null)
    infoLabel: (Scalars['String'] | null)
    command: (Command | null)
    url: (Scalars['String'] | null)
    blank: (Scalars['Boolean'] | null)
    native: (Scalars['Boolean'] | null)
    icon: (Scalars['String'] | null)
    imageId: (Scalars['Int'] | null)
    image: (Image | null)
    display: ((Scalars['String'] | null)[] | null)
    color: (Scalars['String'] | null)
    bgColor: (Scalars['String'] | null)
    children: ((MenuItem | null)[] | null)
    roles: ((Scalars['String'] | null)[] | null)
    entityType: (Scalars['String'] | null)
    entityId: (Scalars['String'] | null)
    badge: (Scalars['Json'] | null)
    params: (Scalars['Json'] | null)
    size: (Scalars['String'] | null)
    outline: (Scalars['Boolean'] | null)
    flat: (Scalars['Boolean'] | null)
    width: (Scalars['String'] | null)
    class: (Scalars['String'] | null)
    onClick: (Scalars['Json'] | null)
    dense: (Scalars['Boolean'] | null)
    loading: (Scalars['Boolean'] | null)
    loadingLabel: (Scalars['String'] | null)
    disable: (Scalars['Boolean'] | null)
    textColor: (Scalars['String'] | null)
    __typename: 'MenuItem'
}

export interface Command {
    code: (Scalars['String'] | null)
    type: (Scalars['String'] | null)
    path: (Scalars['String'] | null)
    params: (Scalars['Json'] | null)
    confirm: (Scalars['Boolean'] | null)
    __typename: 'Command'
}

export interface Image {
    ID: (Scalars['ID'] | null)
    SRC: (Scalars['String'] | null)
    SRC_DEFAULT: (Scalars['String'] | null)
    FILE_SIZE: (Scalars['String'] | null)
    ORIGINAL_NAME: (Scalars['String'] | null)
    __typename: 'Image'
}

export interface ClientEmit {
    id: (Scalars['Int'] | null)
    title: (Scalars['String'] | null)
    message: (Scalars['String'] | null)
    body: (Scalars['String'] | null)
    eventName: (Scalars['String'] | null)
    eventData: (Scalars['Json'] | null)
    eventGroup: (Scalars['String'] | null)
    targetUserId: (Scalars['Int'] | null)
    targetClientId: (Scalars['String'] | null)
    createdAt: Scalars['Json']
    cls: (Scalars['String'] | null)
    __typename: 'ClientEmit'
}

export type DateFormatEnum = 'jstimestamp' | 'timestamp' | 'datetime' | 'date'

export interface ClientNotice {
    ID: Scalars['Int']
    TITLE: (Scalars['String'] | null)
    MESSAGE: (Scalars['String'] | null)
    BODY: (Scalars['String'] | null)
    EVENT_NAME: (Scalars['String'] | null)
    EVENT_DATA: (Scalars['Json'] | null)
    EVENT_GROUP: (Scalars['String'] | null)
    ENTITY_TYPE: (Scalars['String'] | null)
    ENTITY_ID: (Scalars['Int'] | null)
    TARGET_CLIENT_ID: (Scalars['String'] | null)
    TARGET_USER_ID: (Scalars['Float'] | null)
    CREATED_AT_FORMATTED: (Scalars['String'] | null)
    CREATED_AT: (Scalars['Int'] | null)
    ACTION_MOBILE: (Scalars['String'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    IMAGE: (Image | null)
    TARGET: (NoticeTargetEnum | null)
    BODY_HTML: (Scalars['String'] | null)
    SHOW_AS: (NoticeShowAsEnum | null)
    image: (Image | null)
    IMPORTANT: (Scalars['Boolean'] | null)
    haveBody: (Scalars['Boolean'] | null)
    showAs: (Scalars['String'] | null)
    targetCode: (Scalars['String'] | null)
    actionItems: MenuItem[]
    cls: (Scalars['String'] | null)
    isReaded: (Scalars['Boolean'] | null)
    __typename: 'ClientNotice'
}

export type NoticeTargetEnum = 'common' | 'private'

export type NoticeShowAsEnum = 'alert' | 'dialog'

export interface UserSession {
    SESSION_ID: (Scalars['String'] | null)
    USER_ID: (Scalars['Int'] | null)
    FUSER_ID: (Scalars['Int'] | null)
    __typename: 'UserSession'
}

export interface User {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    SESSION_ID: (Scalars['String'] | null)
    GROUPS: UserGroup[]
    ROLES: Scalars['String'][]
    DL: (Scalars['Int'] | null)
    LOGIN: (Scalars['String'] | null)
    LOGIN_FORMAT: (Scalars['String'] | null)
    EMAIL: (Scalars['String'] | null)
    NAME_FULL: (Scalars['String'] | null)
    NAME_TEASER: (Scalars['String'] | null)
    LAST_NAME: (Scalars['String'] | null)
    SECOND_NAME: (Scalars['String'] | null)
    PHONE: (Scalars['String'] | null)
    PHONE_FORMATTED: (Scalars['String'] | null)
    PERSONAL_PHOTO: (Image | null)
    PERSONAL_BIRTHDAY: (Scalars['String'] | null)
    DATE_REGISTER: (Scalars['String'] | null)
    LAST_LOGIN: (Scalars['String'] | null)
    PERSON_TYPE_ID: (Scalars['Int'] | null)
    PROPS: ((EntityProp | null)[] | null)
    PROMOCODE: (Scalars['String'] | null)
    AVATAR: (UserAvatar | null)
    GREETING_NAME: (Scalars['String'] | null)
    FAMILY: ((UserFamily | null)[] | null)
    PROFILE_FILLED: (Scalars['Boolean'] | null)
    PROFILE_GIFT_USED: (Scalars['Boolean'] | null)
    COMPUTED: (Scalars['Json'] | null)
    ORDER_COUNT: (Scalars['Json'] | null)
    SUBSCRIPTIONS: Scalars['String'][]
    __typename: 'User'
}

export interface UserGroup {
    ID: (Scalars['Int'] | null)
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    DL: (Scalars['Int'] | null)
    __typename: 'UserGroup'
}

export interface EntityProp {
    ID: (Scalars['Int'] | null)
    CODE: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    TYPE: (Scalars['String'] | null)
    VAL: (Scalars['Json'] | null)
    VAL_ID: (Scalars['Json'] | null)
    VAL_ENUM_ID: (Scalars['Json'] | null)
    DESC: (Scalars['Json'] | null)
    MUL: (Scalars['Boolean'] | null)
    FILE: (Image | null)
    FILES: ((Image | null)[] | null)
    __typename: 'EntityProp'
}

export interface UserAvatar {
    ELEMENT_ID: (Scalars['Int'] | null)
    IMAGE: (Image | null)
    __typename: 'UserAvatar'
}

export interface UserFamily {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    RELATION: (Scalars['String'] | null)
    USER_ID: (Scalars['String'] | null)
    BIRTHDAY: (Scalars['String'] | null)
    __typename: 'UserFamily'
}

export interface AppClient {
    ID: Scalars['Int']
    CLIENT_ID: (Scalars['String'] | null)
    TOKEN: (Scalars['String'] | null)
    SESSION_ID: (Scalars['String'] | null)
    CURRENT_SESSION_ID: (Scalars['String'] | null)
    USER_ID: (Scalars['Int'] | null)
    WEB_PUSH_TOKEN: (Scalars['String'] | null)
    MOBILE_PUSH_TOKEN: (Scalars['String'] | null)
    WEB_PUSH_ENDPOINT: (Scalars['String'] | null)
    WEB_PUSH_P256DH: (Scalars['String'] | null)
    WEB_PUSH_AUTH: (Scalars['String'] | null)
    WEB_PUSH_ACTIVE: (Scalars['Boolean'] | null)
    DEBUG_PARAMS: (AppClientDebugParams | null)
    __typename: 'AppClient'
}

export interface AppClientDebugParams {
    eventsTransport: (Scalars['Json'] | null)
    __typename: 'AppClientDebugParams'
}

export interface Page {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: PageProps
    DATA_CHUNKS: PageDataChunk[]
    CONTENT_CHUNKS: PageContentChunk[]
    __typename: 'Page'
}

export interface Section {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_TYPE_ID: (Scalars['String'] | null)
    IBLOCK_EXTERNAL_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    PICTURE: (Image | null)
    DETAIL_PICTURE: (Image | null)
    DESCRIPTION: (Scalars['String'] | null)
    DESCRIPTION_TYPE: (Scalars['String'] | null)
    LEFT_MARGIN: (Scalars['Int'] | null)
    RIGHT_MARGIN: (Scalars['Int'] | null)
    DEPTH_LEVEL: (Scalars['Int'] | null)
    SEARCHABLE_CONTENT: (Scalars['String'] | null)
    SECTION_PAGE_URL: (Scalars['String'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    PARENT: (Section | null)
    PARENTS: ((Section | null)[] | null)
    ELEMENT_CNT: (Scalars['Int'] | null)
    META: (ElementMeta | null)
    REPLACE_LINK: (Scalars['String'] | null)
    CHILDREN: Section[]
    __typename: 'Section'
}

export interface ElementMeta {
    TITLE: (Scalars['String'] | null)
    KEYWORDS: (Scalars['String'] | null)
    DESCRIPTION: (Scalars['String'] | null)
    PAGE_TITLE: (Scalars['String'] | null)
    __typename: 'ElementMeta'
}

export interface PageProps {
    TPL_PAGE_VIEW: (Scalars['String'] | null)
    TPL_PAGE_CONTENT: (Scalars['String'] | null)
    DATA_CHUNKS: ElementPropValueWithDesc[]
    CHUNKS: PagePropsChunks[]
    CHUNK_NAME: (Scalars['String'] | null)
    CHUNK_VALUE: (ElementPropValueHtml | null)
    CHUNK_CODE: (Scalars['String'] | null)
    CHUNK_GROUP: (Scalars['String'] | null)
    META_TITLE: (Scalars['String'] | null)
    META_DESCRIPTION: (Scalars['String'] | null)
    META_KEYWORDS: (Scalars['String'] | null)
    __typename: 'PageProps'
}

export interface ElementPropValueWithDesc {
    VALUE: (Scalars['String'] | null)
    DESC: (Scalars['String'] | null)
    __typename: 'ElementPropValueWithDesc'
}

export interface PagePropsChunks {
    CHUNK_CODE: (Scalars['String'] | null)
    CHUNK_NAME: (Scalars['String'] | null)
    CHUNK_VALUE: (ElementPropValueHtml | null)
    CHUNK_GROUP: (Scalars['String'] | null)
    UID: (Scalars['String'] | null)
    __typename: 'PagePropsChunks'
}

export interface ElementPropValueHtml {
    TEXT: (Scalars['String'] | null)
    TYPE: (Scalars['String'] | null)
    __typename: 'ElementPropValueHtml'
}

export interface PageDataChunk {
    CODE: (Scalars['String'] | null)
    TYPE: (Scalars['String'] | null)
    VALUE: (Scalars['Json'] | null)
    __typename: 'PageDataChunk'
}

export interface PageContentChunk {
    GROUP: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    VALUE: (Scalars['String'] | null)
    TYPE: (Scalars['String'] | null)
    __typename: 'PageContentChunk'
}

export interface PageRecordset {
    info: QueryInfo
    nodes: Page[]
    __typename: 'PageRecordset'
}

export interface QueryInfo {
    total: (Scalars['Int'] | null)
    page: (Scalars['Int'] | null)
    pages: (Scalars['Int'] | null)
    limit: (Scalars['Int'] | null)
    nextPage: (Scalars['Int'] | null)
    __typename: 'QueryInfo'
}

export interface CompanyOffice {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: CompanyOfficeProps
    __typename: 'CompanyOffice'
}

export interface CompanyOfficeProps {
    MAIN: (Scalars['String'] | null)
    ADDRESS: (Scalars['String'] | null)
    PHONES: Scalars['String'][]
    EMAIL: (Scalars['String'] | null)
    COORDINATES: (Coordinates | null)
    REQUISITES: (ElementPropValueHtml | null)
    ROLES: ListValue[]
    WORKTIME: (Scalars['String'] | null)
    SERVICE_ID: (Scalars['String'] | null)
    PAYSYSTEM_ID: (Scalars['Float'] | null)
    GIS_URL: (Scalars['String'] | null)
    INFO_URL: (Scalars['String'] | null)
    __typename: 'CompanyOfficeProps'
}

export interface Coordinates {
    LON: Scalars['Float']
    LAT: Scalars['Float']
    __typename: 'Coordinates'
}

export interface ListValue {
    ID: Scalars['Int']
    VALUE: Scalars['String']
    CODE: Scalars['String']
    __typename: 'ListValue'
}

export interface OfficeRecordset {
    info: QueryInfo
    nodes: CompanyOffice[]
    __typename: 'OfficeRecordset'
}

export interface CompanyVacancy {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: CompanyVacancyProps
    __typename: 'CompanyVacancy'
}

export interface CompanyVacancyProps {
    PAYMENT: (Scalars['String'] | null)
    RESPONSIBILITES: (ElementPropValueHtml | null)
    WORK_EXPERIENCE: (Scalars['String'] | null)
    __typename: 'CompanyVacancyProps'
}

export interface VacancyRecordset {
    info: QueryInfo
    nodes: CompanyVacancy[]
    __typename: 'VacancyRecordset'
}

export interface FaqQuestion {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    __typename: 'FaqQuestion'
}

export interface FaqQuestionRecordset {
    info: QueryInfo
    nodes: FaqQuestion[]
    __typename: 'FaqQuestionRecordset'
}

export interface GeoObject {
    geo_lat: (Scalars['Float'] | null)
    geo_lon: (Scalars['Float'] | null)
    address_original: (Scalars['String'] | null)
    address_full: (Scalars['String'] | null)
    address_short: (Scalars['String'] | null)
    street_path_full: (Scalars['String'] | null)
    street_path_short: (Scalars['String'] | null)
    region: (Scalars['String'] | null)
    region_format: (Scalars['String'] | null)
    region_original: (Scalars['String'] | null)
    region_fias_id: (Scalars['String'] | null)
    area: (Scalars['String'] | null)
    area_format: (Scalars['String'] | null)
    area_original: (Scalars['String'] | null)
    area_fias_id: (Scalars['String'] | null)
    city: (Scalars['String'] | null)
    city_format: (Scalars['String'] | null)
    city_original: (Scalars['String'] | null)
    city_fias_id: (Scalars['String'] | null)
    district: (Scalars['String'] | null)
    district_format: (Scalars['String'] | null)
    district_original: (Scalars['String'] | null)
    district_fias_id: (Scalars['String'] | null)
    street: (Scalars['String'] | null)
    street_format: (Scalars['String'] | null)
    street_original: (Scalars['String'] | null)
    street_fias_id: (Scalars['String'] | null)
    house: (Scalars['String'] | null)
    house_format: (Scalars['String'] | null)
    house_original: (Scalars['String'] | null)
    house_fias_id: (Scalars['String'] | null)
    __typename: 'GeoObject'
}

export interface SearchSuggestion {
    label: (Scalars['String'] | null)
    value: (Scalars['String'] | null)
    data: (SearchSuggestionData | null)
    __typename: 'SearchSuggestion'
}

export interface SearchSuggestionData {
    type: (Scalars['String'] | null)
    entityTypeName: (Scalars['String'] | null)
    entityTypeCode: (Scalars['String'] | null)
    entityTypeId: (Scalars['String'] | null)
    entityRole: (Scalars['String'] | null)
    entityId: (Scalars['Int'] | null)
    entityTitle: (Scalars['String'] | null)
    hint: (Scalars['String'] | null)
    __typename: 'SearchSuggestionData'
}

export interface Offer {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    VID: (Scalars['String'] | null)
    OFFER_NAME: (Scalars['String'] | null)
    STARTUP_SHOW: (Scalars['String'] | null)
    BANNER_INTERNAL_TEXT: (Scalars['String'] | null)
    BANNER_HOR_MOBILE: (Image | null)
    BANNER_HOR_DESKTOP: (Image | null)
    BANNER_SQUARE: (Image | null)
    DISCOUNT_ID: (Scalars['Int'] | null)
    CONTENT_IMAGE: (Image | null)
    SLIDES: ((OfferSlide | null)[] | null)
    ACTIONS_WEB: MenuItem[]
    ACTIONS_MOBILE: ((MenuItemMobile | null)[] | null)
    IS_HOT: (Scalars['Boolean'] | null)
    VARS: (Scalars['Json'] | null)
    VIEW_MODE: (Scalars['String'] | null)
    STICKY: (Scalars['Boolean'] | null)
    STICKY_TITLE: (Scalars['String'] | null)
    STICKY_ICON: (Scalars['String'] | null)
    FEATURES: (Scalars['String'] | null)[]
    __typename: 'Offer'
}

export interface OfferSlide {
    ID: (Scalars['Int'] | null)
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    CONTENT_TYPE: (Scalars['String'] | null)
    CONTENT_IMAGE: (Image | null)
    CONTENT_HTML: (Scalars['String'] | null)
    BG_COLOR: (Scalars['String'] | null)
    __typename: 'OfferSlide'
}

export interface MenuItemMobile {
    id: (Scalars['String'] | null)
    parent: (Scalars['String'] | null)
    label: (Scalars['String'] | null)
    icon: (Scalars['String'] | null)
    imageId: (Scalars['Int'] | null)
    image: (Image | null)
    color: (Scalars['String'] | null)
    backgroundColor: (Scalars['String'] | null)
    outlineColor: (Scalars['String'] | null)
    outlineWidth: (Scalars['Int'] | null)
    link: (Scalars['Boolean'] | null)
    outline: (Scalars['Boolean'] | null)
    labelColor: (Scalars['String'] | null)
    badge: (Scalars['Json'] | null)
    params: (Scalars['Json'] | null)
    action: (ActionMobile | null)
    condition: (Condition | null)
    templatable: (Scalars['Boolean'] | null)
    templatableProps: ((Scalars['String'] | null)[] | null)
    roles: (Scalars['Json'] | null)
    __typename: 'MenuItemMobile'
}

export interface ActionMobile {
    code: (Scalars['String'] | null)
    url: (Scalars['String'] | null)
    title: (Scalars['String'] | null)
    titleAuto: (Scalars['Boolean'] | null)
    replace: (Scalars['Boolean'] | null)
    addBacklink: (Scalars['Boolean'] | null)
    addSession: (Scalars['Boolean'] | null)
    await: (Scalars['Boolean'] | null)
    __typename: 'ActionMobile'
}

export interface Condition {
    path: (Scalars['String'] | null)
    eq: (Scalars['Json'] | null)
    gt: (Scalars['Json'] | null)
    lt: (Scalars['Json'] | null)
    __typename: 'Condition'
}

export interface OfferRecordset {
    info: QueryInfo
    nodes: Offer[]
    __typename: 'OfferRecordset'
}

export interface PushSubscriber {
    ID: Scalars['Int']
    __typename: 'PushSubscriber'
}

export interface FortunePrize {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: FortunePrizeProps
    PRIZE_TYPE: (PrizeTypeEnum | null)
    BACKGROUND_COLOR: (Scalars['String'] | null)
    TEXT_COLOR: (Scalars['String'] | null)
    TEXT_ORIENTATION: (Scalars['String'] | null)
    PROBABILITY: (Scalars['Int'] | null)
    GIFT_ELEMENT: (Scalars['Int'] | null)
    DISCOUNT_ELEMENT: (Scalars['Int'] | null)
    __typename: 'FortunePrize'
}

export interface FortunePrizeProps {
    BACKGROUND_COLOR: (Scalars['String'] | null)
    TEXT_COLOR: (Scalars['String'] | null)
    TEXT_ORIENTATION: (ListValue | null)
    PROBABILITY: (Scalars['Float'] | null)
    PRIZE_TYPE: (PrizeTypeEnum | null)
    GIFT_ELEMENT_ENTITY: (Element | null)
    GIFT_ELEMENT: (Scalars['Float'] | null)
    DISCOUNT_ELEMENT_ENTITY: (Element | null)
    DISCOUNT_ELEMENT: (Scalars['Float'] | null)
    __typename: 'FortunePrizeProps'
}

export type PrizeTypeEnum = 'gift' | 'discount'

export interface Element {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    __typename: 'Element'
}

export interface FortuneUserPrize {
    ID: Scalars['Int']
    USER_ID: (Scalars['Int'] | null)
    CREATED_AT: (Scalars['Int'] | null)
    PRIZE_ELEMENT_ID_ENTITY: (Element | null)
    PRIZE_ELEMENT_ID: (Scalars['Int'] | null)
    IS_USED: (Scalars['Boolean'] | null)
    __typename: 'FortuneUserPrize'
}

export interface TelegramChat {
    ID: Scalars['Int']
    CHAT_ID: (Scalars['String'] | null)
    TELEGRAM_ID: (Scalars['String'] | null)
    USER_ID: (Scalars['Int'] | null)
    PHONE: (Scalars['String'] | null)
    STATUS: (Scalars['String'] | null)
    CREATED_AT: (Scalars['String'] | null)
    UPDATED_AT: (Scalars['String'] | null)
    LAST_ACTIVITY: (Scalars['String'] | null)
    UID: (Scalars['String'] | null)
    CONTACT_PHONE: (Scalars['String'] | null)
    __typename: 'TelegramChat'
}

export interface TelegramChatRecordset {
    info: QueryInfo
    nodes: TelegramChat[]
    __typename: 'TelegramChatRecordset'
}

export interface Webcam {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: WebcamProps
    __typename: 'Webcam'
}

export interface WebcamProps {
    CODE: (Scalars['String'] | null)
    __typename: 'WebcamProps'
}

export interface Review {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: ReviewProps
    ELEMENT: (Element | null)
    CHILDREN: ((Review | null)[] | null)
    ORDER: (Order | null)
    __typename: 'Review'
}

export interface ReviewProps {
    AUTHOR_USER_ID: (Scalars['String'] | null)
    AUTHOR_NAME: (Scalars['String'] | null)
    RATING: (Scalars['Float'] | null)
    ELEMENT_ID_ENTITY: (Element | null)
    ELEMENT_ID: (Scalars['Float'] | null)
    CONTEXT_ID: (Scalars['Float'] | null)
    ANSWER: (Scalars['String'] | null)
    __typename: 'ReviewProps'
}

export interface Order {
    ID: Scalars['Int']
    TS: (Scalars['String'] | null)
    SYNCED: (Scalars['Boolean'] | null)
    SERVICE_ID: (Scalars['Int'] | null)
    PERSON_TYPE_ID: (Scalars['Int'] | null)
    URL: (Scalars['String'] | null)
    USER_ID: (Scalars['Int'] | null)
    USER: (User | null)
    DATE_INSERT: (Scalars['Json'] | null)
    DATE_UPDATE: (Scalars['Json'] | null)
    DATE_PAYED: (Scalars['Json'] | null)
    DATE_FORMATTED: (Scalars['Json'] | null)
    DATE_TIME_FORMATTED: (Scalars['Json'] | null)
    PRICE: (Scalars['Float'] | null)
    PRICE_BASKET: (Scalars['Float'] | null)
    PRICE_BASKET_BASE: (Scalars['Float'] | null)
    PRICE_DISCOUNT: (Scalars['Float'] | null)
    PRICE_DELIVERY: (Scalars['Float'] | null)
    PRICE_DELIVERY_BASE: (Scalars['Float'] | null)
    PRICE_TOTAL: (Scalars['Float'] | null)
    PRICE_TOTAL_BASE: (Scalars['Float'] | null)
    PRICE_PAY: (Scalars['Float'] | null)
    PRICE_PAY_BASE: (Scalars['Float'] | null)
    DISCOUNT_PERCENT: (Scalars['Float'] | null)
    DISCOUNT_REASON: (Scalars['String'] | null)
    DELIVERY_FREE_FROM_PRICE: (Scalars['Int'] | null)
    DELIVERY_ADDRESS_FULL: (Scalars['String'] | null)
    DELIVERY_DATETIME: (Scalars['Json'] | null)
    DELIVERY_ID: (Scalars['Int'] | null)
    DELIVERY: (DeliveryService | null)
    DELIVERY_CALCULATED: (Scalars['Boolean'] | null)
    DELIVERY_DEPARTMENT: (CompanyOffice | null)
    PICKUP_DEPARTMENT: (CompanyOffice | null)
    PAYSYSTEM_ID: (Scalars['Int'] | null)
    PAYSYSTEM: (Paysystem | null)
    PAYSYSTEM_IS_ONLINE: (Scalars['Boolean'] | null)
    BASKET: BasketItem[]
    STATUS: (OrderStatus | null)
    STATUS_ID: (Scalars['String'] | null)
    STATUS_NAME: (Scalars['String'] | null)
    STATUS_COLOR: (Scalars['String'] | null)
    CSTATUS_ID: (Scalars['String'] | null)
    CSTATUS_NAME: (Scalars['String'] | null)
    CSTATUS_COLOR: (Scalars['String'] | null)
    IS_PAID: (Scalars['Boolean'] | null)
    IS_ACTIVE: (Scalars['Boolean'] | null)
    IS_FINISHED: (Scalars['Boolean'] | null)
    IS_CANCELED: (Scalars['Boolean'] | null)
    IS_CAN_PAY: (Scalars['Boolean'] | null)
    IS_CAN_PAY_ONLINE: (Scalars['Boolean'] | null)
    IS_CAN_PAY_BILL: (Scalars['Boolean'] | null)
    IS_CAN_CANCEL: (Scalars['Boolean'] | null)
    USER_DESCRIPTION: (Scalars['String'] | null)
    ACCESS_HASH: (Scalars['String'] | null)
    SECRET_URL: (Scalars['String'] | null)
    ACCOUNT_NUMBER: (Scalars['String'] | null)
    PAYMENTS: ((Payment | null)[] | null)
    BUYER_NAME: (Scalars['String'] | null)
    CONTRACT_NUM: (Scalars['String'] | null)
    EDU_GROUP_NUM: (Scalars['String'] | null)
    STUDENT_FIO: (Scalars['String'] | null)
    PAY_LINK: (Scalars['String'] | null)
    SCOPE: (OrderScope | null)
    SCOPE_ENTITY: (Command | null)
    ACTIONS: (Scalars['Json'] | null)
    COUPONS: Coupon[]
    BONUSES: (Scalars['Int'] | null)
    COURIER_STATE: (CourierState | null)
    ADDRESS_FOR_1C: (Scalars['String'] | null)
    CANCEL_REASONS: ((OrderCancelReason | null)[] | null)
    ATTR_VALUE: OrderAttributesValue
    ATTR_VIEW: OrderAttributesView
    ATTRS: OrderAttribute[]
    __typename: 'Order'
}

export interface DeliveryService {
    ID: (Scalars['Int'] | null)
    NAME: (Scalars['String'] | null)
    PARENT_ID: (Scalars['Int'] | null)
    TRANSPORT_TYPE: (DeliveryTransportTypeEnum | null)
    __typename: 'DeliveryService'
}

export type DeliveryTransportTypeEnum = 'courier' | 'pickup'

export interface Paysystem {
    ID: (Scalars['Int'] | null)
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    DESCRIPTION: (Scalars['String'] | null)
    IS_INNER: (Scalars['Boolean'] | null)
    IS_ONLINE: (Scalars['Boolean'] | null)
    IS_ONLINE_DELAYED: (Scalars['Boolean'] | null)
    IS_BILL: (Scalars['Boolean'] | null)
    __typename: 'Paysystem'
}

export interface BasketItem {
    ID: Scalars['Int']
    UUID: Scalars['String']
    PARENT_ID: (Scalars['Int'] | null)
    PARENT_UUID: (Scalars['String'] | null)
    ORDER_ID: (Scalars['Int'] | null)
    PRODUCT_ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    DESC: (Scalars['String'] | null)
    QUANTITY: Scalars['Float']
    BASE_PRICE: Scalars['Float']
    PRICE_BASE: Scalars['Float']
    PRICE: Scalars['Float']
    FINAL_PRICE: Scalars['Float']
    FINAL_PRICE_BASE: (Scalars['Float'] | null)
    MEASURE_NAME: (Scalars['String'] | null)
    COMMENT: (Scalars['String'] | null)
    PAID: (Scalars['Boolean'] | null)
    INPUT_PROPS_HASH: (Scalars['String'] | null)
    DISABLE: (Scalars['Boolean'] | null)
    DISABLE_REASON: (Scalars['String'] | null)
    BENEFIT: BasketItemBenefitType
    DISCOUNTS: BasketItemDiscount[]
    CLIENT_CHANGED_AT: Scalars['Int']
    ELEMENT: (Product | null)
    BUILD: ((BasketBuildItem | null)[] | null)
    MODIFICATORS: Scalars['Json']
    PROPERTIES: BasketItemProps
    __typename: 'BasketItem'
}

export type BasketItemBenefitType = 'gift' | 'special'

export interface BasketItemDiscount {
    RULE: (Scalars['String'] | null)
    TARGET: BasketItemDiscountTarget
    TYPE: BasketItemDiscountType
    AMOUNT: Scalars['Float']
    DISCOUNTED_PRICE: Scalars['Float']
    BASE_PRICE: Scalars['Float']
    __typename: 'BasketItemDiscount'
}

export type BasketItemDiscountTarget = 'basket' | 'delivery' | 'total' | 'product' | 'section'

export type BasketItemDiscountType = 'percent' | 'fixed'

export interface Product {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: ProductProps
    PRICE: ProductPrice
    MEASURE: (ProductMeasure | null)
    PARENT: (Product | null)
    OFFERS: ((Product | null)[] | null)
    IS_SALE_SPECIAL: (Scalars['Boolean'] | null)
    SALES_COUNT: (Scalars['Int'] | null)
    HIT_POSITION: (Scalars['Int'] | null)
    HIT_SECTION_POSITION: (Scalars['Int'] | null)
    WEIGHT: (Scalars['Int'] | null)
    OFFER_PARENT_ELEMENT: (Product | null)
    INGREDIENTS: Ingredient[]
    FEATURE_IDS: ((Scalars['Int'] | null)[] | null)
    IMAGE: (Image | null)
    __typename: 'Product'
}

export interface ProductProps {
    WEIGHT: (Scalars['String'] | null)
    KKAL: (Scalars['String'] | null)
    BELKI: (Scalars['String'] | null)
    ZHIRY: (Scalars['String'] | null)
    UGLEVODY: (Scalars['String'] | null)
    ROLLS_ENTITIES: Element[]
    ROLLS: Scalars['Float'][]
    PHOTOV2: (Image | null)
    COMPONENT_IS: (ListValue | null)
    INGREDIENTS_ENTITIES: Element[]
    INGREDIENTS: Scalars['Float'][]
    SERVICE_ID: (Scalars['String'] | null)
    SALE_SPECIAL: (Scalars['Boolean'] | null)
    FLAGS_ENTITIES: Element[]
    FLAGS: Scalars['Float'][]
    SET_ITEMS: ProductPropsSetItems[]
    MODIFICATORS_ENTITIES: Element[]
    MODIFICATORS: Scalars['Float'][]
    FEATURES_ENTITIES: Element[]
    FEATURES: Scalars['Float'][]
    HIT_POSITION: (Scalars['String'] | null)
    HIT_SECTION_POSITION: (Scalars['String'] | null)
    __typename: 'ProductProps'
}

export interface ProductPropsSetItems {
    PRODUCT_ID_ENTITY: (Element | null)
    PRODUCT_ID: (Scalars['Float'] | null)
    QUANTITY: (Scalars['String'] | null)
    UID: (Scalars['String'] | null)
    __typename: 'ProductPropsSetItems'
}

export interface ProductPrice {
    PRICE: Scalars['Float']
    DISCOUNTED: Scalars['Float']
    DISCOUNT_PERCENT: Scalars['Float']
    __typename: 'ProductPrice'
}

export interface ProductMeasure {
    NAME: (Scalars['String'] | null)
    RATIO: (Scalars['Float'] | null)
    __typename: 'ProductMeasure'
}

export interface Ingredient {
    ELEMENT_ID: Scalars['Int']
    IS_REMOVABLE: (Scalars['Boolean'] | null)
    __typename: 'Ingredient'
}

export interface BasketBuildItem {
    PRODUCT_ID: (Scalars['Int'] | null)
    QUANTITY: (Scalars['Int'] | null)
    ELEMENT: (Product | null)
    __typename: 'BasketBuildItem'
}

export interface BasketItemProps {
    CATALOG_XML_ID: (Scalars['String'] | null)
    PRODUCT_XML_ID: (Scalars['String'] | null)
    PARENT_UUID: (Scalars['String'] | null)
    IS_GIFT: (Scalars['String'] | null)
    REASON_MOD_CODE: (Scalars['String'] | null)
    REASON_MOD_ID: (Scalars['Int'] | null)
    REASON_RULE_CODE: (Scalars['String'] | null)
    REASON_RULE_ID: (Scalars['Int'] | null)
    INGREDIENTS_REMOVED: (Scalars['Int'] | null)[]
    INGREDIENTS_ADDED: (Scalars['Int'] | null)[]
    __typename: 'BasketItemProps'
}

export interface OrderStatus {
    ID: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    COLOR: (Scalars['String'] | null)
    TYPE: (Scalars['String'] | null)
    __typename: 'OrderStatus'
}

export interface Payment {
    ID: (Scalars['Int'] | null)
    PAYSYSTEM_ID: (Scalars['Int'] | null)
    PAYSYSTEM: (Paysystem | null)
    IS_PAID: (Scalars['Boolean'] | null)
    SUM: (Scalars['Float'] | null)
    SUM_PAID: (Scalars['Float'] | null)
    PAY_NAV: (Scalars['Json'] | null)
    PS_STATUS: (Scalars['String'] | null)
    PS_STATUS_CODE: (Scalars['String'] | null)
    PS_STATUS_ID: (Scalars['String'] | null)
    PS_STATUS_NAME: (Scalars['String'] | null)
    PS_INVOICE_ID: (Scalars['String'] | null)
    ORDER_ID: (Scalars['String'] | null)
    ORDER_URL: (Scalars['String'] | null)
    DATE_PAID: (Scalars['Json'] | null)
    __typename: 'Payment'
}

export interface OrderScope {
    CONTRACT_NUM: (Scalars['String'] | null)
    ENTITY_TYPE: (Scalars['String'] | null)
    ENTITY_ID: (Scalars['Int'] | null)
    __typename: 'OrderScope'
}

export interface Coupon {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    COUPON: (Scalars['String'] | null)
    PRODUCT_ID: (Scalars['Int'] | null)
    PRODUCT: (Product | null)
    __typename: 'Coupon'
}

export interface CourierState {
    COORDS: (Scalars['Json'] | null)
    ARRIVAL_TIME_CAPTION: (Scalars['String'] | null)
    ARRIVAL_TIME: (Scalars['String'] | null)
    CAR_COLOR: (Scalars['String'] | null)
    CAR_NUMBER: (Scalars['String'] | null)
    __typename: 'CourierState'
}

export interface OrderCancelReason {
    CODE: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    __typename: 'OrderCancelReason'
}

export interface OrderAttributesValue {
    DETAILS: (Scalars['Boolean'] | null)
    UUID: (Scalars['String'] | null)
    FIO: (Scalars['String'] | null)
    PHONE: (Scalars['String'] | null)
    EMAIL: (Scalars['String'] | null)
    DELIVERY_TYPE: (Scalars['Json'] | null)
    DELIVERY_DEPARTMENT: (Scalars['Int'] | null)
    STREET_PATH: (Scalars['String'] | null)
    CITY: (Scalars['String'] | null)
    CITY_FIAS_ID: (Scalars['String'] | null)
    SETTLEMENT: (Scalars['String'] | null)
    SETTLEMENT_FIAS_ID: (Scalars['String'] | null)
    STREET_FIAS_ID: (Scalars['String'] | null)
    STREET_COORDS: (Coordinates | null)
    HOUSE: (Scalars['String'] | null)
    HOUSE_FIAS_ID: (Scalars['String'] | null)
    HOUSE_COORDS: (Coordinates | null)
    FLAT: (Scalars['String'] | null)
    LOCATION: (Scalars['String'] | null)
    INTERCOM: (Scalars['String'] | null)
    FLOOR: (Scalars['String'] | null)
    ENTRANCE: (Scalars['String'] | null)
    PRIVATE_HOUSE: (Scalars['Boolean'] | null)
    LIFT: (Scalars['Boolean'] | null)
    PICKUP_DEPARTMENT: (Scalars['Json'] | null)
    TIME_MODE: (AttrTimeModeEnum | null)
    DATE: (Scalars['String'] | null)
    TIME: (Scalars['Json'] | null)
    PAYMENT_TYPE: (AttrPaymentTypeEnum | null)
    CASH_SUM: (Scalars['Int'] | null)
    BONUSES: (Scalars['String'] | null)
    PROMOCODE: (Scalars['String'] | null)
    DELIVERY_PRICE: (Scalars['Int'] | null)
    RECEIVER_NAME: (Scalars['String'] | null)
    RECEIVER_ANOTHER: (Scalars['Boolean'] | null)
    RECEIVER_PHONE: (Scalars['String'] | null)
    PERSONS_NUMBER: (Scalars['Int'] | null)
    COMMENT: (Scalars['String'] | null)
    GIFTS_LIST: (Scalars['String'] | null)
    WITH_OPERATOR: (Scalars['Boolean'] | null)
    ROISTAT: (Scalars['String'] | null)
    NEED_CONFIRM: (Scalars['Boolean'] | null)
    PROFILE_COMMENT: (Scalars['String'] | null)
    ADDRESS_SOURCE: (Scalars['String'] | null)
    PROFILE_ID: (Scalars['Int'] | null)
    ADDRESS_IS_CUSTOM: (Scalars['Boolean'] | null)
    PROFILE_DEFAULT: (Scalars['Boolean'] | null)
    VORDER_ID: (Scalars['Int'] | null)
    SERVICE_SEND: (Scalars['Boolean'] | null)
    DATETIME: (Scalars['Int'] | null)
    SERVICE_SEND_START: (Scalars['Int'] | null)
    DATA: (OrderData | null)
    RESERVE_SUCCESS_HASH: (Scalars['String'] | null)
    DISCOUNT_REASON: (Scalars['String'] | null)
    DISCOUNT_PERCENT: (Scalars['Int'] | null)
    ADDRESS: (Scalars['String'] | null)
    BENEFIT_TYPE: (BenefitTypeEnum | null)
    DELIVERY_FREE_FROM_PRICE: (Scalars['String'] | null)
    STREET: (Scalars['String'] | null)
    DEPARTMENT_SERVICE_ID: (Scalars['Int'] | null)
    DELIVERY_FREE_UPDATED_TIME: (Scalars['Int'] | null)
    IS_ACCEPTED: (Scalars['Boolean'] | null)
    TEST_TIME: (Scalars['Int'] | null)
    STRUCT: (Scalars['Json'] | null)
    TRANSPORT_TYPE: (AttrTransportTypeEnum | null)
    COUPON_ID: (Scalars['Int'] | null)
    PRIZE_ID: (Scalars['Int'] | null)
    SESSION_ID: (Scalars['String'] | null)
    PAYMENT_GIFT: (Scalars['String'] | null)
    TEST_TIME_NEW: (Scalars['Int'] | null)
    APP_VERSION: (Scalars['String'] | null)
    SOURCE: (Scalars['String'] | null)
    RESERVE_REQUEST_TIME: (Scalars['Int'] | null)
    UTM_SOURCE: (Scalars['String'] | null)
    RESERVE_AVAILABLE_TIME: (Scalars['Int'] | null)
    RESERVE_NEED_TIME: (Scalars['Int'] | null)
    RESERVE_STATUS: (Scalars['String'] | null)
    RESERVE_SUCCESS_REQUEST_TIME: (Scalars['Int'] | null)
    UTM_MEDIUM: (Scalars['String'] | null)
    UTM_CAMPAIGN: (Scalars['String'] | null)
    UTM_TERM: (Scalars['String'] | null)
    UTM_CONTENT: (Scalars['String'] | null)
    UTM_LANDING_URL: (Scalars['String'] | null)
    DELIVERY_ID: (Scalars['Int'] | null)
    PAY_SYSTEM_ID: (Scalars['Int'] | null)
    USER_DESCRIPTION: (Scalars['String'] | null)
    __typename: 'OrderAttributesValue'
}

export type AttrTimeModeEnum = 'nearest' | 'custom'

export type AttrPaymentTypeEnum = 'cash' | 'card' | 'online'

export interface OrderData {
    paramInt: (Scalars['Int'] | null)
    paramString: (Scalars['String'] | null)
    paramArray: (Scalars['Json'] | null)
    __typename: 'OrderData'
}

export type BenefitTypeEnum = 'prize' | 'discount' | 'bonus' | 'coupon' | 'gift'

export type AttrTransportTypeEnum = 'courier' | 'pickup'

export interface OrderAttributesView {
    DETAILS: (Scalars['String'] | null)
    UUID: (Scalars['String'] | null)
    FIO: (Scalars['String'] | null)
    PHONE: (Scalars['String'] | null)
    EMAIL: (Scalars['String'] | null)
    DELIVERY_TYPE: (Scalars['String'] | null)
    DELIVERY_DEPARTMENT: (Scalars['String'] | null)
    STREET_PATH: (Scalars['String'] | null)
    CITY: (Scalars['String'] | null)
    CITY_FIAS_ID: (Scalars['String'] | null)
    SETTLEMENT: (Scalars['String'] | null)
    SETTLEMENT_FIAS_ID: (Scalars['String'] | null)
    STREET_FIAS_ID: (Scalars['String'] | null)
    STREET_COORDS: (Scalars['String'] | null)
    HOUSE: (Scalars['String'] | null)
    HOUSE_FIAS_ID: (Scalars['String'] | null)
    HOUSE_COORDS: (Scalars['String'] | null)
    FLAT: (Scalars['String'] | null)
    LOCATION: (Scalars['String'] | null)
    INTERCOM: (Scalars['String'] | null)
    FLOOR: (Scalars['String'] | null)
    ENTRANCE: (Scalars['String'] | null)
    PRIVATE_HOUSE: (Scalars['String'] | null)
    LIFT: (Scalars['String'] | null)
    PICKUP_DEPARTMENT: (Scalars['String'] | null)
    TIME_MODE: (Scalars['String'] | null)
    DATE: (Scalars['String'] | null)
    TIME: (Scalars['String'] | null)
    PAYMENT_TYPE: (Scalars['String'] | null)
    CASH_SUM: (Scalars['String'] | null)
    BONUSES: (Scalars['String'] | null)
    PROMOCODE: (Scalars['String'] | null)
    DELIVERY_PRICE: (Scalars['String'] | null)
    RECEIVER_NAME: (Scalars['String'] | null)
    RECEIVER_ANOTHER: (Scalars['String'] | null)
    RECEIVER_PHONE: (Scalars['String'] | null)
    PERSONS_NUMBER: (Scalars['String'] | null)
    COMMENT: (Scalars['String'] | null)
    GIFTS_LIST: (Scalars['String'] | null)
    WITH_OPERATOR: (Scalars['String'] | null)
    ROISTAT: (Scalars['String'] | null)
    NEED_CONFIRM: (Scalars['String'] | null)
    PROFILE_COMMENT: (Scalars['String'] | null)
    ADDRESS_SOURCE: (Scalars['String'] | null)
    PROFILE_ID: (Scalars['String'] | null)
    ADDRESS_IS_CUSTOM: (Scalars['String'] | null)
    PROFILE_DEFAULT: (Scalars['String'] | null)
    VORDER_ID: (Scalars['String'] | null)
    SERVICE_SEND: (Scalars['String'] | null)
    DATETIME: (Scalars['String'] | null)
    SERVICE_SEND_START: (Scalars['String'] | null)
    DATA: (Scalars['String'] | null)
    RESERVE_SUCCESS_HASH: (Scalars['String'] | null)
    DISCOUNT_REASON: (Scalars['String'] | null)
    DISCOUNT_PERCENT: (Scalars['String'] | null)
    ADDRESS: (Scalars['String'] | null)
    BENEFIT_TYPE: (Scalars['String'] | null)
    DELIVERY_FREE_FROM_PRICE: (Scalars['String'] | null)
    STREET: (Scalars['String'] | null)
    DEPARTMENT_SERVICE_ID: (Scalars['String'] | null)
    DELIVERY_FREE_UPDATED_TIME: (Scalars['String'] | null)
    IS_ACCEPTED: (Scalars['String'] | null)
    TEST_TIME: (Scalars['String'] | null)
    STRUCT: (Scalars['String'] | null)
    TRANSPORT_TYPE: (Scalars['String'] | null)
    COUPON_ID: (Scalars['String'] | null)
    PRIZE_ID: (Scalars['String'] | null)
    SESSION_ID: (Scalars['String'] | null)
    PAYMENT_GIFT: (Scalars['String'] | null)
    TEST_TIME_NEW: (Scalars['String'] | null)
    APP_VERSION: (Scalars['String'] | null)
    SOURCE: (Scalars['String'] | null)
    RESERVE_REQUEST_TIME: (Scalars['String'] | null)
    UTM_SOURCE: (Scalars['String'] | null)
    RESERVE_AVAILABLE_TIME: (Scalars['String'] | null)
    RESERVE_NEED_TIME: (Scalars['String'] | null)
    RESERVE_STATUS: (Scalars['String'] | null)
    RESERVE_SUCCESS_REQUEST_TIME: (Scalars['String'] | null)
    UTM_MEDIUM: (Scalars['String'] | null)
    UTM_CAMPAIGN: (Scalars['String'] | null)
    UTM_TERM: (Scalars['String'] | null)
    UTM_CONTENT: (Scalars['String'] | null)
    UTM_LANDING_URL: (Scalars['String'] | null)
    DELIVERY_ID: (Scalars['String'] | null)
    PAY_SYSTEM_ID: (Scalars['String'] | null)
    USER_DESCRIPTION: (Scalars['String'] | null)
    __typename: 'OrderAttributesView'
}

export interface OrderAttribute {
    KIND: OrderAttributeKindEnum
    TYPE: OrderAttributeTypeEnum
    CODE: OrderAttributeCodeEnum
    NAME: (Scalars['String'] | null)
    DEFAULT_VALUE: (Scalars['Json'] | null)
    VALUE: (Scalars['Json'] | null)
    VALUE_VIEW: (Scalars['Json'] | null)
    OPTIONS: ((OrderAttributeOption | null)[] | null)
    __typename: 'OrderAttribute'
}

export type OrderAttributeKindEnum = 'prop' | 'field'

export type OrderAttributeTypeEnum = 'boolean' | 'string' | 'enum' | 'number' | 'location' | 'json' | 'date'

export type OrderAttributeCodeEnum = 'DETAILS' | 'UUID' | 'FIO' | 'PHONE' | 'EMAIL' | 'DELIVERY_TYPE' | 'DELIVERY_DEPARTMENT' | 'STREET_PATH' | 'CITY' | 'CITY_FIAS_ID' | 'SETTLEMENT' | 'SETTLEMENT_FIAS_ID' | 'STREET_FIAS_ID' | 'STREET_COORDS' | 'HOUSE' | 'HOUSE_FIAS_ID' | 'HOUSE_COORDS' | 'FLAT' | 'LOCATION' | 'INTERCOM' | 'FLOOR' | 'ENTRANCE' | 'PRIVATE_HOUSE' | 'LIFT' | 'PICKUP_DEPARTMENT' | 'TIME_MODE' | 'DATE' | 'TIME' | 'PAYMENT_TYPE' | 'CASH_SUM' | 'BONUSES' | 'PROMOCODE' | 'DELIVERY_PRICE' | 'RECEIVER_NAME' | 'RECEIVER_ANOTHER' | 'RECEIVER_PHONE' | 'PERSONS_NUMBER' | 'COMMENT' | 'GIFTS_LIST' | 'WITH_OPERATOR' | 'ROISTAT' | 'NEED_CONFIRM' | 'PROFILE_COMMENT' | 'ADDRESS_SOURCE' | 'PROFILE_ID' | 'ADDRESS_IS_CUSTOM' | 'PROFILE_DEFAULT' | 'VORDER_ID' | 'SERVICE_SEND' | 'DATETIME' | 'SERVICE_SEND_START' | 'DATA' | 'RESERVE_SUCCESS_HASH' | 'DISCOUNT_REASON' | 'DISCOUNT_PERCENT' | 'ADDRESS' | 'BENEFIT_TYPE' | 'DELIVERY_FREE_FROM_PRICE' | 'STREET' | 'DEPARTMENT_SERVICE_ID' | 'DELIVERY_FREE_UPDATED_TIME' | 'IS_ACCEPTED' | 'TEST_TIME' | 'STRUCT' | 'TRANSPORT_TYPE' | 'COUPON_ID' | 'PRIZE_ID' | 'SESSION_ID' | 'PAYMENT_GIFT' | 'TEST_TIME_NEW' | 'APP_VERSION' | 'SOURCE' | 'RESERVE_REQUEST_TIME' | 'UTM_SOURCE' | 'RESERVE_AVAILABLE_TIME' | 'RESERVE_NEED_TIME' | 'RESERVE_STATUS' | 'RESERVE_SUCCESS_REQUEST_TIME' | 'UTM_MEDIUM' | 'UTM_CAMPAIGN' | 'UTM_TERM' | 'UTM_CONTENT' | 'UTM_LANDING_URL' | 'DELIVERY_ID' | 'PAY_SYSTEM_ID' | 'USER_DESCRIPTION'

export interface OrderAttributeOption {
    ID: (Scalars['Int'] | null)
    VALUE: (Scalars['Json'] | null)
    NAME: (Scalars['String'] | null)
    NAME_SHORT: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    DESCRIPTION: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    ICON: (Scalars['String'] | null)
    DISABLE: (Scalars['Boolean'] | null)
    __typename: 'OrderAttributeOption'
}

export interface AppProductRecordset {
    info: QueryInfo
    nodes: Product[]
    __typename: 'AppProductRecordset'
}

export interface SearchResult {
    ELEMENTS: Product[]
    SECTIONS: Section[]
    __typename: 'SearchResult'
}

export interface VorderCurrent {
    TS: (Scalars['String'] | null)
    DELIVERY_PRICE_RULES: DeliveryPriceRule[]
    BONUSES_AVAILABLE: (Scalars['Int'] | null)
    BONUSES_PERCENT: (Scalars['Int'] | null)
    PERSON_TYPES: PersonType[]
    PAYMENT_TYPES: PaymentType[]
    PROFILES: (OrderProfile | null)[]
    DEPARTMENTS: (CompanyOffice | null)[]
    DISCOUNTS: Discount[]
    DELIVERIES: DeliveryComputed[]
    TRANSPORT_TYPES: TransportType[]
    DELIVERY_CALCULATED: (Scalars['Boolean'] | null)
    DELIVERY_FREE_FROM_PRICE: (Scalars['Float'] | null)
    COUPON_CAN_ADD: (Scalars['Boolean'] | null)
    RESPONSE_STATE: (ResponseState | null)
    BASKET_RULES: BasketRule[]
    ID: Scalars['Int']
    SESSION_ID: (Scalars['String'] | null)
    FUSER_ID: (Scalars['Int'] | null)
    USER_ID: (Scalars['Int'] | null)
    USER: (User | null)
    ORDER_ID: (Scalars['Int'] | null)
    FIELDS_RAW: (Scalars['Json'] | null)
    PROPS_RAW: (Scalars['Json'] | null)
    PHONE: (Scalars['String'] | null)
    EMAIL: (Scalars['String'] | null)
    ORDER: (Order | null)
    PROFILE_ID: (Scalars['Int'] | null)
    DELIVERY_DEPARTMENT_ID: (Scalars['Int'] | null)
    PICKUP_DEPARTMENT_ID: (Scalars['Int'] | null)
    DEPARTMENT_ID: (Scalars['Int'] | null)
    BONUSES: (Scalars['Int'] | null)
    COUPONS: Coupon[]
    BASKET: (Basket | null)
    ATTR: OrderAttributesValue
    ATTRS: OrderAttribute[]
    __typename: 'VorderCurrent'
}

export interface DeliveryPriceRule {
    DATE: (Scalars['String'] | null)
    PRICE: (Scalars['Int'] | null)
    __typename: 'DeliveryPriceRule'
}

export interface PersonType {
    ID: (Scalars['Int'] | null)
    NAME: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    CODE: (Scalars['String'] | null)
    RESTRICTED: (Scalars['Boolean'] | null)
    IS_COMPANY: (Scalars['Boolean'] | null)
    __typename: 'PersonType'
}

export interface PaymentType {
    CODE: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    ICON: (Scalars['String'] | null)
    __typename: 'PaymentType'
}

export interface OrderProfile {
    ID: Scalars['Int']
    NAME: Scalars['String']
    CAPTION: (Scalars['String'] | null)
    USER_ID: Scalars['Int']
    USER: (User | null)
    PERSON_TYPE_ID: Scalars['Int']
    PERSON_TYPE: (PersonType | null)
    COMPANY_ID: (Scalars['Int'] | null)
    IS_DEFAULT: (Scalars['Boolean'] | null)
    COORDS: (Coordinates | null)
    DELIVERY_FREE_FROM_PRICE: Scalars['Int']
    ATTR: OrderProfileAttributesValue
    ATTRS: OrderAttribute[]
    __typename: 'OrderProfile'
}

export interface OrderProfileAttributesValue {
    STREET_PATH: (Scalars['String'] | null)
    CITY: (Scalars['String'] | null)
    CITY_FIAS_ID: (Scalars['String'] | null)
    SETTLEMENT: (Scalars['String'] | null)
    SETTLEMENT_FIAS_ID: (Scalars['String'] | null)
    STREET_FIAS_ID: (Scalars['String'] | null)
    STREET_COORDS: (Coordinates | null)
    HOUSE: (Scalars['String'] | null)
    HOUSE_FIAS_ID: (Scalars['String'] | null)
    HOUSE_COORDS: (Coordinates | null)
    FLAT: (Scalars['String'] | null)
    FLOOR: (Scalars['String'] | null)
    ENTRANCE: (Scalars['String'] | null)
    PRIVATE_HOUSE: (Scalars['Boolean'] | null)
    LIFT: (Scalars['Boolean'] | null)
    RECEIVER_NAME: (Scalars['String'] | null)
    RECEIVER_ANOTHER: (Scalars['Boolean'] | null)
    RECEIVER_PHONE: (Scalars['String'] | null)
    PROFILE_COMMENT: (Scalars['String'] | null)
    ADDRESS_SOURCE: (Scalars['String'] | null)
    ADDRESS_IS_CUSTOM: (Scalars['Boolean'] | null)
    PROFILE_DEFAULT: (Scalars['Boolean'] | null)
    ADDRESS: (Scalars['String'] | null)
    STREET: (Scalars['String'] | null)
    __typename: 'OrderProfileAttributesValue'
}

export interface Discount {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: DiscountProps
    CONDITION: OrderCondition
    DISCOUNT_PERCENT: (Scalars['Int'] | null)
    DISCOUNT_TARGET: DiscountTargetEnum
    __typename: 'Discount'
}

export interface DiscountProps {
    TRANSPORT_TYPE: DeliveryTransportTypeEnum[]
    PAYMENT_TYPE: PaymentTypeEnum[]
    PRODUCT_ENTITIES: Element[]
    PRODUCT: Scalars['Float'][]
    PRODUCT_SECTION: Scalars['String'][]
    ORDER_PRICE_FROM: (Scalars['Float'] | null)
    NAME_TEMPLATE: (Scalars['String'] | null)
    HOTEST: (Scalars['Boolean'] | null)
    DISCOUNT_PERCENT: (Scalars['Float'] | null)
    DELIVERY_DISCOUNT: (Scalars['Boolean'] | null)
    PRIZE_ENTITY: (Element | null)
    PRIZE: (Scalars['Float'] | null)
    DISCOUNT_TARGET: (DiscountTargetEnum | null)
    BENEFIT_TYPE: BenefitTypeEnum[]
    __typename: 'DiscountProps'
}

export type PaymentTypeEnum = 'cash' | 'card' | 'online'

export type DiscountTargetEnum = 'product' | 'basket' | 'delivery' | 'total'

export interface OrderCondition {
    BENEFIT_TYPE: BenefitTypeEnum[]
    PAYMENT_TYPE: PaymentTypeEnum[]
    TRANSPORT_TYPE: DeliveryTransportTypeEnum[]
    PRODUCT_SECTION: (Scalars['Int'] | null)[]
    PRODUCT: (Scalars['Int'] | null)[]
    OFFICE_ROLE: OfficeRoleEnum[]
    OFFICE: (Scalars['Int'] | null)[]
    ORDER_PRICE_FROM: (Scalars['Int'] | null)
    COUPON: (Scalars['Int'] | null)
    PRIZE: (Scalars['Int'] | null)
    __typename: 'OrderCondition'
}

export type OfficeRoleEnum = 'delivery' | 'pickup' | 'bar'

export interface DeliveryComputed {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    SERVICE: (DeliveryWrapper | null)
    CALC_TIMESTAMP: (Scalars['Int'] | null)
    PRICE: (Scalars['Float'] | null)
    PRICE_FORMATED: (Scalars['String'] | null)
    DELIVERY_DISCOUNT_PRICE: (Scalars['String'] | null)
    DELIVERY_DISCOUNT_PRICE_FORMATED: (Scalars['String'] | null)
    PERIOD_TEXT: (Scalars['String'] | null)
    CALCULATE_ERRORS: (Scalars['Json'] | null)
    CALCULATE_DESCRIPTION: (Scalars['Json'] | null)
    __typename: 'DeliveryComputed'
}

export interface DeliveryWrapper {
    ID: (Scalars['Int'] | null)
    NAME: (Scalars['String'] | null)
    TRANSPORT_TYPE: (DeliveryTransportTypeEnum | null)
    HOST: (DeliveryService | null)
    __typename: 'DeliveryWrapper'
}

export interface TransportType {
    CODE: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    ICON: (Scalars['String'] | null)
    DISCOUNT: (Scalars['String'] | null)
    __typename: 'TransportType'
}

export interface ResponseState {
    messages: Message[]
    events: (Scalars['Json'] | null)
    rate: (ResponseRate | null)
    redirect: (ResponseRedirect | null)
    __typename: 'ResponseState'
}

export interface Message {
    id: (Scalars['String'] | null)
    type: (MessageTypeEnum | null)
    code: (Scalars['String'] | null)
    name: (Scalars['String'] | null)
    status: (Scalars['String'] | null)
    title: (Scalars['String'] | null)
    message: (Scalars['String'] | null)
    messages: ((Scalars['String'] | null)[] | null)
    category: (Scalars['String'] | null)
    notify: (Scalars['Boolean'] | null)
    rel: (Scalars['String'] | null)
    duration: (Scalars['Int'] | null)
    data: (Scalars['Json'] | null)
    actions: MenuItem[]
    __typename: 'Message'
}

export type MessageTypeEnum = 'success' | 'error' | 'info' | 'warning'

export interface ResponseRate {
    ttl: (Scalars['Int'] | null)
    limited: (Scalars['Boolean'] | null)
    __typename: 'ResponseRate'
}

export interface ResponseRedirect {
    ttl: (Scalars['Int'] | null)
    restricted: (Scalars['Boolean'] | null)
    __typename: 'ResponseRedirect'
}

export interface BasketRule {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: BasketRuleProps
    TYPE: (BasketRuleTypeEnum | null)
    NAME_TEMPLATE: (Scalars['String'] | null)
    ALL_STOP: (Scalars['Boolean'] | null)
    IS_ADDITIONAL: (Scalars['Boolean'] | null)
    CONDITION: OrderCondition
    BENEFITS: BasketRuleBenefitInterface[]
    PROMO: (Scalars['Boolean'] | null)
    __typename: 'BasketRule'
}

export interface BasketRuleProps {
    TYPE: (BasketRuleBenefitTypeEnum | null)
    CAPTION: (Scalars['String'] | null)
    NAME_TEMPLATE: (Scalars['String'] | null)
    IS_ADDITIONAL: (Scalars['Boolean'] | null)
    ALL_STOP: (Scalars['Boolean'] | null)
    CONDITION_PAYMENT_TYPE: PaymentTypeEnum[]
    CONDITION_TRANSPORT_TYPE: DeliveryTransportTypeEnum[]
    CONDITION_ORDER_PRICE_FROM: (Scalars['Float'] | null)
    CONDITION_PRODUCT_SECTION: Scalars['String'][]
    CONDITION_PRODUCT_ENTITIES: Element[]
    CONDITION_PRODUCT: Scalars['Float'][]
    CONDITION_OFFICE_ENTITIES: Element[]
    CONDITION_OFFICE: Scalars['Float'][]
    CONDITION_OFFICE_ROLE: OfferRoleEnum[]
    CONDITION_BENEFIT_TYPE: BenefitTypeEnum[]
    CONDITION_COUPON_ENTITY: (Element | null)
    CONDITION_COUPON: (Scalars['Float'] | null)
    CONDITION_PRIZE_ENTITY: (Element | null)
    CONDITION_PRIZE: (Scalars['Float'] | null)
    BENEFITS: BasketRulePropsBenefits[]
    DISCOUNT_PERCENT: (Scalars['Float'] | null)
    BENEFITS_PRODUCT_ID_ENTITIES: Element[]
    PRODUCT_ID: (Scalars['Float'] | null)
    __typename: 'BasketRuleProps'
}

export type OfferRoleEnum = 'banner' | 'sticker'

export interface BasketRulePropsBenefits {
    TYPE: (BasketRuleBenefitTypeEnum | null)
    DISCOUNT_PERCENT: (Scalars['Float'] | null)
    PRODUCT_ID: (Scalars['Float'] | null)
    UID: (Scalars['String'] | null)
    __typename: 'BasketRulePropsBenefits'
}

export type BasketRuleTypeEnum = 'discount' | 'gift' | 'common' | 'special'

export interface Basket {
    TS: (Scalars['String'] | null)
    SYNCED: (Scalars['Boolean'] | null)
    BASE_PRICE: (Scalars['Float'] | null)
    PRICE: (Scalars['Float'] | null)
    COUNT: (Scalars['Int'] | null)
    QUANTITY: (Scalars['Float'] | null)
    ITEMS: BasketItem[]
    WEIGHT: (Scalars['Float'] | null)
    MIN_PRICE: (Scalars['Float'] | null)
    MIN_PRICE_REACHED: (Scalars['Boolean'] | null)
    HASH: (Scalars['String'] | null)
    OFFERS: ((SpecialOffer | null)[] | null)
    GIFTS: (Scalars['Int'] | null)[]
    CLIENT_CHANGED_AT: Scalars['Int']
    __typename: 'Basket'
}

export interface SpecialOffer {
    MIN_PRICE: (Scalars['Int'] | null)
    MODE: (Scalars['String'] | null)
    ELEMENT_ID: (Scalars['Int'] | null)
    ELEMENT: (Product | null)
    TYPE: (Scalars['String'] | null)
    TYPE_INFO: (SpecialOfferType | null)
    __typename: 'SpecialOffer'
}

export interface SpecialOfferType {
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    COLOR: (Scalars['String'] | null)
    __typename: 'SpecialOfferType'
}

export interface VorderSummary {
    ID: (Scalars['Int'] | null)
    PHONE: (Scalars['String'] | null)
    EMAIL: (Scalars['String'] | null)
    FUSER_ID: (Scalars['Int'] | null)
    __typename: 'VorderSummary'
}

export interface OrderProfileRecordset {
    info: QueryInfo
    nodes: OrderProfile[]
    __typename: 'OrderProfileRecordset'
}

export interface SaleClientCard {
    ID: Scalars['Int']
    BONUSES: (Scalars['Int'] | null)
    FETCHED: (Scalars['Boolean'] | null)
    FETCHED_TIME_FORMATTED: (Scalars['String'] | null)
    FETCHED_TIME: (Scalars['Int'] | null)
    USER_ID: (Scalars['Int'] | null)
    CLIENT_PHONE: (Scalars['String'] | null)
    LEVEL_CODE: (Scalars['String'] | null)
    LEVEL_NAME: (Scalars['String'] | null)
    MONTH_SPENT: (Scalars['Float'] | null)
    BONUSES_EXPIRE_FORMATTED: (Scalars['String'] | null)
    BONUSES_EXPIRE: (Scalars['Int'] | null)
    BONUSES_PERCENT: (Scalars['Float'] | null)
    DIS_FIRST_ORDER: (Scalars['Float'] | null)
    DIS_SELF_PICKUP: (Scalars['Float'] | null)
    LEVEL: (BonusLevel | null)
    DISCOUNTS: Discount[]
    FETCHED_ACTUAL: (Scalars['Boolean'] | null)
    EXPIRED: (Scalars['Boolean'] | null)
    __typename: 'SaleClientCard'
}

export interface BonusLevel {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: BonusLevelProps
    __typename: 'BonusLevel'
}

export interface BonusLevelProps {
    ORDERS_SUMM: (Scalars['String'] | null)
    ACCUMULATION_PERCENT: (Scalars['Float'] | null)
    MAX_USE_PERCENT: (Scalars['Float'] | null)
    COLOR: (Scalars['String'] | null)
    MONTH_SPENT_MIN: (Scalars['Float'] | null)
    MONTH_SPENT_MAX: (Scalars['Float'] | null)
    __typename: 'BonusLevelProps'
}

export interface ClientCardRecordset {
    info: QueryInfo
    nodes: SaleClientCard[]
    __typename: 'ClientCardRecordset'
}

export interface DeliveryZone {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['Json'] | null)
    PROPERTIES: DeliveryZoneProps
    __typename: 'DeliveryZone'
}

export interface DeliveryZoneProps {
    PRICE_TEXT: (Scalars['String'] | null)
    PRICE_BY_DELIVERY: (Scalars['Float'] | null)
    PRICE_BY_KM: (Scalars['Float'] | null)
    FREE_TEXT: (Scalars['String'] | null)
    FREE_FROM_PRICE: (Scalars['Float'] | null)
    GEOJSON: (Scalars['Json'] | null)
    OUTSIDE: (Scalars['Boolean'] | null)
    COLOR: (Scalars['String'] | null)
    __typename: 'DeliveryZoneProps'
}

export interface ProductIngredient {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    URL: (Scalars['String'] | null)
    PROPERTIES: ProductIngredientProps
    __typename: 'ProductIngredient'
}

export interface ProductIngredientProps {
    SHOW_IN_FILTER: (Scalars['Boolean'] | null)
    ALIASES: (Scalars['String'] | null)
    __typename: 'ProductIngredientProps'
}

export interface Modificator {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    PREVIEW_PICTURE: (Image | null)
    SECTION: (ModificatorSection | null)
    TYPE: (ModificatorTypeEnum | null)
    LIMIT: Scalars['Int']
    QUANTITY_LIMIT: Scalars['Int']
    REQUIRED: (Scalars['Boolean'] | null)
    IS_GLOBAL: Scalars['Boolean']
    ORDER_PRICE_FROM: (Scalars['Float'] | null)
    CONDITION: OrderCondition
    PRODUCT_COMPONENT: (Scalars['String'] | null)
    PRODUCT_COMPONENT_PROPS: Scalars['Json']
    PRODUCT_COMPONENT_STYLE: Scalars['Json']
    OPTIONS: ModificatorOption[]
    CODE_PATH: Scalars['String']
    ID_PATH: Scalars['String']
    DEFAULT_VALUE: (Scalars['Json'] | null)
    GROUP_CODE: Scalars['String']
    POSITIONS: Scalars['String'][]
    OPTION_INFO_TYPE: (ProductModificatorOptionInfoTypeEnum | null)
    FEATURES: (Scalars['Int'] | null)[]
    PROPERTIES: ModificatorProps
    __typename: 'Modificator'
}

export interface ModificatorSection {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_TYPE_ID: (Scalars['String'] | null)
    IBLOCK_EXTERNAL_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    PICTURE: (Image | null)
    DETAIL_PICTURE: (Image | null)
    DESCRIPTION: (Scalars['String'] | null)
    DESCRIPTION_TYPE: (Scalars['String'] | null)
    LEFT_MARGIN: (Scalars['Int'] | null)
    RIGHT_MARGIN: (Scalars['Int'] | null)
    DEPTH_LEVEL: (Scalars['Int'] | null)
    SEARCHABLE_CONTENT: (Scalars['String'] | null)
    SECTION_PAGE_URL: (Scalars['String'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    PARENT: (ModificatorSection | null)
    PARENTS: ((ModificatorSection | null)[] | null)
    ELEMENT_CNT: (Scalars['Int'] | null)
    META: (ElementMeta | null)
    REPLACE_LINK: (Scalars['String'] | null)
    CHILDREN: Section[]
    PROPERTIES: ModificatorSectionProps
    __typename: 'ModificatorSection'
}

export interface ModificatorSectionProps {
    LIMIT: (Scalars['Float'] | null)
    TYPE: (ModificatorTypeEnum | null)
    REQUIRED: (Scalars['Boolean'] | null)
    QUANTITY_LIMIT: (Scalars['Int'] | null)
    PRODUCT_COMPONENT: (Scalars['String'] | null)
    PRODUCT_COM_PROPS: (Scalars['String'] | null)
    IS_GROUP: (Scalars['Boolean'] | null)
    PRODUCT_COM_STYLE: (Scalars['String'] | null)
    CARD_POS: (ProductModificatorCardPositionEnum | null)
    OPTION_INFO_TYPE: (ProductModificatorOptionInfoTypeEnum | null)
    __typename: 'ModificatorSectionProps'
}

export type ModificatorTypeEnum = 'gift' | 'special' | 'additive' | 'constructor' | 'feature'

export type ProductModificatorCardPositionEnum = 'media' | 'title' | 'sale'

export type ProductModificatorOptionInfoTypeEnum = 'product'

export interface ModificatorOption {
    UID: Scalars['String']
    NAME: (Scalars['String'] | null)
    PRODUCT_ID: (Scalars['Int'] | null)
    QUANTITY: (Scalars['Int'] | null)
    QUANTITY_LIMIT: (Scalars['Int'] | null)
    IMAGE: (Image | null)
    DEFAULT: (Scalars['Boolean'] | null)
    __typename: 'ModificatorOption'
}

export interface ModificatorProps {
    OVERRIDE_PARENT: (Scalars['Boolean'] | null)
    TYPE: (ModificatorTypeEnum | null)
    REQUIRED: (LogicEnum | null)
    LIMIT: (Scalars['Float'] | null)
    QUANTITY_LIMIT: (Scalars['Float'] | null)
    PRODUCT_COMPONENT: (Scalars['String'] | null)
    PRODUCT_COMPONENT_PROPS: (Scalars['String'] | null)
    PRODUCT_COMPONENT_STYLE: (Scalars['String'] | null)
    CARD_POSITION: (ProductModificatorCardPositionEnum | null)
    DETAIL_POSITION: (ProductModificatorDetailPositionEnum | null)
    PRODUCTS: ModificatorPropsProducts[]
    PRODUCTS_PRODUCT_ID_ENTITIES: Element[]
    PRODUCT_ID: (Scalars['Float'] | null)
    QUANTITY: (Scalars['Float'] | null)
    UID: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    IMAGE: (Image | null)
    DEFAULT: (Scalars['Boolean'] | null)
    __typename: 'ModificatorProps'
}

export type LogicEnum = 'Y' | 'N'

export type ProductModificatorDetailPositionEnum = 'media' | 'title' | 'sale'

export interface ModificatorPropsProducts {
    PRODUCT_ID: (Scalars['Float'] | null)
    QUANTITY: (Scalars['Float'] | null)
    QUANTITY_LIMIT: (Scalars['Float'] | null)
    UID: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    IMAGE: (Image | null)
    DEFAULT: (Scalars['Boolean'] | null)
    __typename: 'ModificatorPropsProducts'
}

export interface ProductFlag {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    URL: (Scalars['String'] | null)
    PROPERTIES: ProductFlagProps
    __typename: 'ProductFlag'
}

export interface ProductFlagProps {
    NAME_SHORT: (Scalars['String'] | null)
    TEXT_COLOR: (Scalars['String'] | null)
    BG_COLOR: (Scalars['String'] | null)
    IMAGE: (Image | null)
    ICON: (Scalars['String'] | null)
    CLASS: (Scalars['String'] | null)
    __typename: 'ProductFlagProps'
}

export interface OrderRestriction {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: OrderRestrictionProps
    SCHEDULE: (Scalars['Json'] | null)
    SCHEDULE_DESC: (Scalars['String'] | null)
    SCHEDULE_ACTIVE: (Scalars['Boolean'] | null)
    CONDITION: OrderCondition
    ITEM_ERROR_NAME: (Scalars['String'] | null)
    ITEM_MESSAGE: (Scalars['String'] | null)
    MESSAGE: (Scalars['String'] | null)
    __typename: 'OrderRestriction'
}

export interface OrderRestrictionProps {
    TRANSPORT_TYPE: DeliveryTransportTypeEnum[]
    OFFICE_ROLE: OfficeRoleEnum[]
    OFFICE_ENTITIES: Element[]
    OFFICE: Scalars['Float'][]
    PAYMENT_TYPE: PaymentTypeEnum[]
    PRODUCT_ENTITIES: Element[]
    PRODUCT: Scalars['Float'][]
    PRODUCT_SECTION: Scalars['String'][]
    MESSAGE: (Scalars['String'] | null)
    ITEM_MESSAGE: (Scalars['String'] | null)
    SCHEDULE: (Scalars['Json'] | null)
    ITEM_ERROR_NAME: (ErrorNameEnum | null)
    SECTION: (VOrderSectionEnum | null)
    __typename: 'OrderRestrictionProps'
}

export interface ProductSection {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_TYPE_ID: (Scalars['String'] | null)
    IBLOCK_EXTERNAL_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    PICTURE: (Image | null)
    DETAIL_PICTURE: (Image | null)
    DESCRIPTION: (Scalars['String'] | null)
    DESCRIPTION_TYPE: (Scalars['String'] | null)
    LEFT_MARGIN: (Scalars['Int'] | null)
    RIGHT_MARGIN: (Scalars['Int'] | null)
    DEPTH_LEVEL: (Scalars['Int'] | null)
    SEARCHABLE_CONTENT: (Scalars['String'] | null)
    SECTION_PAGE_URL: (Scalars['String'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    PARENT: (ProductSection | null)
    PARENTS: ((ProductSection | null)[] | null)
    ELEMENT_CNT: (Scalars['Int'] | null)
    META: (ElementMeta | null)
    REPLACE_LINK: (Scalars['String'] | null)
    CHILDREN: Section[]
    PROPERTIES: ProductSectionProps
    FEATURE_IDS: ((Scalars['Int'] | null)[] | null)
    __typename: 'ProductSection'
}

export interface ProductSectionProps {
    MENU_BG_COLOR: (Scalars['String'] | null)
    TITLE_IRKUTSK: (Scalars['String'] | null)
    DESCR_IRKUTSK: (Scalars['String'] | null)
    H1_IRKUTSK: (Scalars['String'] | null)
    TITLE_ANGARSK: (Scalars['String'] | null)
    DESCR_ANGARSK: (Scalars['String'] | null)
    H1_ANGARSK: (Scalars['String'] | null)
    TITLE_KRASNOYARSK: (Scalars['String'] | null)
    DESCR_KRASNOYARSK: (Scalars['String'] | null)
    H1_KRASNOYARSK: (Scalars['String'] | null)
    NAV_URL: Scalars['String'][]
    NAV_TITLE: Scalars['String'][]
    HINT: (Scalars['String'] | null)
    CATEGORY_CLASS: (Scalars['String'] | null)
    SEARCH_IN: (Scalars['String'] | null)
    REPLACE_LINK: (Scalars['String'] | null)
    M_CARD: (Scalars['String'] | null)
    MENU_ICON: (Image | null)
    MENU_FOCUSED_ICON: (Image | null)
    MENU_ITEM_STYLE: (ButtonStyleEnum | null)
    MENU_COLOR: (Scalars['String'] | null)
    UPSALE_SECTIONS: Scalars['Int'][]
    MODIFICATORS_ENTITY: Modificator[]
    MODIFICATORS: Scalars['Int'][]
    __typename: 'ProductSectionProps'
}

export type ButtonStyleEnum = 'flat' | 'filled' | 'outline'

export interface ClientSegment {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    __typename: 'ClientSegment'
}

export interface ClientSegmentRecordset {
    info: QueryInfo
    nodes: ClientSegment[]
    __typename: 'ClientSegmentRecordset'
}

export interface Feature {
    ACTIVE: (Scalars['Boolean'] | null)
    AVAILABLE: AvailableStatus
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: FeatureProps
    __typename: 'Feature'
}

export interface AvailableStatus {
    STATUS: (Scalars['Boolean'] | null)
    REASON: (Scalars['String'] | null)
    __typename: 'AvailableStatus'
}

export interface FeatureProps {
    MODEL_CLASS: (Scalars['String'] | null)
    SEGMENTS_ENTITIES: Element[]
    SEGMENTS: Scalars['Float'][]
    SCHEDULE_ENABLE: (Scalars['Boolean'] | null)
    SCHEDULE: (Scalars['Json'] | null)
    __typename: 'FeatureProps'
}

export interface FeatureRecordset {
    info: QueryInfo
    nodes: Feature[]
    __typename: 'FeatureRecordset'
}

export interface CallTrackingPhone {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    PROPERTIES: CallTrackingPhoneProps
    PHONE_NUMBER: (Scalars['String'] | null)
    IS_DEFAULT: (Scalars['Boolean'] | null)
    IS_RESERVED: (Scalars['Boolean'] | null)
    __typename: 'CallTrackingPhone'
}

export interface CallTrackingPhoneProps {
    PHONE_NUMBER: (Scalars['String'] | null)
    CLIENT_ID: (Scalars['String'] | null)
    USER_ID: (Scalars['Float'] | null)
    RESERVED_AT: (Scalars['Int'] | null)
    IS_DEFAULT: (Scalars['Boolean'] | null)
    __typename: 'CallTrackingPhoneProps'
}

export interface YandexMetricGoal {
    ID: Scalars['Int']
    NAME: (Scalars['String'] | null)
    CODE: (Scalars['String'] | null)
    SORT: (Scalars['Int'] | null)
    IBLOCK_ID: (Scalars['Int'] | null)
    IBLOCK_CODE: (Scalars['String'] | null)
    IBLOCK_SECTION_ID: (Scalars['Int'] | null)
    ACTIVE: (Scalars['Boolean'] | null)
    ACTIVE_FROM: (Scalars['Json'] | null)
    ACTIVE_TO: (Scalars['Json'] | null)
    TIMESTAMP_X: (Scalars['Json'] | null)
    DATE_CREATE: (Scalars['Json'] | null)
    CREATED_BY: (Scalars['Int'] | null)
    CREATED_USER_NAME: (Scalars['String'] | null)
    MODIFIED_BY: (Scalars['Int'] | null)
    PREVIEW_PICTURE: (Image | null)
    PREVIEW_TEXT: (Scalars['String'] | null)
    PREVIEW_TEXT_TYPE: (Scalars['String'] | null)
    DETAIL_PICTURE: (Image | null)
    DETAIL_TEXT: (Scalars['String'] | null)
    DETAIL_TEXT_TYPE: (Scalars['String'] | null)
    SHOW_COUNTER: (Scalars['Int'] | null)
    SHOW_COUNTER_START: (Scalars['Json'] | null)
    TAGS: (Scalars['String'] | null)
    XML_ID: (Scalars['String'] | null)
    EXTERNAL_ID: (Scalars['String'] | null)
    SECTION_ID: (Scalars['Int'] | null)
    IBLOCK_SECTION_IDS: Scalars['Int'][]
    URL: (Scalars['String'] | null)
    PATH: ((Section | null)[] | null)
    SECTIONS: ((Section | null)[] | null)
    SECTION: (Section | null)
    ROOT_SECTION: (Section | null)
    META: (ElementMeta | null)
    __typename: 'YandexMetricGoal'
}

export interface YandexMetricGoalRecordset {
    info: QueryInfo
    nodes: YandexMetricGoal[]
    __typename: 'YandexMetricGoalRecordset'
}

export interface Mutation {
    testMutationcreate: (TestmutationcreateResult | null)
    testMutationupdate: (TestmutationupdateResult | null)
    testMutationdelete: Response
    hook_mutation: Response
    notice_pub_sync_readed: (NoticePubSyncReadedResult | null)
    notice_pub_push_send_queue: Response
    notice_pub_push_update_token: Response
    user_auth_create_sa: Response
    user_auth_login_start: (UserAuthLoginStartResult | null)
    user_auth_login_request: (UserAuthLoginRequestResult | null)
    user_auth_login_confirm: (UserAuthLoginConfirmResult | null)
    user_app_client: Response
    user_profile_save: Response
    user_logout: Response
    user_profile_name: (UserProfileNameResult | null)
    user_profile_birthday: (UserProfileBirthdayResult | null)
    user_profile_email: (UserProfileEmailResult | null)
    company_office_update: (CompanyOfficeUpdateResult | null)
    company_vacancy_order: Response
    push_subscribe: (PushSubscribeResult | null)
    push_unsubscribe: (PushUnsubscribeResult | null)
    push_send_test: (PushSendTestResult | null)
    fortune_spin: (FortuneSpinResult | null)
    telegram_create: (TelegramCreateResult | null)
    telegram_update: (TelegramUpdateResult | null)
    telegram_delete: Response
    telegram_auth_by_phone: (TelegramAuthByPhoneResult | null)
    review_service_review: (ReviewServiceReviewResult | null)
    review_order_guest_review: (ReviewOrderGuestReviewResult | null)
    catalog_product_order: Response
    sale_order_test: (SaleOrderTestResult | null)
    sale_order_pay_online: (SaleOrderPayOnlineResult | null)
    sale_order_repeat: (SaleOrderRepeatResult | null)
    sale_order_cancel: (SaleOrderCancelResult | null)
    vorder_new: (VorderNewResult | null)
    vorder_apply: (VorderApplyResult | null)
    vorder_basket: (VorderBasketResult | null)
    vorder_delivery_calculate: (VorderDeliveryCalculateResult | null)
    vorder_coupon: (VorderCouponResult | null)
    vorder_submit: (VorderSubmitResult | null)
    vorder_sync: (VorderSyncResult | null)
    sale_profile_default: (SaleProfileDefaultResult | null)
    sale_profile_delete: (SaleProfileDeleteResult | null)
    sale_profile_save: (SaleProfileSaveResult | null)
    sale_profile_calc_delivery: (SaleProfileCalcDeliveryResult | null)
    sale_client_card_create: (SaleClientCardCreateResult | null)
    sale_client_card_update: (SaleClientCardUpdateResult | null)
    sale_client_card_delete: Response
    call_tracking_request_phone: (CallTrackingRequestPhoneResult | null)
    __typename: 'Mutation'
}

export interface TestmutationcreateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (TestItem | null)
    __typename: 'TestmutationcreateResult'
}

export interface TestmutationupdateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (TestItem | null)
    __typename: 'TestmutationupdateResult'
}

export interface Response {
    success: (Scalars['Boolean'] | null)
    state: ResponseState
    payload: (Scalars['Json'] | null)
    error: (ErrorInterface | null)
    errors: ErrorInterface[]
    __typename: 'Response'
}

export interface NoticePubSyncReadedResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: ((ClientNotice | null)[] | null)
    __typename: 'NoticePubSyncReadedResult'
}

export interface UserAuthLoginStartResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (UserAuthLoginStartResultPayload | null)
    __typename: 'UserAuthLoginStartResult'
}

export interface UserAuthLoginStartResultPayload {
    confirmModes: UserAuthConfirm[]
    discounts: Discount[]
    __typename: 'UserAuthLoginStartResultPayload'
}

export interface UserAuthConfirm {
    NAME: Scalars['String']
    CODE: Scalars['String']
    COLOR: (Scalars['String'] | null)
    ICON: (Scalars['String'] | null)
    LIST_NAME: (Scalars['String'] | null)
    LIST_CAPTION: (Scalars['String'] | null)
    LIST_BUTTON_MOBILE: (MenuItemMobile | null)
    LIST_BUTTON_WEB: (MenuItem | null)
    CONFIRM_CONTENT_MOBILE: (Scalars['String'] | null)
    CONFIRM_CONTENT_WEB: (Scalars['String'] | null)
    CONFIRM_STEPS: ((UserAuthConfirmStep | null)[] | null)
    RESEND_TITLE: (Scalars['String'] | null)
    __typename: 'UserAuthConfirm'
}

export interface UserAuthConfirmStep {
    CODE: (Scalars['String'] | null)
    NAME: (Scalars['String'] | null)
    CAPTION: (Scalars['String'] | null)
    __typename: 'UserAuthConfirmStep'
}

export interface UserAuthLoginRequestResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (UserAuthLoginRequestResultPayload | null)
    __typename: 'UserAuthLoginRequestResult'
}

export interface UserAuthLoginRequestResultPayload {
    rateTtl: (Scalars['Int'] | null)
    __typename: 'UserAuthLoginRequestResultPayload'
}

export interface UserAuthLoginConfirmResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (UserAuthLoginConfirmResultPayload | null)
    __typename: 'UserAuthLoginConfirmResult'
}

export interface UserAuthLoginConfirmResultPayload {
    appClient: (AppClient | null)
    sessionId: (Scalars['String'] | null)
    userId: (Scalars['Int'] | null)
    redirect: (Scalars['Json'] | null)
    isNew: (Scalars['Boolean'] | null)
    __typename: 'UserAuthLoginConfirmResultPayload'
}

export interface UserProfileNameResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (User | null)
    __typename: 'UserProfileNameResult'
}

export interface UserProfileBirthdayResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (User | null)
    __typename: 'UserProfileBirthdayResult'
}

export interface UserProfileEmailResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (User | null)
    __typename: 'UserProfileEmailResult'
}

export interface CompanyOfficeUpdateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (CompanyOffice | null)
    __typename: 'CompanyOfficeUpdateResult'
}

export interface PushSubscribeResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (PushSubscribeResultPayload | null)
    __typename: 'PushSubscribeResult'
}

export interface PushSubscribeResultPayload {
    appClient: (AppClient | null)
    __typename: 'PushSubscribeResultPayload'
}

export interface PushUnsubscribeResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (PushUnsubscribeResultPayload | null)
    __typename: 'PushUnsubscribeResult'
}

export interface PushUnsubscribeResultPayload {
    appClient: (AppClient | null)
    __typename: 'PushUnsubscribeResultPayload'
}

export interface PushSendTestResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (PushSendTestResultPayload | null)
    __typename: 'PushSendTestResult'
}

export interface PushSendTestResultPayload {
    success: (Scalars['Boolean'] | null)
    sent: (Scalars['Int'] | null)
    failed: (Scalars['Int'] | null)
    __typename: 'PushSendTestResultPayload'
}

export interface FortuneSpinResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (FortuneSpinResultPayload | null)
    __typename: 'FortuneSpinResult'
}

export interface FortuneSpinResultPayload {
    userPrize: (FortuneUserPrize | null)
    __typename: 'FortuneSpinResultPayload'
}

export interface TelegramCreateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (TelegramChat | null)
    __typename: 'TelegramCreateResult'
}

export interface TelegramUpdateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (TelegramChat | null)
    __typename: 'TelegramUpdateResult'
}

export interface TelegramAuthByPhoneResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (TelegramAuthByPhoneResultPayload | null)
    __typename: 'TelegramAuthByPhoneResult'
}

export interface TelegramAuthByPhoneResultPayload {
    userId: (Scalars['Int'] | null)
    userName: (Scalars['String'] | null)
    phone: (Scalars['String'] | null)
    token: (Scalars['String'] | null)
    chatId: (Scalars['String'] | null)
    __typename: 'TelegramAuthByPhoneResultPayload'
}

export interface ReviewServiceReviewResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (Review | null)
    __typename: 'ReviewServiceReviewResult'
}

export interface ReviewOrderGuestReviewResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (ReviewOrderGuestReviewResultPayload | null)
    __typename: 'ReviewOrderGuestReviewResult'
}

export interface ReviewOrderGuestReviewResultPayload {
    redirectUrl: (Scalars['String'] | null)
    departmentId: (Scalars['Int'] | null)
    departmentName: (Scalars['String'] | null)
    __typename: 'ReviewOrderGuestReviewResultPayload'
}

export interface SaleOrderTestResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (SaleOrderTestResultPayload | null)
    __typename: 'SaleOrderTestResult'
}

export interface SaleOrderTestResultPayload {
    num: (Scalars['Int'] | null)
    __typename: 'SaleOrderTestResultPayload'
}

export interface SaleOrderPayOnlineResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (SaleOrderPayOnlineResultPayload | null)
    __typename: 'SaleOrderPayOnlineResult'
}

export interface SaleOrderPayOnlineResultPayload {
    paymentUrl: (Scalars['String'] | null)
    price: (Scalars['Int'] | null)
    order: (Order | null)
    __typename: 'SaleOrderPayOnlineResultPayload'
}

export interface SaleOrderRepeatResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (Order | null)
    __typename: 'SaleOrderRepeatResult'
}

export interface SaleOrderCancelResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (Order[] | null)
    __typename: 'SaleOrderCancelResult'
}

export interface VorderNewResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderNewResultPayload | null)
    __typename: 'VorderNewResult'
}

export interface VorderNewResultPayload {
    vorder: (Vorder | null)
    __typename: 'VorderNewResultPayload'
}

export interface Vorder {
    ID: Scalars['Int']
    SESSION_ID: (Scalars['String'] | null)
    FUSER_ID: (Scalars['Int'] | null)
    USER_ID: (Scalars['Int'] | null)
    USER: (User | null)
    ORDER_ID: (Scalars['Int'] | null)
    FIELDS_RAW: (Scalars['Json'] | null)
    PROPS_RAW: (Scalars['Json'] | null)
    PHONE: (Scalars['String'] | null)
    EMAIL: (Scalars['String'] | null)
    ORDER: (Order | null)
    PROFILE_ID: (Scalars['Int'] | null)
    DELIVERY_DEPARTMENT_ID: (Scalars['Int'] | null)
    PICKUP_DEPARTMENT_ID: (Scalars['Int'] | null)
    DEPARTMENT_ID: (Scalars['Int'] | null)
    BONUSES: (Scalars['Int'] | null)
    COUPONS: Coupon[]
    BASKET: (Basket | null)
    ATTR: OrderAttributesValue
    ATTRS: OrderAttribute[]
    __typename: 'Vorder'
}

export interface VorderApplyResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderApplyResultPayload | null)
    __typename: 'VorderApplyResult'
}

export interface VorderApplyResultPayload {
    vorder: (Vorder | null)
    __typename: 'VorderApplyResultPayload'
}

export interface VorderBasketResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderBasketResultPayload | null)
    __typename: 'VorderBasketResult'
}

export interface VorderBasketResultPayload {
    vorder: (Vorder | null)
    __typename: 'VorderBasketResultPayload'
}

export type TimeModeEnum = 'nearest' | 'custom'

export interface VorderDeliveryCalculateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderDeliveryCalculateResultPayload | null)
    __typename: 'VorderDeliveryCalculateResult'
}

export interface VorderDeliveryCalculateResultPayload {
    vorder: (VorderCurrent | null)
    calc: (DeliveryCalculate | null)
    __typename: 'VorderDeliveryCalculateResultPayload'
}

export interface DeliveryCalculate {
    ID: Scalars['Int']
    VORDER_ID: (Scalars['Int'] | null)
    REQUEST_DELTA: (Scalars['Int'] | null)
    DELIVERY_HASH: (Scalars['String'] | null)
    ORDER_ID: (Scalars['Float'] | null)
    DELIVERY_ADDRESS: (Scalars['String'] | null)
    REQUEST_TIME_FORMATTED: (Scalars['String'] | null)
    REQUEST_TIME: (Scalars['Int'] | null)
    NEED_TIME_FORMATTED: (Scalars['String'] | null)
    NEED_TIME: (Scalars['Int'] | null)
    ORDER_PRICE: (Scalars['Int'] | null)
    RES_DELIVER_PRICE: (Scalars['Float'] | null)
    RES_TIME_FORMATTED: (Scalars['String'] | null)
    RES_TIME: (Scalars['Int'] | null)
    RES_OFFICE_1C_ID: (Scalars['Int'] | null)
    RES_OFFICE_ID: (Scalars['Int'] | null)
    ADDRESS_COORDS: (Scalars['String'] | null)
    PHONE: (Scalars['String'] | null)
    RES_STATUS: (DeliveryCalcStatusEnum | null)
    TRANSPORT_TYPE: (Scalars['String'] | null)
    TIME_MODE: (TimeModeEnum | null)
    __typename: 'DeliveryCalculate'
}

export type DeliveryCalcStatusEnum = 'success' | 'time_busy' | 'service_unavailable' | 'address_not_found'

export interface VorderCouponResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderCouponResultPayload | null)
    __typename: 'VorderCouponResult'
}

export interface VorderCouponResultPayload {
    vorder: (VorderCurrent | null)
    coupon: (Coupon | null)
    __typename: 'VorderCouponResultPayload'
}

export interface VorderSubmitResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderSubmitResultPayload | null)
    __typename: 'VorderSubmitResult'
}

export interface VorderSubmitResultPayload {
    vorder: (VorderCurrent | null)
    newVorderId: (Scalars['Int'] | null)
    orderId: (Scalars['Int'] | null)
    orderUrl: (Scalars['String'] | null)
    order: (Order | null)
    activeOrders: Order[]
    __typename: 'VorderSubmitResultPayload'
}

export interface VorderSyncResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (VorderSyncResultPayload | null)
    __typename: 'VorderSyncResult'
}

export interface VorderSyncResultPayload {
    vorder: (Vorder | null)
    __typename: 'VorderSyncResultPayload'
}

export interface SaleProfileDefaultResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (OrderProfile | null)
    __typename: 'SaleProfileDefaultResult'
}

export interface SaleProfileDeleteResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (Scalars['Int'] | null)
    __typename: 'SaleProfileDeleteResult'
}

export interface SaleProfileSaveResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (OrderProfile | null)
    __typename: 'SaleProfileSaveResult'
}

export interface SaleProfileCalcDeliveryResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (DeliveryCalculate | null)
    __typename: 'SaleProfileCalcDeliveryResult'
}

export interface SaleClientCardCreateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (SaleClientCard | null)
    __typename: 'SaleClientCardCreateResult'
}

export interface SaleClientCardUpdateResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (SaleClientCard | null)
    __typename: 'SaleClientCardUpdateResult'
}

export interface CallTrackingRequestPhoneResult {
    success: (Scalars['Boolean'] | null)
    errors: ErrorInterface[]
    error: (ErrorInterface | null)
    state: ResponseState
    payload: (CallTrackingRequestPhoneResultPayload | null)
    __typename: 'CallTrackingRequestPhoneResult'
}

export interface CallTrackingRequestPhoneResultPayload {
    phone: (CallTrackingPhone | null)
    __typename: 'CallTrackingRequestPhoneResultPayload'
}

export interface CommonErrorGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ErrorInterfaceGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    on_CommonError?: CommonErrorGenqlSelection
    on_RateError?: RateErrorGenqlSelection
    on_OtpError?: OtpErrorGenqlSelection
    on_AccessError?: AccessErrorGenqlSelection
    on_FormError?: FormErrorGenqlSelection
    on_ExternalServiceError?: ExternalServiceErrorGenqlSelection
    on_ProtocolError?: ProtocolErrorGenqlSelection
    on_InternalError?: InternalErrorGenqlSelection
    on_UserError?: UserErrorGenqlSelection
    on_VorderError?: VorderErrorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface RateErrorGenqlSelection{
    ttl?: boolean | number
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OtpErrorGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface AccessErrorGenqlSelection{
    authRedirect?: boolean | number
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FormErrorGenqlSelection{
    fieldName?: boolean | number
    fieldLabel?: boolean | number
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ExternalServiceErrorGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProtocolErrorGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface InternalErrorGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserErrorGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketRuleBenefitDiscountGenqlSelection{
    UID?: boolean | number
    TYPE?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketRuleBenefitInterfaceGenqlSelection{
    UID?: boolean | number
    TYPE?: boolean | number
    on_BasketRuleBenefitDiscount?: BasketRuleBenefitDiscountGenqlSelection
    on_BasketRuleBenefitGift?: BasketRuleBenefitGiftGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketRuleBenefitGiftGenqlSelection{
    UID?: boolean | number
    TYPE?: boolean | number
    PRODUCT_ID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderErrorGenqlSelection{
    itemUuid?: boolean | number
    fieldName?: boolean | number
    fieldLabel?: boolean | number
    section?: boolean | number
    type?: boolean | number
    name?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    alertShow?: boolean | number
    alertMessage?: boolean | number
    alertDuration?: boolean | number
    targetShow?: boolean | number
    targetMessage?: boolean | number
    debug?: boolean | number
    rel?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface QueryGenqlSelection{
    testPublicpublic?: (TestItemGenqlSelection & { __args?: QueryTestPublicpublicArgs })
    testOptionalAuthlist?: (TestItemGenqlSelection & { __args?: QueryTestOptionalAuthlistArgs })
    testRequiredAuthauthorized?: (TestItemGenqlSelection & { __args?: QueryTestRequiredAuthauthorizedArgs })
    testAdminOnlyadminOnly?: (TestItemGenqlSelection & { __args?: QueryTestAdminOnlyadminOnlyArgs })
    testCombinedadminOnly?: (TestItemGenqlSelection & { __args?: QueryTestCombinedadminOnlyArgs })
    testCombinedlist?: (TestItemGenqlSelection & { __args?: QueryTestCombinedlistArgs })
    hook_query?: boolean | number
    entity_options?: (EntityOptionGenqlSelection & { __args: QueryEntityOptionsArgs })
    entity_type_list?: (EntityTypeGenqlSelection & { __args?: QueryEntityTypeListArgs })
    entity_type?: (EntityTypeGenqlSelection & { __args?: QueryEntityTypeArgs })
    entity_provider_types?: EntityProviderTypeGenqlSelection
    entity_computed_fields?: EntityComputedFieldGenqlSelection
    menu_menus?: MenuGenqlSelection
    list?: ClientEmitGenqlSelection
    notice_pub_list?: ClientNoticeGenqlSelection
    user_session?: UserSessionGenqlSelection
    user_fetch?: (UserGenqlSelection & { __args?: QueryUserFetchArgs })
    user_app_client?: AppClientGenqlSelection
    page_single?: (PageGenqlSelection & { __args?: QueryPageSingleArgs })
    page_list?: (PageGenqlSelection & { __args?: QueryPageListArgs })
    page_recordset?: (PageRecordsetGenqlSelection & { __args?: QueryPageRecordsetArgs })
    page_route?: (PageGenqlSelection & { __args?: QueryPageRouteArgs })
    company_office_single?: (CompanyOfficeGenqlSelection & { __args?: QueryCompanyOfficeSingleArgs })
    company_office_list?: (CompanyOfficeGenqlSelection & { __args?: QueryCompanyOfficeListArgs })
    company_office_recordset?: (OfficeRecordsetGenqlSelection & { __args?: QueryCompanyOfficeRecordsetArgs })
    company_vacancy_single?: (CompanyVacancyGenqlSelection & { __args?: QueryCompanyVacancySingleArgs })
    company_vacancy_list?: (CompanyVacancyGenqlSelection & { __args?: QueryCompanyVacancyListArgs })
    company_vacancy_recordset?: (VacancyRecordsetGenqlSelection & { __args?: QueryCompanyVacancyRecordsetArgs })
    faq_element_single?: (FaqQuestionGenqlSelection & { __args?: QueryFaqElementSingleArgs })
    faq_element_list?: (FaqQuestionGenqlSelection & { __args?: QueryFaqElementListArgs })
    faq_element_recordset?: (FaqQuestionRecordsetGenqlSelection & { __args?: QueryFaqElementRecordsetArgs })
    geo_geocoder_locations_by_coords?: (GeoObjectGenqlSelection & { __args?: QueryGeoGeocoderLocationsByCoordsArgs })
    geo_geocoder_location_by_address?: (GeoObjectGenqlSelection & { __args?: QueryGeoGeocoderLocationByAddressArgs })
    search_suggestions_popular?: SearchSuggestionGenqlSelection
    search_suggestions?: (SearchSuggestionGenqlSelection & { __args?: QuerySearchSuggestionsArgs })
    offer_single?: (OfferGenqlSelection & { __args?: QueryOfferSingleArgs })
    offer_list?: (OfferGenqlSelection & { __args?: QueryOfferListArgs })
    offer_recordset?: (OfferRecordsetGenqlSelection & { __args?: QueryOfferRecordsetArgs })
    offer_user_list?: OfferGenqlSelection
    offer_common_list?: OfferGenqlSelection
    push_vapid_public_key?: boolean | number
    push_user_subscribers?: PushSubscriberGenqlSelection
    fortune_prizes?: FortunePrizeGenqlSelection
    fortune_user_prize?: FortuneUserPrizeGenqlSelection
    telegram_single?: (TelegramChatGenqlSelection & { __args?: QueryTelegramSingleArgs })
    telegram_list?: (TelegramChatGenqlSelection & { __args?: QueryTelegramListArgs })
    telegram_recordset?: (TelegramChatRecordsetGenqlSelection & { __args?: QueryTelegramRecordsetArgs })
    telegram_chat_by_id?: (TelegramChatGenqlSelection & { __args: QueryTelegramChatByIdArgs })
    telegram_active_chats?: (TelegramChatGenqlSelection & { __args?: QueryTelegramActiveChatsArgs })
    camera_element_list?: (WebcamGenqlSelection & { __args?: QueryCameraElementListArgs })
    review_list?: (ReviewGenqlSelection & { __args?: QueryReviewListArgs })
    catalog_product_single?: (ProductGenqlSelection & { __args?: QueryCatalogProductSingleArgs })
    catalog_product_list?: (ProductGenqlSelection & { __args?: QueryCatalogProductListArgs })
    catalog_product_recordset?: (AppProductRecordsetGenqlSelection & { __args?: QueryCatalogProductRecordsetArgs })
    catalog_product_all?: (ProductGenqlSelection & { __args?: QueryCatalogProductAllArgs })
    catalog_product_fav_list?: (ProductGenqlSelection & { __args?: QueryCatalogProductFavListArgs })
    catalog_product_fav_list2?: (ProductGenqlSelection & { __args?: QueryCatalogProductFavList2Args })
    catalog_product_search?: (SearchResultGenqlSelection & { __args?: QueryCatalogProductSearchArgs })
    catalog_product_search_new?: (ProductGenqlSelection & { __args?: QueryCatalogProductSearchNewArgs })
    sale_order_active_list?: (OrderGenqlSelection & { __args?: QuerySaleOrderActiveListArgs })
    sale_order_ensure_payment?: (PaymentGenqlSelection & { __args?: QuerySaleOrderEnsurePaymentArgs })
    vorder_current?: (VorderCurrentGenqlSelection & { __args?: QueryVorderCurrentArgs })
    vorder_summary?: VorderSummaryGenqlSelection
    vorder_basket_products?: ProductGenqlSelection
    sale_profile_single?: (OrderProfileGenqlSelection & { __args?: QuerySaleProfileSingleArgs })
    sale_profile_list?: (OrderProfileGenqlSelection & { __args?: QuerySaleProfileListArgs })
    sale_profile_recordset?: (OrderProfileRecordsetGenqlSelection & { __args?: QuerySaleProfileRecordsetArgs })
    sale_client_card_single?: (SaleClientCardGenqlSelection & { __args?: QuerySaleClientCardSingleArgs })
    sale_client_card_list?: (SaleClientCardGenqlSelection & { __args?: QuerySaleClientCardListArgs })
    sale_client_card_recordset?: (ClientCardRecordsetGenqlSelection & { __args?: QuerySaleClientCardRecordsetArgs })
    sale_client_card_fetch?: (SaleClientCardGenqlSelection & { __args?: QuerySaleClientCardFetchArgs })
    sale_client_card_apply_by_phone?: (SaleClientCardGenqlSelection & { __args?: QuerySaleClientCardApplyByPhoneArgs })
    sale_delivery_zones?: DeliveryZoneGenqlSelection
    sale_order_statuses?: OrderStatusGenqlSelection
    basket_rule_list?: (BasketRuleGenqlSelection & { __args?: QueryBasketRuleListArgs })
    sale_bonus_level_list?: (BonusLevelGenqlSelection & { __args?: QuerySaleBonusLevelListArgs })
    product_ingredient_list?: (ProductIngredientGenqlSelection & { __args?: QueryProductIngredientListArgs })
    product_modificator_list?: ModificatorGenqlSelection
    product_flag_list?: (ProductFlagGenqlSelection & { __args?: QueryProductFlagListArgs })
    order_restriction_list?: (OrderRestrictionGenqlSelection & { __args?: QueryOrderRestrictionListArgs })
    catalog_product_section_list?: (ProductSectionGenqlSelection & { __args?: QueryCatalogProductSectionListArgs })
    order_history?: (OrderGenqlSelection & { __args?: QueryOrderHistoryArgs })
    client_segment_single?: (ClientSegmentGenqlSelection & { __args?: QueryClientSegmentSingleArgs })
    client_segment_list?: (ClientSegmentGenqlSelection & { __args?: QueryClientSegmentListArgs })
    client_segment_recordset?: (ClientSegmentRecordsetGenqlSelection & { __args?: QueryClientSegmentRecordsetArgs })
    feature_single?: (FeatureGenqlSelection & { __args?: QueryFeatureSingleArgs })
    feature_list?: (FeatureGenqlSelection & { __args?: QueryFeatureListArgs })
    feature_recordset?: (FeatureRecordsetGenqlSelection & { __args?: QueryFeatureRecordsetArgs })
    feature_list_for_user?: (FeatureGenqlSelection & { __args?: QueryFeatureListForUserArgs })
    call_tracking_phone?: CallTrackingPhoneGenqlSelection
    yandex_metric_goal_single?: (YandexMetricGoalGenqlSelection & { __args?: QueryYandexMetricGoalSingleArgs })
    yandex_metric_goal_list?: (YandexMetricGoalGenqlSelection & { __args?: QueryYandexMetricGoalListArgs })
    yandex_metric_goal_recordset?: (YandexMetricGoalRecordsetGenqlSelection & { __args?: QueryYandexMetricGoalRecordsetArgs })
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TestItemGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    description?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TestItemFilterInput {id?: (Scalars['Int'] | null),name?: (Scalars['String'] | null)}

export interface EntityQueryTargetInput {UID?: (Scalars['String'][] | null),PROVIDER_TYPE?: (Scalars['String'][] | null),PROVIDER?: (Scalars['String'][] | null),BUNDLE_CODE?: (Scalars['Int'][] | null),BUNDLE_ID?: (Scalars['Int'][] | null)}

export interface EntityOptionGenqlSelection{
    UID?: boolean | number
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    TAXONOMY_TERM_ID?: boolean | number
    TAXONOMY_TERM_IDS?: boolean | number
    PARENT_ID?: boolean | number
    ACTIVE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface EntityTypeGenqlSelection{
    UID?: boolean | number
    PROVIDER_TYPE?: boolean | number
    PROVIDER_TYPE_NAME?: boolean | number
    PROVIDER?: boolean | number
    PROVIDER_NAME?: boolean | number
    BUNDLE_CODE?: boolean | number
    BUNDLE_ID?: boolean | number
    ENTITY_TYPE?: boolean | number
    TAXONOMY_TYPE?: boolean | number
    TAXONOMY_MEMBER_TYPE?: boolean | number
    NAME?: boolean | number
    ROLE?: boolean | number
    CLASS?: boolean | number
    RIGHTS?: boolean | number
    TAXONOMY_TERMS?: EntityOptionGenqlSelection
    OPTIONS?: EntityOptionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface EntityProviderTypeGenqlSelection{
    CODE?: boolean | number
    NAME?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface EntityComputedFieldGenqlSelection{
    entityType?: boolean | number
    entityBundleCode?: boolean | number
    entityBundleId?: boolean | number
    name?: boolean | number
    type?: boolean | number
    conditionDate?: boolean | number
    valueType?: boolean | number
    round?: boolean | number
    valueOptions?: EntityComputedFieldValueOptionGenqlSelection
    entityField?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface EntityComputedFieldValueOptionGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface MenuGenqlSelection{
    id?: boolean | number
    code?: boolean | number
    children?: MenuItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface MenuItemGenqlSelection{
    id?: boolean | number
    parent?: boolean | number
    label?: boolean | number
    infoLabel?: boolean | number
    command?: CommandGenqlSelection
    url?: boolean | number
    blank?: boolean | number
    native?: boolean | number
    icon?: boolean | number
    imageId?: boolean | number
    image?: ImageGenqlSelection
    display?: boolean | number
    color?: boolean | number
    bgColor?: boolean | number
    children?: MenuItemGenqlSelection
    roles?: boolean | number
    entityType?: boolean | number
    entityId?: boolean | number
    badge?: boolean | number
    params?: boolean | number
    size?: boolean | number
    outline?: boolean | number
    flat?: boolean | number
    width?: boolean | number
    class?: boolean | number
    onClick?: boolean | number
    dense?: boolean | number
    loading?: boolean | number
    loadingLabel?: boolean | number
    disable?: boolean | number
    textColor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CommandGenqlSelection{
    code?: boolean | number
    type?: boolean | number
    path?: boolean | number
    params?: boolean | number
    confirm?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ImageGenqlSelection{
    ID?: boolean | number
    SRC?: boolean | number
    SRC_DEFAULT?: boolean | number
    FILE_SIZE?: boolean | number
    ORIGINAL_NAME?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ClientEmitGenqlSelection{
    id?: boolean | number
    title?: boolean | number
    message?: boolean | number
    body?: boolean | number
    eventName?: boolean | number
    eventData?: boolean | number
    eventGroup?: boolean | number
    targetUserId?: boolean | number
    targetClientId?: boolean | number
    createdAt?: { __args: ClientEmitCreatedAtArgs } | boolean | number
    cls?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ClientNoticeGenqlSelection{
    ID?: boolean | number
    TITLE?: boolean | number
    MESSAGE?: boolean | number
    BODY?: boolean | number
    EVENT_NAME?: boolean | number
    EVENT_DATA?: boolean | number
    EVENT_GROUP?: boolean | number
    ENTITY_TYPE?: boolean | number
    ENTITY_ID?: boolean | number
    TARGET_CLIENT_ID?: boolean | number
    TARGET_USER_ID?: boolean | number
    CREATED_AT_FORMATTED?: boolean | number
    CREATED_AT?: boolean | number
    ACTION_MOBILE?: boolean | number
    ACTIVE?: boolean | number
    IMAGE?: ImageGenqlSelection
    TARGET?: boolean | number
    BODY_HTML?: boolean | number
    SHOW_AS?: boolean | number
    image?: ImageGenqlSelection
    IMPORTANT?: boolean | number
    haveBody?: boolean | number
    showAs?: boolean | number
    targetCode?: boolean | number
    actionItems?: MenuItemGenqlSelection
    cls?: boolean | number
    isReaded?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserSessionGenqlSelection{
    SESSION_ID?: boolean | number
    USER_ID?: boolean | number
    FUSER_ID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    SESSION_ID?: boolean | number
    GROUPS?: UserGroupGenqlSelection
    ROLES?: boolean | number
    DL?: boolean | number
    LOGIN?: boolean | number
    LOGIN_FORMAT?: boolean | number
    EMAIL?: boolean | number
    NAME_FULL?: boolean | number
    NAME_TEASER?: boolean | number
    LAST_NAME?: boolean | number
    SECOND_NAME?: boolean | number
    PHONE?: boolean | number
    PHONE_FORMATTED?: boolean | number
    PERSONAL_PHOTO?: ImageGenqlSelection
    PERSONAL_BIRTHDAY?: boolean | number
    DATE_REGISTER?: boolean | number
    LAST_LOGIN?: boolean | number
    PERSON_TYPE_ID?: boolean | number
    PROPS?: EntityPropGenqlSelection
    PROMOCODE?: boolean | number
    AVATAR?: UserAvatarGenqlSelection
    GREETING_NAME?: boolean | number
    FAMILY?: UserFamilyGenqlSelection
    PROFILE_FILLED?: boolean | number
    PROFILE_GIFT_USED?: boolean | number
    COMPUTED?: boolean | number
    ORDER_COUNT?: boolean | number
    SUBSCRIPTIONS?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserGroupGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    DL?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface EntityPropGenqlSelection{
    ID?: boolean | number
    CODE?: boolean | number
    NAME?: boolean | number
    TYPE?: boolean | number
    VAL?: boolean | number
    VAL_ID?: boolean | number
    VAL_ENUM_ID?: boolean | number
    DESC?: boolean | number
    MUL?: boolean | number
    FILE?: ImageGenqlSelection
    FILES?: ImageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAvatarGenqlSelection{
    ELEMENT_ID?: boolean | number
    IMAGE?: ImageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserFamilyGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    RELATION?: boolean | number
    USER_ID?: boolean | number
    BIRTHDAY?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface AppClientGenqlSelection{
    ID?: boolean | number
    CLIENT_ID?: boolean | number
    TOKEN?: boolean | number
    SESSION_ID?: boolean | number
    CURRENT_SESSION_ID?: boolean | number
    USER_ID?: boolean | number
    WEB_PUSH_TOKEN?: boolean | number
    MOBILE_PUSH_TOKEN?: boolean | number
    WEB_PUSH_ENDPOINT?: boolean | number
    WEB_PUSH_P256DH?: boolean | number
    WEB_PUSH_AUTH?: boolean | number
    WEB_PUSH_ACTIVE?: boolean | number
    DEBUG_PARAMS?: AppClientDebugParamsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface AppClientDebugParamsGenqlSelection{
    eventsTransport?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ElementListFilterInput {ID?: (IntFilterInput | null),NAME?: (StringFilterInput | null),CODE?: (StringFilterInput | null),SORT?: (IntFilterInput | null),IBLOCK_ID?: (IntFilterInput | null),IBLOCK_CODE?: (StringFilterInput | null),IBLOCK_SECTION_ID?: (IntFilterInput | null),ACTIVE?: (Scalars['Boolean'] | null),ACTIVE_DATE?: (Scalars['Boolean'] | null)}

export interface IntFilterInput {exists?: (Scalars['Boolean'] | null),eq?: (Scalars['Int'] | null),in?: ((Scalars['Int'] | null)[] | null),not?: (Scalars['Int'] | null),gt?: (Scalars['Int'] | null),lt?: (Scalars['Int'] | null)}

export interface StringFilterInput {exists?: (Scalars['Boolean'] | null),eq?: (Scalars['String'] | null),in?: ((Scalars['String'] | null)[] | null),not?: (Scalars['String'] | null),like?: (Scalars['String'] | null)}

export interface QueryNavInput {limit?: (Scalars['Int'] | null),page?: (Scalars['Int'] | null),sort?: (Scalars['String'] | null),sortField?: (Scalars['String'] | null),asc?: (Scalars['Boolean'] | null),sortAscending?: (Scalars['Boolean'] | null),postSort?: (Scalars['String'] | null),postSortAsc?: (Scalars['Boolean'] | null),postLimit?: (Scalars['Int'] | null)}

export interface PageGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: PageActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: PageActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: PageTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: PageDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: PagePreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: PageDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: PageShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: PagePropsGenqlSelection
    DATA_CHUNKS?: PageDataChunkGenqlSelection
    CONTENT_CHUNKS?: PageContentChunkGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SectionGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_TYPE_ID?: boolean | number
    IBLOCK_EXTERNAL_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    TIMESTAMP_X?: { __args: SectionTimestampXArgs } | boolean | number
    ACTIVE?: boolean | number
    PICTURE?: ImageGenqlSelection
    DETAIL_PICTURE?: ImageGenqlSelection
    DESCRIPTION?: boolean | number
    DESCRIPTION_TYPE?: boolean | number
    LEFT_MARGIN?: boolean | number
    RIGHT_MARGIN?: boolean | number
    DEPTH_LEVEL?: boolean | number
    SEARCHABLE_CONTENT?: { __args: SectionSearchableContentArgs } | boolean | number
    SECTION_PAGE_URL?: boolean | number
    DATE_CREATE?: { __args: SectionDateCreateArgs } | boolean | number
    PARENT?: SectionGenqlSelection
    PARENTS?: SectionGenqlSelection
    ELEMENT_CNT?: boolean | number
    META?: ElementMetaGenqlSelection
    REPLACE_LINK?: boolean | number
    CHILDREN?: SectionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ElementMetaGenqlSelection{
    TITLE?: boolean | number
    KEYWORDS?: boolean | number
    DESCRIPTION?: boolean | number
    PAGE_TITLE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PagePropsGenqlSelection{
    TPL_PAGE_VIEW?: boolean | number
    TPL_PAGE_CONTENT?: boolean | number
    DATA_CHUNKS?: ElementPropValueWithDescGenqlSelection
    CHUNKS?: PagePropsChunksGenqlSelection
    CHUNK_NAME?: boolean | number
    CHUNK_VALUE?: ElementPropValueHtmlGenqlSelection
    CHUNK_CODE?: boolean | number
    CHUNK_GROUP?: boolean | number
    META_TITLE?: boolean | number
    META_DESCRIPTION?: boolean | number
    META_KEYWORDS?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ElementPropValueWithDescGenqlSelection{
    VALUE?: boolean | number
    DESC?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PagePropsChunksGenqlSelection{
    CHUNK_CODE?: boolean | number
    CHUNK_NAME?: boolean | number
    CHUNK_VALUE?: ElementPropValueHtmlGenqlSelection
    CHUNK_GROUP?: boolean | number
    UID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ElementPropValueHtmlGenqlSelection{
    TEXT?: boolean | number
    TYPE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PageDataChunkGenqlSelection{
    CODE?: boolean | number
    TYPE?: boolean | number
    VALUE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PageContentChunkGenqlSelection{
    GROUP?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    VALUE?: boolean | number
    TYPE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface EntityComputedFieldInput {id?: (Scalars['String'] | null),code?: (Scalars['String'] | null),type?: (Scalars['String'] | null),filter?: (EntityComputedFieldFilterInput | null)}

export interface EntityComputedFieldFilterInput {value?: (Scalars['Json'] | null),valueFrom?: (Scalars['Json'] | null),valueTo?: (Scalars['Json'] | null),
/** Массив значений для множественного выбора */
valueIn?: ((Scalars['Json'] | null)[] | null),dateFrom?: (Scalars['String'] | null),dateFromValue?: (Scalars['String'] | null),dateTo?: (Scalars['String'] | null),dateToValue?: (Scalars['String'] | null)}

export interface PageRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface QueryInfoGenqlSelection{
    total?: boolean | number
    page?: boolean | number
    pages?: boolean | number
    limit?: boolean | number
    nextPage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OfficeFilterInput {ID?: (IntFilterInput | null),NAME?: (StringFilterInput | null),CODE?: (StringFilterInput | null),SORT?: (IntFilterInput | null),IBLOCK_ID?: (IntFilterInput | null),IBLOCK_CODE?: (StringFilterInput | null),IBLOCK_SECTION_ID?: (IntFilterInput | null),ACTIVE?: (Scalars['Boolean'] | null),ACTIVE_DATE?: (Scalars['Boolean'] | null)}

export interface CompanyOfficeGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: CompanyOfficeActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: CompanyOfficeActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: CompanyOfficeTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: CompanyOfficeDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: CompanyOfficePreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: CompanyOfficeDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: CompanyOfficeShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: CompanyOfficePropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CompanyOfficePropsGenqlSelection{
    MAIN?: boolean | number
    ADDRESS?: boolean | number
    PHONES?: boolean | number
    EMAIL?: boolean | number
    COORDINATES?: CoordinatesGenqlSelection
    REQUISITES?: ElementPropValueHtmlGenqlSelection
    ROLES?: ListValueGenqlSelection
    WORKTIME?: boolean | number
    SERVICE_ID?: boolean | number
    PAYSYSTEM_ID?: boolean | number
    GIS_URL?: boolean | number
    INFO_URL?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CoordinatesGenqlSelection{
    LON?: boolean | number
    LAT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ListValueGenqlSelection{
    ID?: boolean | number
    VALUE?: boolean | number
    CODE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OfficeRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: CompanyOfficeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CompanyVacancyGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: CompanyVacancyActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: CompanyVacancyActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: CompanyVacancyTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: CompanyVacancyDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: CompanyVacancyPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: CompanyVacancyDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: CompanyVacancyShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: CompanyVacancyPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CompanyVacancyPropsGenqlSelection{
    PAYMENT?: boolean | number
    RESPONSIBILITES?: ElementPropValueHtmlGenqlSelection
    WORK_EXPERIENCE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VacancyRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: CompanyVacancyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FaqQuestionGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: FaqQuestionActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: FaqQuestionActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: FaqQuestionTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: FaqQuestionDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: FaqQuestionPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: FaqQuestionDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: FaqQuestionShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FaqQuestionRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: FaqQuestionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface GeoObjectGenqlSelection{
    geo_lat?: boolean | number
    geo_lon?: boolean | number
    address_original?: boolean | number
    address_full?: boolean | number
    address_short?: boolean | number
    street_path_full?: boolean | number
    street_path_short?: boolean | number
    region?: boolean | number
    region_format?: boolean | number
    region_original?: boolean | number
    region_fias_id?: boolean | number
    area?: boolean | number
    area_format?: boolean | number
    area_original?: boolean | number
    area_fias_id?: boolean | number
    city?: boolean | number
    city_format?: boolean | number
    city_original?: boolean | number
    city_fias_id?: boolean | number
    district?: boolean | number
    district_format?: boolean | number
    district_original?: boolean | number
    district_fias_id?: boolean | number
    street?: boolean | number
    street_format?: boolean | number
    street_original?: boolean | number
    street_fias_id?: boolean | number
    house?: boolean | number
    house_format?: boolean | number
    house_original?: boolean | number
    house_fias_id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SearchSuggestionGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    data?: SearchSuggestionDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SearchSuggestionDataGenqlSelection{
    type?: boolean | number
    entityTypeName?: boolean | number
    entityTypeCode?: boolean | number
    entityTypeId?: boolean | number
    entityRole?: boolean | number
    entityId?: boolean | number
    entityTitle?: boolean | number
    hint?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OfferGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: OfferActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: OfferActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: OfferTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: OfferDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: OfferPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: OfferDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: OfferShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    VID?: boolean | number
    OFFER_NAME?: boolean | number
    STARTUP_SHOW?: boolean | number
    BANNER_INTERNAL_TEXT?: boolean | number
    BANNER_HOR_MOBILE?: ImageGenqlSelection
    BANNER_HOR_DESKTOP?: ImageGenqlSelection
    BANNER_SQUARE?: ImageGenqlSelection
    DISCOUNT_ID?: boolean | number
    CONTENT_IMAGE?: ImageGenqlSelection
    SLIDES?: OfferSlideGenqlSelection
    ACTIONS_WEB?: MenuItemGenqlSelection
    ACTIONS_MOBILE?: MenuItemMobileGenqlSelection
    IS_HOT?: boolean | number
    VARS?: boolean | number
    VIEW_MODE?: boolean | number
    STICKY?: boolean | number
    STICKY_TITLE?: boolean | number
    STICKY_ICON?: boolean | number
    FEATURES?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OfferSlideGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    CONTENT_TYPE?: boolean | number
    CONTENT_IMAGE?: ImageGenqlSelection
    CONTENT_HTML?: boolean | number
    BG_COLOR?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface MenuItemMobileGenqlSelection{
    id?: boolean | number
    parent?: boolean | number
    label?: boolean | number
    icon?: boolean | number
    imageId?: boolean | number
    image?: ImageGenqlSelection
    color?: boolean | number
    backgroundColor?: boolean | number
    outlineColor?: boolean | number
    outlineWidth?: boolean | number
    link?: boolean | number
    outline?: boolean | number
    labelColor?: boolean | number
    badge?: boolean | number
    params?: boolean | number
    action?: ActionMobileGenqlSelection
    condition?: ConditionGenqlSelection
    templatable?: boolean | number
    templatableProps?: boolean | number
    roles?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ActionMobileGenqlSelection{
    code?: boolean | number
    url?: boolean | number
    title?: boolean | number
    titleAuto?: boolean | number
    replace?: boolean | number
    addBacklink?: boolean | number
    addSession?: boolean | number
    await?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ConditionGenqlSelection{
    path?: boolean | number
    eq?: boolean | number
    gt?: boolean | number
    lt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OfferRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: OfferGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushSubscriberGenqlSelection{
    ID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FortunePrizeGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: FortunePrizeActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: FortunePrizeActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: FortunePrizeTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: FortunePrizeDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: FortunePrizePreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: FortunePrizeDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: FortunePrizeShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: FortunePrizePropsGenqlSelection
    PRIZE_TYPE?: boolean | number
    BACKGROUND_COLOR?: boolean | number
    TEXT_COLOR?: boolean | number
    TEXT_ORIENTATION?: boolean | number
    PROBABILITY?: boolean | number
    GIFT_ELEMENT?: boolean | number
    DISCOUNT_ELEMENT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FortunePrizePropsGenqlSelection{
    BACKGROUND_COLOR?: boolean | number
    TEXT_COLOR?: boolean | number
    TEXT_ORIENTATION?: ListValueGenqlSelection
    PROBABILITY?: boolean | number
    PRIZE_TYPE?: boolean | number
    GIFT_ELEMENT_ENTITY?: ElementGenqlSelection
    GIFT_ELEMENT?: boolean | number
    DISCOUNT_ELEMENT_ENTITY?: ElementGenqlSelection
    DISCOUNT_ELEMENT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ElementGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: ElementActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: ElementActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: ElementTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: ElementDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: ElementPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: ElementDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: ElementShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FortuneUserPrizeGenqlSelection{
    ID?: boolean | number
    USER_ID?: boolean | number
    CREATED_AT?: boolean | number
    PRIZE_ELEMENT_ID_ENTITY?: ElementGenqlSelection
    PRIZE_ELEMENT_ID?: boolean | number
    IS_USED?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface HLEntityFilter {ID?: (IntFilterInput | null)}

export interface TelegramChatGenqlSelection{
    ID?: boolean | number
    CHAT_ID?: boolean | number
    TELEGRAM_ID?: boolean | number
    USER_ID?: boolean | number
    PHONE?: boolean | number
    STATUS?: boolean | number
    CREATED_AT?: boolean | number
    UPDATED_AT?: boolean | number
    LAST_ACTIVITY?: boolean | number
    UID?: boolean | number
    CONTACT_PHONE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TelegramChatRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: TelegramChatGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface WebcamGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: WebcamActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: WebcamActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: WebcamTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: WebcamDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: WebcamPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: WebcamDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: WebcamShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: WebcamPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface WebcamPropsGenqlSelection{
    CODE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ReviewGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: ReviewActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: ReviewActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: ReviewTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: ReviewDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: ReviewPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: ReviewDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: ReviewShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: ReviewPropsGenqlSelection
    ELEMENT?: ElementGenqlSelection
    CHILDREN?: ReviewGenqlSelection
    ORDER?: OrderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ReviewPropsGenqlSelection{
    AUTHOR_USER_ID?: boolean | number
    AUTHOR_NAME?: boolean | number
    RATING?: boolean | number
    ELEMENT_ID_ENTITY?: ElementGenqlSelection
    ELEMENT_ID?: boolean | number
    CONTEXT_ID?: boolean | number
    ANSWER?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderGenqlSelection{
    ID?: boolean | number
    TS?: boolean | number
    SYNCED?: boolean | number
    SERVICE_ID?: boolean | number
    PERSON_TYPE_ID?: boolean | number
    URL?: boolean | number
    USER_ID?: boolean | number
    USER?: UserGenqlSelection
    DATE_INSERT?: { __args: OrderDateInsertArgs } | boolean | number
    DATE_UPDATE?: { __args: OrderDateUpdateArgs } | boolean | number
    DATE_PAYED?: { __args: OrderDatePayedArgs } | boolean | number
    DATE_FORMATTED?: { __args: OrderDateFormattedArgs } | boolean | number
    DATE_TIME_FORMATTED?: { __args: OrderDateTimeFormattedArgs } | boolean | number
    PRICE?: boolean | number
    PRICE_BASKET?: boolean | number
    PRICE_BASKET_BASE?: boolean | number
    PRICE_DISCOUNT?: boolean | number
    PRICE_DELIVERY?: boolean | number
    PRICE_DELIVERY_BASE?: boolean | number
    PRICE_TOTAL?: boolean | number
    PRICE_TOTAL_BASE?: boolean | number
    PRICE_PAY?: boolean | number
    PRICE_PAY_BASE?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    DISCOUNT_REASON?: boolean | number
    DELIVERY_FREE_FROM_PRICE?: boolean | number
    DELIVERY_ADDRESS_FULL?: boolean | number
    DELIVERY_DATETIME?: { __args: OrderDeliveryDatetimeArgs } | boolean | number
    DELIVERY_ID?: boolean | number
    DELIVERY?: DeliveryServiceGenqlSelection
    DELIVERY_CALCULATED?: boolean | number
    DELIVERY_DEPARTMENT?: CompanyOfficeGenqlSelection
    PICKUP_DEPARTMENT?: CompanyOfficeGenqlSelection
    PAYSYSTEM_ID?: boolean | number
    PAYSYSTEM?: PaysystemGenqlSelection
    PAYSYSTEM_IS_ONLINE?: boolean | number
    BASKET?: BasketItemGenqlSelection
    STATUS?: OrderStatusGenqlSelection
    STATUS_ID?: boolean | number
    STATUS_NAME?: boolean | number
    STATUS_COLOR?: boolean | number
    CSTATUS_ID?: boolean | number
    CSTATUS_NAME?: boolean | number
    CSTATUS_COLOR?: boolean | number
    IS_PAID?: boolean | number
    IS_ACTIVE?: boolean | number
    IS_FINISHED?: boolean | number
    IS_CANCELED?: boolean | number
    IS_CAN_PAY?: boolean | number
    IS_CAN_PAY_ONLINE?: boolean | number
    IS_CAN_PAY_BILL?: boolean | number
    IS_CAN_CANCEL?: boolean | number
    USER_DESCRIPTION?: boolean | number
    ACCESS_HASH?: boolean | number
    SECRET_URL?: boolean | number
    ACCOUNT_NUMBER?: boolean | number
    PAYMENTS?: PaymentGenqlSelection
    BUYER_NAME?: boolean | number
    CONTRACT_NUM?: boolean | number
    EDU_GROUP_NUM?: boolean | number
    STUDENT_FIO?: boolean | number
    PAY_LINK?: boolean | number
    SCOPE?: OrderScopeGenqlSelection
    SCOPE_ENTITY?: CommandGenqlSelection
    ACTIONS?: boolean | number
    COUPONS?: CouponGenqlSelection
    BONUSES?: boolean | number
    COURIER_STATE?: CourierStateGenqlSelection
    ADDRESS_FOR_1C?: boolean | number
    CANCEL_REASONS?: OrderCancelReasonGenqlSelection
    ATTR_VALUE?: OrderAttributesValueGenqlSelection
    ATTR_VIEW?: OrderAttributesViewGenqlSelection
    ATTRS?: OrderAttributeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryServiceGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    PARENT_ID?: boolean | number
    TRANSPORT_TYPE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PaysystemGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    DESCRIPTION?: boolean | number
    IS_INNER?: boolean | number
    IS_ONLINE?: boolean | number
    IS_ONLINE_DELAYED?: boolean | number
    IS_BILL?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketItemGenqlSelection{
    ID?: boolean | number
    UUID?: boolean | number
    PARENT_ID?: boolean | number
    PARENT_UUID?: boolean | number
    ORDER_ID?: boolean | number
    PRODUCT_ID?: boolean | number
    NAME?: boolean | number
    DESC?: boolean | number
    QUANTITY?: boolean | number
    BASE_PRICE?: boolean | number
    PRICE_BASE?: boolean | number
    PRICE?: boolean | number
    FINAL_PRICE?: boolean | number
    FINAL_PRICE_BASE?: boolean | number
    MEASURE_NAME?: boolean | number
    COMMENT?: boolean | number
    PAID?: boolean | number
    INPUT_PROPS_HASH?: boolean | number
    DISABLE?: boolean | number
    DISABLE_REASON?: boolean | number
    BENEFIT?: boolean | number
    DISCOUNTS?: BasketItemDiscountGenqlSelection
    CLIENT_CHANGED_AT?: boolean | number
    ELEMENT?: ProductGenqlSelection
    BUILD?: BasketBuildItemGenqlSelection
    MODIFICATORS?: boolean | number
    PROPERTIES?: BasketItemPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketItemDiscountGenqlSelection{
    RULE?: boolean | number
    TARGET?: boolean | number
    TYPE?: boolean | number
    AMOUNT?: boolean | number
    DISCOUNTED_PRICE?: boolean | number
    BASE_PRICE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: ProductActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: ProductActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: ProductTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: ProductDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: ProductPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: ProductDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: ProductShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: ProductPropsGenqlSelection
    PRICE?: ProductPriceGenqlSelection
    MEASURE?: ProductMeasureGenqlSelection
    PARENT?: ProductGenqlSelection
    OFFERS?: ProductGenqlSelection
    IS_SALE_SPECIAL?: boolean | number
    SALES_COUNT?: boolean | number
    HIT_POSITION?: boolean | number
    HIT_SECTION_POSITION?: boolean | number
    WEIGHT?: boolean | number
    OFFER_PARENT_ELEMENT?: ProductGenqlSelection
    INGREDIENTS?: IngredientGenqlSelection
    FEATURE_IDS?: boolean | number
    IMAGE?: ImageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductPropsGenqlSelection{
    WEIGHT?: boolean | number
    KKAL?: boolean | number
    BELKI?: boolean | number
    ZHIRY?: boolean | number
    UGLEVODY?: boolean | number
    ROLLS_ENTITIES?: ElementGenqlSelection
    ROLLS?: boolean | number
    PHOTOV2?: ImageGenqlSelection
    COMPONENT_IS?: ListValueGenqlSelection
    INGREDIENTS_ENTITIES?: ElementGenqlSelection
    INGREDIENTS?: boolean | number
    SERVICE_ID?: boolean | number
    SALE_SPECIAL?: boolean | number
    FLAGS_ENTITIES?: ElementGenqlSelection
    FLAGS?: boolean | number
    SET_ITEMS?: ProductPropsSetItemsGenqlSelection
    MODIFICATORS_ENTITIES?: ElementGenqlSelection
    MODIFICATORS?: boolean | number
    FEATURES_ENTITIES?: ElementGenqlSelection
    FEATURES?: boolean | number
    HIT_POSITION?: boolean | number
    HIT_SECTION_POSITION?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductPropsSetItemsGenqlSelection{
    PRODUCT_ID_ENTITY?: ElementGenqlSelection
    PRODUCT_ID?: boolean | number
    QUANTITY?: boolean | number
    UID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductPriceGenqlSelection{
    PRICE?: boolean | number
    DISCOUNTED?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductMeasureGenqlSelection{
    NAME?: boolean | number
    RATIO?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface IngredientGenqlSelection{
    ELEMENT_ID?: boolean | number
    IS_REMOVABLE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketBuildItemGenqlSelection{
    PRODUCT_ID?: boolean | number
    QUANTITY?: boolean | number
    ELEMENT?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketItemPropsGenqlSelection{
    CATALOG_XML_ID?: boolean | number
    PRODUCT_XML_ID?: boolean | number
    PARENT_UUID?: boolean | number
    IS_GIFT?: boolean | number
    REASON_MOD_CODE?: boolean | number
    REASON_MOD_ID?: boolean | number
    REASON_RULE_CODE?: boolean | number
    REASON_RULE_ID?: boolean | number
    INGREDIENTS_REMOVED?: boolean | number
    INGREDIENTS_ADDED?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderStatusGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    SORT?: boolean | number
    COLOR?: boolean | number
    TYPE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PaymentGenqlSelection{
    ID?: boolean | number
    PAYSYSTEM_ID?: boolean | number
    PAYSYSTEM?: PaysystemGenqlSelection
    IS_PAID?: boolean | number
    SUM?: boolean | number
    SUM_PAID?: boolean | number
    PAY_NAV?: boolean | number
    PS_STATUS?: boolean | number
    PS_STATUS_CODE?: boolean | number
    PS_STATUS_ID?: boolean | number
    PS_STATUS_NAME?: boolean | number
    PS_INVOICE_ID?: boolean | number
    ORDER_ID?: boolean | number
    ORDER_URL?: boolean | number
    DATE_PAID?: { __args: PaymentDatePaidArgs } | boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderScopeGenqlSelection{
    CONTRACT_NUM?: boolean | number
    ENTITY_TYPE?: boolean | number
    ENTITY_ID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CouponGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    COUPON?: boolean | number
    PRODUCT_ID?: boolean | number
    PRODUCT?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CourierStateGenqlSelection{
    COORDS?: boolean | number
    ARRIVAL_TIME_CAPTION?: boolean | number
    ARRIVAL_TIME?: boolean | number
    CAR_COLOR?: boolean | number
    CAR_NUMBER?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderCancelReasonGenqlSelection{
    CODE?: boolean | number
    NAME?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderAttributesValueGenqlSelection{
    DETAILS?: boolean | number
    UUID?: boolean | number
    FIO?: boolean | number
    PHONE?: boolean | number
    EMAIL?: boolean | number
    DELIVERY_TYPE?: boolean | number
    DELIVERY_DEPARTMENT?: boolean | number
    STREET_PATH?: boolean | number
    CITY?: boolean | number
    CITY_FIAS_ID?: boolean | number
    SETTLEMENT?: boolean | number
    SETTLEMENT_FIAS_ID?: boolean | number
    STREET_FIAS_ID?: boolean | number
    STREET_COORDS?: CoordinatesGenqlSelection
    HOUSE?: boolean | number
    HOUSE_FIAS_ID?: boolean | number
    HOUSE_COORDS?: CoordinatesGenqlSelection
    FLAT?: boolean | number
    LOCATION?: boolean | number
    INTERCOM?: boolean | number
    FLOOR?: boolean | number
    ENTRANCE?: boolean | number
    PRIVATE_HOUSE?: boolean | number
    LIFT?: boolean | number
    PICKUP_DEPARTMENT?: boolean | number
    TIME_MODE?: boolean | number
    DATE?: boolean | number
    TIME?: boolean | number
    PAYMENT_TYPE?: boolean | number
    CASH_SUM?: boolean | number
    BONUSES?: boolean | number
    PROMOCODE?: boolean | number
    DELIVERY_PRICE?: boolean | number
    RECEIVER_NAME?: boolean | number
    RECEIVER_ANOTHER?: boolean | number
    RECEIVER_PHONE?: boolean | number
    PERSONS_NUMBER?: boolean | number
    COMMENT?: boolean | number
    GIFTS_LIST?: boolean | number
    WITH_OPERATOR?: boolean | number
    ROISTAT?: boolean | number
    NEED_CONFIRM?: boolean | number
    PROFILE_COMMENT?: boolean | number
    ADDRESS_SOURCE?: boolean | number
    PROFILE_ID?: boolean | number
    ADDRESS_IS_CUSTOM?: boolean | number
    PROFILE_DEFAULT?: boolean | number
    VORDER_ID?: boolean | number
    SERVICE_SEND?: boolean | number
    DATETIME?: boolean | number
    SERVICE_SEND_START?: boolean | number
    DATA?: OrderDataGenqlSelection
    RESERVE_SUCCESS_HASH?: boolean | number
    DISCOUNT_REASON?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    ADDRESS?: boolean | number
    BENEFIT_TYPE?: boolean | number
    DELIVERY_FREE_FROM_PRICE?: boolean | number
    STREET?: boolean | number
    DEPARTMENT_SERVICE_ID?: boolean | number
    DELIVERY_FREE_UPDATED_TIME?: boolean | number
    IS_ACCEPTED?: boolean | number
    TEST_TIME?: boolean | number
    STRUCT?: boolean | number
    TRANSPORT_TYPE?: boolean | number
    COUPON_ID?: boolean | number
    PRIZE_ID?: boolean | number
    SESSION_ID?: boolean | number
    PAYMENT_GIFT?: boolean | number
    TEST_TIME_NEW?: boolean | number
    APP_VERSION?: boolean | number
    SOURCE?: boolean | number
    RESERVE_REQUEST_TIME?: boolean | number
    UTM_SOURCE?: boolean | number
    RESERVE_AVAILABLE_TIME?: boolean | number
    RESERVE_NEED_TIME?: boolean | number
    RESERVE_STATUS?: boolean | number
    RESERVE_SUCCESS_REQUEST_TIME?: boolean | number
    UTM_MEDIUM?: boolean | number
    UTM_CAMPAIGN?: boolean | number
    UTM_TERM?: boolean | number
    UTM_CONTENT?: boolean | number
    UTM_LANDING_URL?: boolean | number
    DELIVERY_ID?: boolean | number
    PAY_SYSTEM_ID?: boolean | number
    USER_DESCRIPTION?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderDataGenqlSelection{
    paramInt?: boolean | number
    paramString?: boolean | number
    paramArray?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderAttributesViewGenqlSelection{
    DETAILS?: boolean | number
    UUID?: boolean | number
    FIO?: boolean | number
    PHONE?: boolean | number
    EMAIL?: boolean | number
    DELIVERY_TYPE?: boolean | number
    DELIVERY_DEPARTMENT?: boolean | number
    STREET_PATH?: boolean | number
    CITY?: boolean | number
    CITY_FIAS_ID?: boolean | number
    SETTLEMENT?: boolean | number
    SETTLEMENT_FIAS_ID?: boolean | number
    STREET_FIAS_ID?: boolean | number
    STREET_COORDS?: boolean | number
    HOUSE?: boolean | number
    HOUSE_FIAS_ID?: boolean | number
    HOUSE_COORDS?: boolean | number
    FLAT?: boolean | number
    LOCATION?: boolean | number
    INTERCOM?: boolean | number
    FLOOR?: boolean | number
    ENTRANCE?: boolean | number
    PRIVATE_HOUSE?: boolean | number
    LIFT?: boolean | number
    PICKUP_DEPARTMENT?: boolean | number
    TIME_MODE?: boolean | number
    DATE?: boolean | number
    TIME?: boolean | number
    PAYMENT_TYPE?: boolean | number
    CASH_SUM?: boolean | number
    BONUSES?: boolean | number
    PROMOCODE?: boolean | number
    DELIVERY_PRICE?: boolean | number
    RECEIVER_NAME?: boolean | number
    RECEIVER_ANOTHER?: boolean | number
    RECEIVER_PHONE?: boolean | number
    PERSONS_NUMBER?: boolean | number
    COMMENT?: boolean | number
    GIFTS_LIST?: boolean | number
    WITH_OPERATOR?: boolean | number
    ROISTAT?: boolean | number
    NEED_CONFIRM?: boolean | number
    PROFILE_COMMENT?: boolean | number
    ADDRESS_SOURCE?: boolean | number
    PROFILE_ID?: boolean | number
    ADDRESS_IS_CUSTOM?: boolean | number
    PROFILE_DEFAULT?: boolean | number
    VORDER_ID?: boolean | number
    SERVICE_SEND?: boolean | number
    DATETIME?: boolean | number
    SERVICE_SEND_START?: boolean | number
    DATA?: boolean | number
    RESERVE_SUCCESS_HASH?: boolean | number
    DISCOUNT_REASON?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    ADDRESS?: boolean | number
    BENEFIT_TYPE?: boolean | number
    DELIVERY_FREE_FROM_PRICE?: boolean | number
    STREET?: boolean | number
    DEPARTMENT_SERVICE_ID?: boolean | number
    DELIVERY_FREE_UPDATED_TIME?: boolean | number
    IS_ACCEPTED?: boolean | number
    TEST_TIME?: boolean | number
    STRUCT?: boolean | number
    TRANSPORT_TYPE?: boolean | number
    COUPON_ID?: boolean | number
    PRIZE_ID?: boolean | number
    SESSION_ID?: boolean | number
    PAYMENT_GIFT?: boolean | number
    TEST_TIME_NEW?: boolean | number
    APP_VERSION?: boolean | number
    SOURCE?: boolean | number
    RESERVE_REQUEST_TIME?: boolean | number
    UTM_SOURCE?: boolean | number
    RESERVE_AVAILABLE_TIME?: boolean | number
    RESERVE_NEED_TIME?: boolean | number
    RESERVE_STATUS?: boolean | number
    RESERVE_SUCCESS_REQUEST_TIME?: boolean | number
    UTM_MEDIUM?: boolean | number
    UTM_CAMPAIGN?: boolean | number
    UTM_TERM?: boolean | number
    UTM_CONTENT?: boolean | number
    UTM_LANDING_URL?: boolean | number
    DELIVERY_ID?: boolean | number
    PAY_SYSTEM_ID?: boolean | number
    USER_DESCRIPTION?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderAttributeGenqlSelection{
    KIND?: boolean | number
    TYPE?: boolean | number
    CODE?: boolean | number
    NAME?: boolean | number
    DEFAULT_VALUE?: boolean | number
    VALUE?: boolean | number
    VALUE_VIEW?: boolean | number
    OPTIONS?: OrderAttributeOptionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderAttributeOptionGenqlSelection{
    ID?: boolean | number
    VALUE?: boolean | number
    NAME?: boolean | number
    NAME_SHORT?: boolean | number
    SORT?: boolean | number
    DESCRIPTION?: boolean | number
    XML_ID?: boolean | number
    ICON?: boolean | number
    DISABLE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductFilterInput {ID?: (IntFilterInput | null),NAME?: (StringFilterInput | null),CODE?: (StringFilterInput | null),SORT?: (IntFilterInput | null),IBLOCK_ID?: (IntFilterInput | null),IBLOCK_CODE?: (StringFilterInput | null),IBLOCK_SECTION_ID?: (IntFilterInput | null),ACTIVE?: (Scalars['Boolean'] | null),ACTIVE_DATE?: (Scalars['Boolean'] | null)}

export interface AppProductRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SearchResultGenqlSelection{
    ELEMENTS?: ProductGenqlSelection
    SECTIONS?: SectionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SearchSuggestionDataInput {type?: (Scalars['String'] | null),entityTypeName?: (Scalars['String'] | null),entityTypeCode?: (Scalars['String'] | null),entityTypeId?: (Scalars['String'] | null),entityRole?: (Scalars['String'] | null),entityId?: (Scalars['Int'] | null),entityTitle?: (Scalars['String'] | null),hint?: (Scalars['String'] | null)}

export interface OrderFilter {ID?: (IntFilterInput | null),ACCOUNT_NUMBER?: (StringFilterInput | null),PAYED?: (Scalars['Boolean'] | null),USER_ID?: (IntFilterInput | null),EMAIL?: (StringFilterInput | null),PHONE?: (StringFilterInput | null),ELEMENT_NAME?: (StringFilterInput | null),SECTION_ID?: (IntFilterInput | null),PAY_SYSTEM_ID?: (IntFilterInput | null),STATUS_ID?: (StringFilterInput | null),CANCELED?: (Scalars['Boolean'] | null),DATE_YEAR?: (Scalars['Int'] | null),DATE_MONTH?: (Scalars['Int'] | null),DATE_DAY?: (Scalars['Int'] | null),DATE_PAYED_YEAR?: (Scalars['Int'] | null),DATE_PAYED_MONTH?: (Scalars['Int'] | null),DATE_PAYED_DAY?: (Scalars['Int'] | null),PROP_FIO?: (StringFilterInput | null),PROP_EMAIL?: (StringFilterInput | null),PROP_PHONE?: (StringFilterInput | null),PROP_PRODUCT_SECTIONS?: (StringFilterInput | null),PROP_CONTRACT_NUM?: (StringFilterInput | null),PROP_EDU_GROUP_NUM?: (StringFilterInput | null),PROP_STUDENT_FIO?: (StringFilterInput | null),MODE?: (Scalars['String'] | null)}

export interface VorderCurrentGenqlSelection{
    TS?: boolean | number
    DELIVERY_PRICE_RULES?: DeliveryPriceRuleGenqlSelection
    BONUSES_AVAILABLE?: boolean | number
    BONUSES_PERCENT?: boolean | number
    PERSON_TYPES?: PersonTypeGenqlSelection
    PAYMENT_TYPES?: PaymentTypeGenqlSelection
    PROFILES?: OrderProfileGenqlSelection
    DEPARTMENTS?: CompanyOfficeGenqlSelection
    DISCOUNTS?: DiscountGenqlSelection
    DELIVERIES?: DeliveryComputedGenqlSelection
    TRANSPORT_TYPES?: TransportTypeGenqlSelection
    DELIVERY_CALCULATED?: boolean | number
    DELIVERY_FREE_FROM_PRICE?: boolean | number
    COUPON_CAN_ADD?: boolean | number
    RESPONSE_STATE?: ResponseStateGenqlSelection
    BASKET_RULES?: BasketRuleGenqlSelection
    ID?: boolean | number
    SESSION_ID?: boolean | number
    FUSER_ID?: boolean | number
    USER_ID?: boolean | number
    USER?: UserGenqlSelection
    ORDER_ID?: boolean | number
    FIELDS_RAW?: boolean | number
    PROPS_RAW?: boolean | number
    PHONE?: boolean | number
    EMAIL?: boolean | number
    ORDER?: OrderGenqlSelection
    PROFILE_ID?: boolean | number
    DELIVERY_DEPARTMENT_ID?: boolean | number
    PICKUP_DEPARTMENT_ID?: boolean | number
    DEPARTMENT_ID?: boolean | number
    BONUSES?: boolean | number
    COUPONS?: CouponGenqlSelection
    BASKET?: (BasketGenqlSelection & { __args?: VorderCurrentBasketArgs })
    ATTR?: OrderAttributesValueGenqlSelection
    ATTRS?: OrderAttributeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryPriceRuleGenqlSelection{
    DATE?: boolean | number
    PRICE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PersonTypeGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    SORT?: boolean | number
    CODE?: boolean | number
    RESTRICTED?: boolean | number
    IS_COMPANY?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PaymentTypeGenqlSelection{
    CODE?: boolean | number
    NAME?: boolean | number
    ICON?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderProfileGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CAPTION?: boolean | number
    USER_ID?: boolean | number
    USER?: UserGenqlSelection
    PERSON_TYPE_ID?: boolean | number
    PERSON_TYPE?: PersonTypeGenqlSelection
    COMPANY_ID?: boolean | number
    IS_DEFAULT?: boolean | number
    COORDS?: CoordinatesGenqlSelection
    DELIVERY_FREE_FROM_PRICE?: boolean | number
    ATTR?: OrderProfileAttributesValueGenqlSelection
    ATTRS?: OrderAttributeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderProfileAttributesValueGenqlSelection{
    STREET_PATH?: boolean | number
    CITY?: boolean | number
    CITY_FIAS_ID?: boolean | number
    SETTLEMENT?: boolean | number
    SETTLEMENT_FIAS_ID?: boolean | number
    STREET_FIAS_ID?: boolean | number
    STREET_COORDS?: CoordinatesGenqlSelection
    HOUSE?: boolean | number
    HOUSE_FIAS_ID?: boolean | number
    HOUSE_COORDS?: CoordinatesGenqlSelection
    FLAT?: boolean | number
    FLOOR?: boolean | number
    ENTRANCE?: boolean | number
    PRIVATE_HOUSE?: boolean | number
    LIFT?: boolean | number
    RECEIVER_NAME?: boolean | number
    RECEIVER_ANOTHER?: boolean | number
    RECEIVER_PHONE?: boolean | number
    PROFILE_COMMENT?: boolean | number
    ADDRESS_SOURCE?: boolean | number
    ADDRESS_IS_CUSTOM?: boolean | number
    PROFILE_DEFAULT?: boolean | number
    ADDRESS?: boolean | number
    STREET?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DiscountGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: DiscountActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: DiscountActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: DiscountTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: DiscountDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: DiscountPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: DiscountDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: DiscountShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: DiscountPropsGenqlSelection
    CONDITION?: OrderConditionGenqlSelection
    DISCOUNT_PERCENT?: boolean | number
    DISCOUNT_TARGET?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DiscountPropsGenqlSelection{
    TRANSPORT_TYPE?: boolean | number
    PAYMENT_TYPE?: boolean | number
    PRODUCT_ENTITIES?: ElementGenqlSelection
    PRODUCT?: boolean | number
    PRODUCT_SECTION?: boolean | number
    ORDER_PRICE_FROM?: boolean | number
    NAME_TEMPLATE?: boolean | number
    HOTEST?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    DELIVERY_DISCOUNT?: boolean | number
    PRIZE_ENTITY?: ElementGenqlSelection
    PRIZE?: boolean | number
    DISCOUNT_TARGET?: boolean | number
    BENEFIT_TYPE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderConditionGenqlSelection{
    BENEFIT_TYPE?: boolean | number
    PAYMENT_TYPE?: boolean | number
    TRANSPORT_TYPE?: boolean | number
    PRODUCT_SECTION?: boolean | number
    PRODUCT?: boolean | number
    OFFICE_ROLE?: boolean | number
    OFFICE?: boolean | number
    ORDER_PRICE_FROM?: boolean | number
    COUPON?: boolean | number
    PRIZE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryComputedGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    SERVICE?: DeliveryWrapperGenqlSelection
    CALC_TIMESTAMP?: boolean | number
    PRICE?: boolean | number
    PRICE_FORMATED?: boolean | number
    DELIVERY_DISCOUNT_PRICE?: boolean | number
    DELIVERY_DISCOUNT_PRICE_FORMATED?: boolean | number
    PERIOD_TEXT?: boolean | number
    CALCULATE_ERRORS?: boolean | number
    CALCULATE_DESCRIPTION?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryWrapperGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    TRANSPORT_TYPE?: boolean | number
    HOST?: DeliveryServiceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TransportTypeGenqlSelection{
    CODE?: boolean | number
    NAME?: boolean | number
    ICON?: boolean | number
    DISCOUNT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ResponseStateGenqlSelection{
    messages?: MessageGenqlSelection
    events?: boolean | number
    rate?: ResponseRateGenqlSelection
    redirect?: ResponseRedirectGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface MessageGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    code?: boolean | number
    name?: boolean | number
    status?: boolean | number
    title?: boolean | number
    message?: boolean | number
    messages?: boolean | number
    category?: boolean | number
    notify?: boolean | number
    rel?: boolean | number
    duration?: boolean | number
    data?: boolean | number
    actions?: MenuItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ResponseRateGenqlSelection{
    ttl?: boolean | number
    limited?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ResponseRedirectGenqlSelection{
    ttl?: boolean | number
    restricted?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketRuleGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: BasketRuleActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: BasketRuleActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: BasketRuleTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: BasketRuleDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: BasketRulePreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: BasketRuleDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: BasketRuleShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: BasketRulePropsGenqlSelection
    TYPE?: boolean | number
    NAME_TEMPLATE?: boolean | number
    ALL_STOP?: boolean | number
    IS_ADDITIONAL?: boolean | number
    CONDITION?: OrderConditionGenqlSelection
    BENEFITS?: BasketRuleBenefitInterfaceGenqlSelection
    PROMO?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketRulePropsGenqlSelection{
    TYPE?: boolean | number
    CAPTION?: boolean | number
    NAME_TEMPLATE?: boolean | number
    IS_ADDITIONAL?: boolean | number
    ALL_STOP?: boolean | number
    CONDITION_PAYMENT_TYPE?: boolean | number
    CONDITION_TRANSPORT_TYPE?: boolean | number
    CONDITION_ORDER_PRICE_FROM?: boolean | number
    CONDITION_PRODUCT_SECTION?: boolean | number
    CONDITION_PRODUCT_ENTITIES?: ElementGenqlSelection
    CONDITION_PRODUCT?: boolean | number
    CONDITION_OFFICE_ENTITIES?: ElementGenqlSelection
    CONDITION_OFFICE?: boolean | number
    CONDITION_OFFICE_ROLE?: boolean | number
    CONDITION_BENEFIT_TYPE?: boolean | number
    CONDITION_COUPON_ENTITY?: ElementGenqlSelection
    CONDITION_COUPON?: boolean | number
    CONDITION_PRIZE_ENTITY?: ElementGenqlSelection
    CONDITION_PRIZE?: boolean | number
    BENEFITS?: BasketRulePropsBenefitsGenqlSelection
    DISCOUNT_PERCENT?: boolean | number
    BENEFITS_PRODUCT_ID_ENTITIES?: ElementGenqlSelection
    PRODUCT_ID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketRulePropsBenefitsGenqlSelection{
    TYPE?: boolean | number
    DISCOUNT_PERCENT?: boolean | number
    PRODUCT_ID?: boolean | number
    UID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BasketGenqlSelection{
    TS?: boolean | number
    SYNCED?: boolean | number
    BASE_PRICE?: boolean | number
    PRICE?: boolean | number
    COUNT?: boolean | number
    QUANTITY?: boolean | number
    ITEMS?: BasketItemGenqlSelection
    WEIGHT?: boolean | number
    MIN_PRICE?: boolean | number
    MIN_PRICE_REACHED?: boolean | number
    HASH?: boolean | number
    OFFERS?: SpecialOfferGenqlSelection
    GIFTS?: boolean | number
    CLIENT_CHANGED_AT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SpecialOfferGenqlSelection{
    MIN_PRICE?: boolean | number
    MODE?: boolean | number
    ELEMENT_ID?: boolean | number
    ELEMENT?: ProductGenqlSelection
    TYPE?: boolean | number
    TYPE_INFO?: SpecialOfferTypeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SpecialOfferTypeGenqlSelection{
    NAME?: boolean | number
    CODE?: boolean | number
    COLOR?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderSummaryGenqlSelection{
    ID?: boolean | number
    PHONE?: boolean | number
    EMAIL?: boolean | number
    FUSER_ID?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderProfileRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: OrderProfileGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ClientCardFilterInput {ID?: (IntFilterInput | null),BONUSES?: (IntFilterInput | null),FETCHED?: (Scalars['Boolean'] | null),FETCHED_TIME?: (DateFilterInput | null),USER_ID?: (IntFilterInput | null),CLIENT_PHONE?: (StringFilterInput | null),LEVEL_CODE?: (StringFilterInput | null),LEVEL_NAME?: (StringFilterInput | null),MONTH_SPENT?: (IntFilterInput | null),BONUSES_EXPIRE?: (DateFilterInput | null),BONUSES_PERCENT?: (IntFilterInput | null),DIS_FIRST_ORDER?: (IntFilterInput | null),DIS_SELF_PICKUP?: (IntFilterInput | null)}

export interface DateFilterInput {eq?: (Scalars['String'] | null),in?: ((Scalars['String'] | null)[] | null),not?: (Scalars['String'] | null),gt?: (Scalars['String'] | null),lt?: (Scalars['String'] | null)}

export interface SaleClientCardGenqlSelection{
    ID?: boolean | number
    BONUSES?: boolean | number
    FETCHED?: boolean | number
    FETCHED_TIME_FORMATTED?: boolean | number
    FETCHED_TIME?: boolean | number
    USER_ID?: boolean | number
    CLIENT_PHONE?: boolean | number
    LEVEL_CODE?: boolean | number
    LEVEL_NAME?: boolean | number
    MONTH_SPENT?: boolean | number
    BONUSES_EXPIRE_FORMATTED?: boolean | number
    BONUSES_EXPIRE?: boolean | number
    BONUSES_PERCENT?: boolean | number
    DIS_FIRST_ORDER?: boolean | number
    DIS_SELF_PICKUP?: boolean | number
    LEVEL?: BonusLevelGenqlSelection
    DISCOUNTS?: DiscountGenqlSelection
    FETCHED_ACTUAL?: boolean | number
    EXPIRED?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BonusLevelGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: BonusLevelActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: BonusLevelActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: BonusLevelTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: BonusLevelDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: BonusLevelPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: BonusLevelDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: BonusLevelShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: BonusLevelPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface BonusLevelPropsGenqlSelection{
    ORDERS_SUMM?: boolean | number
    ACCUMULATION_PERCENT?: boolean | number
    MAX_USE_PERCENT?: boolean | number
    COLOR?: boolean | number
    MONTH_SPENT_MIN?: boolean | number
    MONTH_SPENT_MAX?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ClientCardRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: SaleClientCardGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryZoneGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: DeliveryZonePreviewTextArgs } | boolean | number
    PROPERTIES?: DeliveryZonePropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryZonePropsGenqlSelection{
    PRICE_TEXT?: boolean | number
    PRICE_BY_DELIVERY?: boolean | number
    PRICE_BY_KM?: boolean | number
    FREE_TEXT?: boolean | number
    FREE_FROM_PRICE?: boolean | number
    GEOJSON?: boolean | number
    OUTSIDE?: boolean | number
    COLOR?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductIngredientGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    URL?: boolean | number
    PROPERTIES?: ProductIngredientPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductIngredientPropsGenqlSelection{
    SHOW_IN_FILTER?: boolean | number
    ALIASES?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ModificatorGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    SECTION?: ModificatorSectionGenqlSelection
    TYPE?: boolean | number
    LIMIT?: boolean | number
    QUANTITY_LIMIT?: boolean | number
    REQUIRED?: boolean | number
    IS_GLOBAL?: boolean | number
    ORDER_PRICE_FROM?: boolean | number
    CONDITION?: OrderConditionGenqlSelection
    PRODUCT_COMPONENT?: boolean | number
    PRODUCT_COMPONENT_PROPS?: boolean | number
    PRODUCT_COMPONENT_STYLE?: boolean | number
    OPTIONS?: ModificatorOptionGenqlSelection
    CODE_PATH?: boolean | number
    ID_PATH?: boolean | number
    DEFAULT_VALUE?: boolean | number
    GROUP_CODE?: boolean | number
    POSITIONS?: boolean | number
    OPTION_INFO_TYPE?: boolean | number
    FEATURES?: boolean | number
    PROPERTIES?: ModificatorPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ModificatorSectionGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_TYPE_ID?: boolean | number
    IBLOCK_EXTERNAL_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    TIMESTAMP_X?: { __args: ModificatorSectionTimestampXArgs } | boolean | number
    ACTIVE?: boolean | number
    PICTURE?: ImageGenqlSelection
    DETAIL_PICTURE?: ImageGenqlSelection
    DESCRIPTION?: boolean | number
    DESCRIPTION_TYPE?: boolean | number
    LEFT_MARGIN?: boolean | number
    RIGHT_MARGIN?: boolean | number
    DEPTH_LEVEL?: boolean | number
    SEARCHABLE_CONTENT?: { __args: ModificatorSectionSearchableContentArgs } | boolean | number
    SECTION_PAGE_URL?: boolean | number
    DATE_CREATE?: { __args: ModificatorSectionDateCreateArgs } | boolean | number
    PARENT?: ModificatorSectionGenqlSelection
    PARENTS?: ModificatorSectionGenqlSelection
    ELEMENT_CNT?: boolean | number
    META?: ElementMetaGenqlSelection
    REPLACE_LINK?: boolean | number
    CHILDREN?: SectionGenqlSelection
    PROPERTIES?: ModificatorSectionPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ModificatorSectionPropsGenqlSelection{
    LIMIT?: boolean | number
    TYPE?: boolean | number
    REQUIRED?: boolean | number
    QUANTITY_LIMIT?: boolean | number
    PRODUCT_COMPONENT?: boolean | number
    PRODUCT_COM_PROPS?: boolean | number
    IS_GROUP?: boolean | number
    PRODUCT_COM_STYLE?: boolean | number
    CARD_POS?: boolean | number
    OPTION_INFO_TYPE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ModificatorOptionGenqlSelection{
    UID?: boolean | number
    NAME?: boolean | number
    PRODUCT_ID?: boolean | number
    QUANTITY?: boolean | number
    QUANTITY_LIMIT?: boolean | number
    IMAGE?: ImageGenqlSelection
    DEFAULT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ModificatorPropsGenqlSelection{
    OVERRIDE_PARENT?: boolean | number
    TYPE?: boolean | number
    REQUIRED?: boolean | number
    LIMIT?: boolean | number
    QUANTITY_LIMIT?: boolean | number
    PRODUCT_COMPONENT?: boolean | number
    PRODUCT_COMPONENT_PROPS?: boolean | number
    PRODUCT_COMPONENT_STYLE?: boolean | number
    CARD_POSITION?: boolean | number
    DETAIL_POSITION?: boolean | number
    PRODUCTS?: ModificatorPropsProductsGenqlSelection
    PRODUCTS_PRODUCT_ID_ENTITIES?: ElementGenqlSelection
    PRODUCT_ID?: boolean | number
    QUANTITY?: boolean | number
    UID?: boolean | number
    NAME?: boolean | number
    IMAGE?: ImageGenqlSelection
    DEFAULT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ModificatorPropsProductsGenqlSelection{
    PRODUCT_ID?: boolean | number
    QUANTITY?: boolean | number
    QUANTITY_LIMIT?: boolean | number
    UID?: boolean | number
    NAME?: boolean | number
    IMAGE?: ImageGenqlSelection
    DEFAULT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductFlagGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    URL?: boolean | number
    PROPERTIES?: ProductFlagPropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductFlagPropsGenqlSelection{
    NAME_SHORT?: boolean | number
    TEXT_COLOR?: boolean | number
    BG_COLOR?: boolean | number
    IMAGE?: ImageGenqlSelection
    ICON?: boolean | number
    CLASS?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderRestrictionGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: OrderRestrictionActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: OrderRestrictionActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: OrderRestrictionTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: OrderRestrictionDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: OrderRestrictionPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: OrderRestrictionDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: OrderRestrictionShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: OrderRestrictionPropsGenqlSelection
    SCHEDULE?: boolean | number
    SCHEDULE_DESC?: boolean | number
    SCHEDULE_ACTIVE?: boolean | number
    CONDITION?: OrderConditionGenqlSelection
    ITEM_ERROR_NAME?: boolean | number
    ITEM_MESSAGE?: boolean | number
    MESSAGE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface OrderRestrictionPropsGenqlSelection{
    TRANSPORT_TYPE?: boolean | number
    OFFICE_ROLE?: boolean | number
    OFFICE_ENTITIES?: ElementGenqlSelection
    OFFICE?: boolean | number
    PAYMENT_TYPE?: boolean | number
    PRODUCT_ENTITIES?: ElementGenqlSelection
    PRODUCT?: boolean | number
    PRODUCT_SECTION?: boolean | number
    MESSAGE?: boolean | number
    ITEM_MESSAGE?: boolean | number
    SCHEDULE?: boolean | number
    ITEM_ERROR_NAME?: boolean | number
    SECTION?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SectionFilterInput {ID?: (IntFilterInput | null),ACTIVE?: (Scalars['Boolean'] | null),GLOBAL_ACTIVE?: (Scalars['Boolean'] | null),NAME?: (StringFilterInput | null),CODE?: (StringFilterInput | null),XML_ID?: (StringFilterInput | null),SECTION_ID?: (IntFilterInput | null),DEPTH_LEVEL?: (IntFilterInput | null),LEFT_BORDER?: (IntFilterInput | null),RIGHT_BORDER?: (IntFilterInput | null),LEFT_MARGIN?: (IntFilterInput | null),RIGHT_MARGIN?: (IntFilterInput | null),IBLOCK_ID?: (IntFilterInput | null),IBLOCK_ACTIVE?: (Scalars['Boolean'] | null),IBLOCK_NAME?: (StringFilterInput | null),IBLOCK_TYPE?: (StringFilterInput | null),HAS_ELEMENT?: (IntFilterInput | null),MENU_BG_COLOR?: (StringFilterInput | null),TITLE_IRKUTSK?: (StringFilterInput | null),DESCR_IRKUTSK?: (StringFilterInput | null),H1_IRKUTSK?: (StringFilterInput | null),TITLE_ANGARSK?: (StringFilterInput | null),DESCR_ANGARSK?: (StringFilterInput | null),H1_ANGARSK?: (StringFilterInput | null),TITLE_KRASNOYARSK?: (StringFilterInput | null),DESCR_KRASNOYARSK?: (StringFilterInput | null),H1_KRASNOYARSK?: (StringFilterInput | null),NAV_URL?: (StringFilterInput | null),NAV_TITLE?: (StringFilterInput | null),HINT?: (StringFilterInput | null),CATEGORY_CLASS?: (StringFilterInput | null),SEARCH_IN?: (StringFilterInput | null),REPLACE_LINK?: (StringFilterInput | null),M_CARD?: (StringFilterInput | null),MENU_ICON?: (StringFilterInput | null),MENU_FOCUSED_ICON?: (StringFilterInput | null),MENU_ITEM_STYLE?: (StringFilterInput | null),MENU_COLOR?: (StringFilterInput | null),UPSALE_SECTIONS?: (StringFilterInput | null),MODIFICATORS?: (StringFilterInput | null)}

export interface ProductSectionGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_TYPE_ID?: boolean | number
    IBLOCK_EXTERNAL_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    TIMESTAMP_X?: { __args: ProductSectionTimestampXArgs } | boolean | number
    ACTIVE?: boolean | number
    PICTURE?: ImageGenqlSelection
    DETAIL_PICTURE?: ImageGenqlSelection
    DESCRIPTION?: boolean | number
    DESCRIPTION_TYPE?: boolean | number
    LEFT_MARGIN?: boolean | number
    RIGHT_MARGIN?: boolean | number
    DEPTH_LEVEL?: boolean | number
    SEARCHABLE_CONTENT?: { __args: ProductSectionSearchableContentArgs } | boolean | number
    SECTION_PAGE_URL?: boolean | number
    DATE_CREATE?: { __args: ProductSectionDateCreateArgs } | boolean | number
    PARENT?: ProductSectionGenqlSelection
    PARENTS?: ProductSectionGenqlSelection
    ELEMENT_CNT?: boolean | number
    META?: ElementMetaGenqlSelection
    REPLACE_LINK?: boolean | number
    CHILDREN?: SectionGenqlSelection
    PROPERTIES?: ProductSectionPropsGenqlSelection
    FEATURE_IDS?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ProductSectionPropsGenqlSelection{
    MENU_BG_COLOR?: boolean | number
    TITLE_IRKUTSK?: boolean | number
    DESCR_IRKUTSK?: boolean | number
    H1_IRKUTSK?: boolean | number
    TITLE_ANGARSK?: boolean | number
    DESCR_ANGARSK?: boolean | number
    H1_ANGARSK?: boolean | number
    TITLE_KRASNOYARSK?: boolean | number
    DESCR_KRASNOYARSK?: boolean | number
    H1_KRASNOYARSK?: boolean | number
    NAV_URL?: boolean | number
    NAV_TITLE?: boolean | number
    HINT?: boolean | number
    CATEGORY_CLASS?: boolean | number
    SEARCH_IN?: boolean | number
    REPLACE_LINK?: boolean | number
    M_CARD?: boolean | number
    MENU_ICON?: ImageGenqlSelection
    MENU_FOCUSED_ICON?: ImageGenqlSelection
    MENU_ITEM_STYLE?: boolean | number
    MENU_COLOR?: boolean | number
    UPSALE_SECTIONS?: boolean | number
    MODIFICATORS_ENTITY?: ModificatorGenqlSelection
    MODIFICATORS?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ClientSegmentGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: ClientSegmentActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: ClientSegmentActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: ClientSegmentTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: ClientSegmentDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: ClientSegmentPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: ClientSegmentDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: ClientSegmentShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ClientSegmentRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: ClientSegmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FeatureGenqlSelection{
    ACTIVE?: boolean | number
    AVAILABLE?: AvailableStatusGenqlSelection
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE_FROM?: { __args: FeatureActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: FeatureActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: FeatureTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: FeatureDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: FeaturePreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: FeatureDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: FeatureShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: FeaturePropsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface AvailableStatusGenqlSelection{
    STATUS?: boolean | number
    REASON?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FeaturePropsGenqlSelection{
    MODEL_CLASS?: boolean | number
    SEGMENTS_ENTITIES?: ElementGenqlSelection
    SEGMENTS?: boolean | number
    SCHEDULE_ENABLE?: boolean | number
    SCHEDULE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FeatureRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: FeatureGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CallTrackingPhoneGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: CallTrackingPhoneActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: CallTrackingPhoneActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: CallTrackingPhoneTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: CallTrackingPhoneDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: CallTrackingPhonePreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: CallTrackingPhoneDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: CallTrackingPhoneShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    PROPERTIES?: CallTrackingPhonePropsGenqlSelection
    PHONE_NUMBER?: boolean | number
    IS_DEFAULT?: boolean | number
    IS_RESERVED?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CallTrackingPhonePropsGenqlSelection{
    PHONE_NUMBER?: boolean | number
    CLIENT_ID?: boolean | number
    USER_ID?: boolean | number
    RESERVED_AT?: boolean | number
    IS_DEFAULT?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface YandexMetricGoalGenqlSelection{
    ID?: boolean | number
    NAME?: boolean | number
    CODE?: boolean | number
    SORT?: boolean | number
    IBLOCK_ID?: boolean | number
    IBLOCK_CODE?: boolean | number
    IBLOCK_SECTION_ID?: boolean | number
    ACTIVE?: boolean | number
    ACTIVE_FROM?: { __args: YandexMetricGoalActiveFromArgs } | boolean | number
    ACTIVE_TO?: { __args: YandexMetricGoalActiveToArgs } | boolean | number
    TIMESTAMP_X?: { __args: YandexMetricGoalTimestampXArgs } | boolean | number
    DATE_CREATE?: { __args: YandexMetricGoalDateCreateArgs } | boolean | number
    CREATED_BY?: boolean | number
    CREATED_USER_NAME?: boolean | number
    MODIFIED_BY?: boolean | number
    PREVIEW_PICTURE?: ImageGenqlSelection
    PREVIEW_TEXT?: { __args: YandexMetricGoalPreviewTextArgs } | boolean | number
    PREVIEW_TEXT_TYPE?: boolean | number
    DETAIL_PICTURE?: ImageGenqlSelection
    DETAIL_TEXT?: { __args: YandexMetricGoalDetailTextArgs } | boolean | number
    DETAIL_TEXT_TYPE?: boolean | number
    SHOW_COUNTER?: boolean | number
    SHOW_COUNTER_START?: { __args: YandexMetricGoalShowCounterStartArgs } | boolean | number
    TAGS?: boolean | number
    XML_ID?: boolean | number
    EXTERNAL_ID?: boolean | number
    SECTION_ID?: boolean | number
    IBLOCK_SECTION_IDS?: boolean | number
    URL?: boolean | number
    PATH?: SectionGenqlSelection
    SECTIONS?: SectionGenqlSelection
    SECTION?: SectionGenqlSelection
    ROOT_SECTION?: SectionGenqlSelection
    META?: ElementMetaGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface YandexMetricGoalRecordsetGenqlSelection{
    info?: QueryInfoGenqlSelection
    nodes?: YandexMetricGoalGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface MutationGenqlSelection{
    testMutationcreate?: (TestmutationcreateResultGenqlSelection & { __args: MutationTestMutationcreateArgs })
    testMutationupdate?: (TestmutationupdateResultGenqlSelection & { __args: MutationTestMutationupdateArgs })
    testMutationdelete?: (ResponseGenqlSelection & { __args?: MutationTestMutationdeleteArgs })
    hook_mutation?: ResponseGenqlSelection
    notice_pub_sync_readed?: (NoticePubSyncReadedResultGenqlSelection & { __args?: MutationNoticePubSyncReadedArgs })
    notice_pub_push_send_queue?: ResponseGenqlSelection
    notice_pub_push_update_token?: (ResponseGenqlSelection & { __args?: MutationNoticePubPushUpdateTokenArgs })
    user_auth_create_sa?: (ResponseGenqlSelection & { __args?: MutationUserAuthCreateSaArgs })
    user_auth_login_start?: (UserAuthLoginStartResultGenqlSelection & { __args?: MutationUserAuthLoginStartArgs })
    user_auth_login_request?: (UserAuthLoginRequestResultGenqlSelection & { __args?: MutationUserAuthLoginRequestArgs })
    user_auth_login_confirm?: (UserAuthLoginConfirmResultGenqlSelection & { __args?: MutationUserAuthLoginConfirmArgs })
    user_app_client?: (ResponseGenqlSelection & { __args?: MutationUserAppClientArgs })
    user_profile_save?: (ResponseGenqlSelection & { __args?: MutationUserProfileSaveArgs })
    user_logout?: ResponseGenqlSelection
    user_profile_name?: (UserProfileNameResultGenqlSelection & { __args?: MutationUserProfileNameArgs })
    user_profile_birthday?: (UserProfileBirthdayResultGenqlSelection & { __args?: MutationUserProfileBirthdayArgs })
    user_profile_email?: (UserProfileEmailResultGenqlSelection & { __args?: MutationUserProfileEmailArgs })
    company_office_update?: (CompanyOfficeUpdateResultGenqlSelection & { __args: MutationCompanyOfficeUpdateArgs })
    company_vacancy_order?: (ResponseGenqlSelection & { __args?: MutationCompanyVacancyOrderArgs })
    push_subscribe?: (PushSubscribeResultGenqlSelection & { __args: MutationPushSubscribeArgs })
    push_unsubscribe?: PushUnsubscribeResultGenqlSelection
    push_send_test?: (PushSendTestResultGenqlSelection & { __args: MutationPushSendTestArgs })
    fortune_spin?: FortuneSpinResultGenqlSelection
    telegram_create?: (TelegramCreateResultGenqlSelection & { __args: MutationTelegramCreateArgs })
    telegram_update?: (TelegramUpdateResultGenqlSelection & { __args: MutationTelegramUpdateArgs })
    telegram_delete?: (ResponseGenqlSelection & { __args?: MutationTelegramDeleteArgs })
    telegram_auth_by_phone?: (TelegramAuthByPhoneResultGenqlSelection & { __args: MutationTelegramAuthByPhoneArgs })
    review_service_review?: (ReviewServiceReviewResultGenqlSelection & { __args?: MutationReviewServiceReviewArgs })
    review_order_guest_review?: (ReviewOrderGuestReviewResultGenqlSelection & { __args?: MutationReviewOrderGuestReviewArgs })
    catalog_product_order?: (ResponseGenqlSelection & { __args?: MutationCatalogProductOrderArgs })
    sale_order_test?: SaleOrderTestResultGenqlSelection
    sale_order_pay_online?: (SaleOrderPayOnlineResultGenqlSelection & { __args?: MutationSaleOrderPayOnlineArgs })
    sale_order_repeat?: (SaleOrderRepeatResultGenqlSelection & { __args?: MutationSaleOrderRepeatArgs })
    sale_order_cancel?: (SaleOrderCancelResultGenqlSelection & { __args?: MutationSaleOrderCancelArgs })
    vorder_new?: VorderNewResultGenqlSelection
    vorder_apply?: (VorderApplyResultGenqlSelection & { __args?: MutationVorderApplyArgs })
    vorder_basket?: (VorderBasketResultGenqlSelection & { __args?: MutationVorderBasketArgs })
    vorder_delivery_calculate?: (VorderDeliveryCalculateResultGenqlSelection & { __args?: MutationVorderDeliveryCalculateArgs })
    vorder_coupon?: (VorderCouponResultGenqlSelection & { __args?: MutationVorderCouponArgs })
    vorder_submit?: (VorderSubmitResultGenqlSelection & { __args?: MutationVorderSubmitArgs })
    vorder_sync?: (VorderSyncResultGenqlSelection & { __args?: MutationVorderSyncArgs })
    sale_profile_default?: (SaleProfileDefaultResultGenqlSelection & { __args?: MutationSaleProfileDefaultArgs })
    sale_profile_delete?: (SaleProfileDeleteResultGenqlSelection & { __args?: MutationSaleProfileDeleteArgs })
    sale_profile_save?: (SaleProfileSaveResultGenqlSelection & { __args?: MutationSaleProfileSaveArgs })
    sale_profile_calc_delivery?: (SaleProfileCalcDeliveryResultGenqlSelection & { __args?: MutationSaleProfileCalcDeliveryArgs })
    sale_client_card_create?: (SaleClientCardCreateResultGenqlSelection & { __args: MutationSaleClientCardCreateArgs })
    sale_client_card_update?: (SaleClientCardUpdateResultGenqlSelection & { __args: MutationSaleClientCardUpdateArgs })
    sale_client_card_delete?: (ResponseGenqlSelection & { __args?: MutationSaleClientCardDeleteArgs })
    call_tracking_request_phone?: CallTrackingRequestPhoneResultGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TestItemInput {name: Scalars['String'],description?: (Scalars['String'] | null)}

export interface TestmutationcreateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: TestItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TestmutationupdateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: TestItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ResponseGenqlSelection{
    success?: boolean | number
    state?: ResponseStateGenqlSelection
    payload?: boolean | number
    error?: ErrorInterfaceGenqlSelection
    errors?: ErrorInterfaceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface NoticePubSyncReadedResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: ClientNoticeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CaptchaInput {SID?: (Scalars['String'] | null),PROVIDER?: (Scalars['String'] | null),ANSWER?: (Scalars['String'] | null),VALUE?: (Scalars['Json'] | null)}

export interface UserAuthLoginStartResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: UserAuthLoginStartResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthLoginStartResultPayloadGenqlSelection{
    confirmModes?: UserAuthConfirmGenqlSelection
    discounts?: DiscountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthConfirmGenqlSelection{
    NAME?: boolean | number
    CODE?: boolean | number
    COLOR?: boolean | number
    ICON?: boolean | number
    LIST_NAME?: boolean | number
    LIST_CAPTION?: boolean | number
    LIST_BUTTON_MOBILE?: MenuItemMobileGenqlSelection
    LIST_BUTTON_WEB?: MenuItemGenqlSelection
    CONFIRM_CONTENT_MOBILE?: boolean | number
    CONFIRM_CONTENT_WEB?: boolean | number
    CONFIRM_STEPS?: UserAuthConfirmStepGenqlSelection
    RESEND_TITLE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthConfirmStepGenqlSelection{
    CODE?: boolean | number
    NAME?: boolean | number
    CAPTION?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthLoginRequestResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: UserAuthLoginRequestResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthLoginRequestResultPayloadGenqlSelection{
    rateTtl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthLoginConfirmResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: UserAuthLoginConfirmResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserAuthLoginConfirmResultPayloadGenqlSelection{
    appClient?: AppClientGenqlSelection
    sessionId?: boolean | number
    userId?: boolean | number
    redirect?: boolean | number
    isNew?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserProfileNameResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserProfileBirthdayResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface UserProfileEmailResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CompanyOfficeInput {IBLOCK_ID?: (Scalars['Int'] | null),NAME?: (Scalars['String'] | null),CODE?: (Scalars['String'] | null),PROPERTIES?: (CompanyOfficeInputProps | null)}

export interface CompanyOfficeInputProps {MAIN?: (Scalars['String'] | null),ADDRESS?: (Scalars['String'] | null),PHONES?: (Scalars['String'][] | null),EMAIL?: (Scalars['String'] | null),COORDINATES?: (CoordinatesInput | null),REQUISITES?: (Scalars['String'] | null),ROLES?: (Scalars['Int'][] | null),WORKTIME?: (Scalars['String'] | null),SERVICE_ID?: (Scalars['String'] | null),PAYSYSTEM_ID?: (Scalars['Int'] | null),GIS_URL?: (Scalars['String'] | null),INFO_URL?: (Scalars['String'] | null)}

export interface CoordinatesInput {LON?: (Scalars['Float'] | null),LAT?: (Scalars['Float'] | null)}

export interface CompanyOfficeUpdateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: CompanyOfficeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushSubscribeResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: PushSubscribeResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushSubscribeResultPayloadGenqlSelection{
    appClient?: AppClientGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushUnsubscribeResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: PushUnsubscribeResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushUnsubscribeResultPayloadGenqlSelection{
    appClient?: AppClientGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushSendTestResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: PushSendTestResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface PushSendTestResultPayloadGenqlSelection{
    success?: boolean | number
    sent?: boolean | number
    failed?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FortuneSpinResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: FortuneSpinResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface FortuneSpinResultPayloadGenqlSelection{
    userPrize?: FortuneUserPrizeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TelegramChatInput {CHAT_ID: Scalars['String'],TELEGRAM_ID: Scalars['String'],USER_ID?: (Scalars['Int'] | null),PHONE?: (Scalars['String'] | null),STATUS?: (Scalars['String'] | null)}

export interface TelegramCreateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: TelegramChatGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TelegramUpdateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: TelegramChatGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TelegramAuthByPhoneResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: TelegramAuthByPhoneResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface TelegramAuthByPhoneResultPayloadGenqlSelection{
    userId?: boolean | number
    userName?: boolean | number
    phone?: boolean | number
    token?: boolean | number
    chatId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ReviewServiceReviewResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: ReviewGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ReviewOrderGuestReviewResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: ReviewOrderGuestReviewResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ReviewOrderGuestReviewResultPayloadGenqlSelection{
    redirectUrl?: boolean | number
    departmentId?: boolean | number
    departmentName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleOrderTestResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: SaleOrderTestResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleOrderTestResultPayloadGenqlSelection{
    num?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleOrderPayOnlineResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: SaleOrderPayOnlineResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleOrderPayOnlineResultPayloadGenqlSelection{
    paymentUrl?: boolean | number
    price?: boolean | number
    order?: OrderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleOrderRepeatResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: OrderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleOrderCancelResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: OrderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderNewResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderNewResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderNewResultPayloadGenqlSelection{
    vorder?: VorderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderGenqlSelection{
    ID?: boolean | number
    SESSION_ID?: boolean | number
    FUSER_ID?: boolean | number
    USER_ID?: boolean | number
    USER?: UserGenqlSelection
    ORDER_ID?: boolean | number
    FIELDS_RAW?: boolean | number
    PROPS_RAW?: boolean | number
    PHONE?: boolean | number
    EMAIL?: boolean | number
    ORDER?: OrderGenqlSelection
    PROFILE_ID?: boolean | number
    DELIVERY_DEPARTMENT_ID?: boolean | number
    PICKUP_DEPARTMENT_ID?: boolean | number
    DEPARTMENT_ID?: boolean | number
    BONUSES?: boolean | number
    COUPONS?: CouponGenqlSelection
    BASKET?: (BasketGenqlSelection & { __args?: VorderBasketArgs })
    ATTR?: OrderAttributesValueGenqlSelection
    ATTRS?: OrderAttributeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderInput {attrs?: (OrderAttributesValueInput | null),basket?: (Scalars['Json'] | null),vorderId?: (Scalars['Int'] | null)}

export interface OrderAttributesValueInput {DETAILS?: (Scalars['Boolean'] | null),UUID?: (Scalars['String'] | null),FIO?: (Scalars['String'] | null),PHONE?: (Scalars['String'] | null),EMAIL?: (Scalars['String'] | null),DELIVERY_TYPE?: (Scalars['Json'] | null),DELIVERY_DEPARTMENT?: (Scalars['Int'] | null),STREET_PATH?: (Scalars['String'] | null),CITY?: (Scalars['String'] | null),CITY_FIAS_ID?: (Scalars['String'] | null),SETTLEMENT?: (Scalars['String'] | null),SETTLEMENT_FIAS_ID?: (Scalars['String'] | null),STREET_FIAS_ID?: (Scalars['String'] | null),STREET_COORDS?: (CoordinatesInput | null),HOUSE?: (Scalars['String'] | null),HOUSE_FIAS_ID?: (Scalars['String'] | null),HOUSE_COORDS?: (CoordinatesInput | null),FLAT?: (Scalars['String'] | null),LOCATION?: (Scalars['String'] | null),INTERCOM?: (Scalars['String'] | null),FLOOR?: (Scalars['String'] | null),ENTRANCE?: (Scalars['String'] | null),PRIVATE_HOUSE?: (Scalars['Boolean'] | null),LIFT?: (Scalars['Boolean'] | null),PICKUP_DEPARTMENT?: (Scalars['Json'] | null),TIME_MODE?: (AttrTimeModeEnum | null),DATE?: (Scalars['String'] | null),TIME?: (Scalars['Json'] | null),PAYMENT_TYPE?: (AttrPaymentTypeEnum | null),CASH_SUM?: (Scalars['Int'] | null),BONUSES?: (Scalars['String'] | null),PROMOCODE?: (Scalars['String'] | null),DELIVERY_PRICE?: (Scalars['Int'] | null),RECEIVER_NAME?: (Scalars['String'] | null),RECEIVER_ANOTHER?: (Scalars['Boolean'] | null),RECEIVER_PHONE?: (Scalars['String'] | null),PERSONS_NUMBER?: (Scalars['Int'] | null),COMMENT?: (Scalars['String'] | null),GIFTS_LIST?: (Scalars['String'] | null),WITH_OPERATOR?: (Scalars['Boolean'] | null),ROISTAT?: (Scalars['String'] | null),NEED_CONFIRM?: (Scalars['Boolean'] | null),PROFILE_COMMENT?: (Scalars['String'] | null),ADDRESS_SOURCE?: (Scalars['String'] | null),PROFILE_ID?: (Scalars['Int'] | null),ADDRESS_IS_CUSTOM?: (Scalars['Boolean'] | null),PROFILE_DEFAULT?: (Scalars['Boolean'] | null),VORDER_ID?: (Scalars['Int'] | null),SERVICE_SEND?: (Scalars['Boolean'] | null),DATETIME?: (Scalars['Int'] | null),SERVICE_SEND_START?: (Scalars['Int'] | null),DATA?: (OrderDataInput | null),RESERVE_SUCCESS_HASH?: (Scalars['String'] | null),DISCOUNT_REASON?: (Scalars['String'] | null),DISCOUNT_PERCENT?: (Scalars['Int'] | null),ADDRESS?: (Scalars['String'] | null),BENEFIT_TYPE?: (BenefitTypeEnum | null),DELIVERY_FREE_FROM_PRICE?: (Scalars['String'] | null),STREET?: (Scalars['String'] | null),DEPARTMENT_SERVICE_ID?: (Scalars['Int'] | null),DELIVERY_FREE_UPDATED_TIME?: (Scalars['Int'] | null),IS_ACCEPTED?: (Scalars['Boolean'] | null),TEST_TIME?: (Scalars['Int'] | null),STRUCT?: (Scalars['String'] | null),TRANSPORT_TYPE?: (AttrTransportTypeEnum | null),COUPON_ID?: (Scalars['Int'] | null),PRIZE_ID?: (Scalars['Int'] | null),SESSION_ID?: (Scalars['String'] | null),PAYMENT_GIFT?: (Scalars['String'] | null),TEST_TIME_NEW?: (Scalars['Int'] | null),APP_VERSION?: (Scalars['String'] | null),SOURCE?: (Scalars['String'] | null),RESERVE_REQUEST_TIME?: (Scalars['Int'] | null),UTM_SOURCE?: (Scalars['String'] | null),RESERVE_AVAILABLE_TIME?: (Scalars['Int'] | null),RESERVE_NEED_TIME?: (Scalars['Int'] | null),RESERVE_STATUS?: (Scalars['String'] | null),RESERVE_SUCCESS_REQUEST_TIME?: (Scalars['Int'] | null),UTM_MEDIUM?: (Scalars['String'] | null),UTM_CAMPAIGN?: (Scalars['String'] | null),UTM_TERM?: (Scalars['String'] | null),UTM_CONTENT?: (Scalars['String'] | null),UTM_LANDING_URL?: (Scalars['String'] | null),DELIVERY_ID?: (Scalars['Int'] | null),PAY_SYSTEM_ID?: (Scalars['Int'] | null),USER_DESCRIPTION?: (Scalars['String'] | null)}

export interface OrderDataInput {paramInt?: (Scalars['Int'] | null),paramString?: (Scalars['String'] | null),paramArray?: (Scalars['Json'] | null)}

export interface VorderApplyResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderApplyResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderApplyResultPayloadGenqlSelection{
    vorder?: VorderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderBasketResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderBasketResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderBasketResultPayloadGenqlSelection{
    vorder?: VorderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryCalculateInput {time?: (Scalars['Int'] | null),mode?: (TimeModeEnum | null)}

export interface VorderDeliveryCalculateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderDeliveryCalculateResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderDeliveryCalculateResultPayloadGenqlSelection{
    vorder?: VorderCurrentGenqlSelection
    calc?: DeliveryCalculateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface DeliveryCalculateGenqlSelection{
    ID?: boolean | number
    VORDER_ID?: boolean | number
    REQUEST_DELTA?: boolean | number
    DELIVERY_HASH?: boolean | number
    ORDER_ID?: boolean | number
    DELIVERY_ADDRESS?: boolean | number
    REQUEST_TIME_FORMATTED?: boolean | number
    REQUEST_TIME?: boolean | number
    NEED_TIME_FORMATTED?: boolean | number
    NEED_TIME?: boolean | number
    ORDER_PRICE?: boolean | number
    RES_DELIVER_PRICE?: boolean | number
    RES_TIME_FORMATTED?: boolean | number
    RES_TIME?: boolean | number
    RES_OFFICE_1C_ID?: boolean | number
    RES_OFFICE_ID?: boolean | number
    ADDRESS_COORDS?: boolean | number
    PHONE?: boolean | number
    RES_STATUS?: boolean | number
    TRANSPORT_TYPE?: boolean | number
    TIME_MODE?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderCouponResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderCouponResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderCouponResultPayloadGenqlSelection{
    vorder?: VorderCurrentGenqlSelection
    coupon?: CouponGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderSubmitResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderSubmitResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderSubmitResultPayloadGenqlSelection{
    vorder?: VorderCurrentGenqlSelection
    newVorderId?: boolean | number
    orderId?: boolean | number
    orderUrl?: boolean | number
    order?: OrderGenqlSelection
    activeOrders?: OrderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderSyncResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: VorderSyncResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface VorderSyncResultPayloadGenqlSelection{
    vorder?: VorderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleProfileDefaultResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: OrderProfileGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleProfileDeleteResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleProfileSaveResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: OrderProfileGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleProfileCalcDeliveryResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: DeliveryCalculateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface ElementInput {IBLOCK_ID?: (Scalars['Int'] | null),NAME?: (Scalars['String'] | null),CODE?: (Scalars['String'] | null)}

export interface SaleClientCardCreateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: SaleClientCardGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface SaleClientCardUpdateResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: SaleClientCardGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CallTrackingRequestPhoneResultGenqlSelection{
    success?: boolean | number
    errors?: ErrorInterfaceGenqlSelection
    error?: ErrorInterfaceGenqlSelection
    state?: ResponseStateGenqlSelection
    payload?: CallTrackingRequestPhoneResultPayloadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}

export interface CallTrackingRequestPhoneResultPayloadGenqlSelection{
    phone?: CallTrackingPhoneGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
    __fragment?: JsonFragmentName
}


    const CommonError_possibleTypes: string[] = ['CommonError']
    export const isCommonError = (obj?: { __typename?: any } | null): obj is CommonError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCommonError"')
      return CommonError_possibleTypes.includes(obj.__typename)
    }
    


    const ErrorInterface_possibleTypes: string[] = ['CommonError','RateError','OtpError','AccessError','FormError','ExternalServiceError','ProtocolError','InternalError','UserError','VorderError']
    export const isErrorInterface = (obj?: { __typename?: any } | null): obj is ErrorInterface => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isErrorInterface"')
      return ErrorInterface_possibleTypes.includes(obj.__typename)
    }
    


    const RateError_possibleTypes: string[] = ['RateError']
    export const isRateError = (obj?: { __typename?: any } | null): obj is RateError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRateError"')
      return RateError_possibleTypes.includes(obj.__typename)
    }
    


    const OtpError_possibleTypes: string[] = ['OtpError']
    export const isOtpError = (obj?: { __typename?: any } | null): obj is OtpError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOtpError"')
      return OtpError_possibleTypes.includes(obj.__typename)
    }
    


    const AccessError_possibleTypes: string[] = ['AccessError']
    export const isAccessError = (obj?: { __typename?: any } | null): obj is AccessError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccessError"')
      return AccessError_possibleTypes.includes(obj.__typename)
    }
    


    const FormError_possibleTypes: string[] = ['FormError']
    export const isFormError = (obj?: { __typename?: any } | null): obj is FormError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFormError"')
      return FormError_possibleTypes.includes(obj.__typename)
    }
    


    const ExternalServiceError_possibleTypes: string[] = ['ExternalServiceError']
    export const isExternalServiceError = (obj?: { __typename?: any } | null): obj is ExternalServiceError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExternalServiceError"')
      return ExternalServiceError_possibleTypes.includes(obj.__typename)
    }
    


    const ProtocolError_possibleTypes: string[] = ['ProtocolError']
    export const isProtocolError = (obj?: { __typename?: any } | null): obj is ProtocolError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProtocolError"')
      return ProtocolError_possibleTypes.includes(obj.__typename)
    }
    


    const InternalError_possibleTypes: string[] = ['InternalError']
    export const isInternalError = (obj?: { __typename?: any } | null): obj is InternalError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInternalError"')
      return InternalError_possibleTypes.includes(obj.__typename)
    }
    


    const UserError_possibleTypes: string[] = ['UserError']
    export const isUserError = (obj?: { __typename?: any } | null): obj is UserError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserError"')
      return UserError_possibleTypes.includes(obj.__typename)
    }
    


    const BasketRuleBenefitDiscount_possibleTypes: string[] = ['BasketRuleBenefitDiscount']
    export const isBasketRuleBenefitDiscount = (obj?: { __typename?: any } | null): obj is BasketRuleBenefitDiscount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketRuleBenefitDiscount"')
      return BasketRuleBenefitDiscount_possibleTypes.includes(obj.__typename)
    }
    


    const BasketRuleBenefitInterface_possibleTypes: string[] = ['BasketRuleBenefitDiscount','BasketRuleBenefitGift']
    export const isBasketRuleBenefitInterface = (obj?: { __typename?: any } | null): obj is BasketRuleBenefitInterface => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketRuleBenefitInterface"')
      return BasketRuleBenefitInterface_possibleTypes.includes(obj.__typename)
    }
    


    const BasketRuleBenefitGift_possibleTypes: string[] = ['BasketRuleBenefitGift']
    export const isBasketRuleBenefitGift = (obj?: { __typename?: any } | null): obj is BasketRuleBenefitGift => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketRuleBenefitGift"')
      return BasketRuleBenefitGift_possibleTypes.includes(obj.__typename)
    }
    


    const VorderError_possibleTypes: string[] = ['VorderError']
    export const isVorderError = (obj?: { __typename?: any } | null): obj is VorderError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderError"')
      return VorderError_possibleTypes.includes(obj.__typename)
    }
    


    const Query_possibleTypes: string[] = ['Query']
    export const isQuery = (obj?: { __typename?: any } | null): obj is Query => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuery"')
      return Query_possibleTypes.includes(obj.__typename)
    }
    


    const TestItem_possibleTypes: string[] = ['TestItem']
    export const isTestItem = (obj?: { __typename?: any } | null): obj is TestItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTestItem"')
      return TestItem_possibleTypes.includes(obj.__typename)
    }
    


    const EntityOption_possibleTypes: string[] = ['EntityOption']
    export const isEntityOption = (obj?: { __typename?: any } | null): obj is EntityOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityOption"')
      return EntityOption_possibleTypes.includes(obj.__typename)
    }
    


    const EntityType_possibleTypes: string[] = ['EntityType']
    export const isEntityType = (obj?: { __typename?: any } | null): obj is EntityType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityType"')
      return EntityType_possibleTypes.includes(obj.__typename)
    }
    


    const EntityProviderType_possibleTypes: string[] = ['EntityProviderType']
    export const isEntityProviderType = (obj?: { __typename?: any } | null): obj is EntityProviderType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityProviderType"')
      return EntityProviderType_possibleTypes.includes(obj.__typename)
    }
    


    const EntityComputedField_possibleTypes: string[] = ['EntityComputedField']
    export const isEntityComputedField = (obj?: { __typename?: any } | null): obj is EntityComputedField => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityComputedField"')
      return EntityComputedField_possibleTypes.includes(obj.__typename)
    }
    


    const EntityComputedFieldValueOption_possibleTypes: string[] = ['EntityComputedFieldValueOption']
    export const isEntityComputedFieldValueOption = (obj?: { __typename?: any } | null): obj is EntityComputedFieldValueOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityComputedFieldValueOption"')
      return EntityComputedFieldValueOption_possibleTypes.includes(obj.__typename)
    }
    


    const Menu_possibleTypes: string[] = ['Menu']
    export const isMenu = (obj?: { __typename?: any } | null): obj is Menu => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMenu"')
      return Menu_possibleTypes.includes(obj.__typename)
    }
    


    const MenuItem_possibleTypes: string[] = ['MenuItem']
    export const isMenuItem = (obj?: { __typename?: any } | null): obj is MenuItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMenuItem"')
      return MenuItem_possibleTypes.includes(obj.__typename)
    }
    


    const Command_possibleTypes: string[] = ['Command']
    export const isCommand = (obj?: { __typename?: any } | null): obj is Command => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCommand"')
      return Command_possibleTypes.includes(obj.__typename)
    }
    


    const Image_possibleTypes: string[] = ['Image']
    export const isImage = (obj?: { __typename?: any } | null): obj is Image => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isImage"')
      return Image_possibleTypes.includes(obj.__typename)
    }
    


    const ClientEmit_possibleTypes: string[] = ['ClientEmit']
    export const isClientEmit = (obj?: { __typename?: any } | null): obj is ClientEmit => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClientEmit"')
      return ClientEmit_possibleTypes.includes(obj.__typename)
    }
    


    const ClientNotice_possibleTypes: string[] = ['ClientNotice']
    export const isClientNotice = (obj?: { __typename?: any } | null): obj is ClientNotice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClientNotice"')
      return ClientNotice_possibleTypes.includes(obj.__typename)
    }
    


    const UserSession_possibleTypes: string[] = ['UserSession']
    export const isUserSession = (obj?: { __typename?: any } | null): obj is UserSession => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserSession"')
      return UserSession_possibleTypes.includes(obj.__typename)
    }
    


    const User_possibleTypes: string[] = ['User']
    export const isUser = (obj?: { __typename?: any } | null): obj is User => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUser"')
      return User_possibleTypes.includes(obj.__typename)
    }
    


    const UserGroup_possibleTypes: string[] = ['UserGroup']
    export const isUserGroup = (obj?: { __typename?: any } | null): obj is UserGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserGroup"')
      return UserGroup_possibleTypes.includes(obj.__typename)
    }
    


    const EntityProp_possibleTypes: string[] = ['EntityProp']
    export const isEntityProp = (obj?: { __typename?: any } | null): obj is EntityProp => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityProp"')
      return EntityProp_possibleTypes.includes(obj.__typename)
    }
    


    const UserAvatar_possibleTypes: string[] = ['UserAvatar']
    export const isUserAvatar = (obj?: { __typename?: any } | null): obj is UserAvatar => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAvatar"')
      return UserAvatar_possibleTypes.includes(obj.__typename)
    }
    


    const UserFamily_possibleTypes: string[] = ['UserFamily']
    export const isUserFamily = (obj?: { __typename?: any } | null): obj is UserFamily => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserFamily"')
      return UserFamily_possibleTypes.includes(obj.__typename)
    }
    


    const AppClient_possibleTypes: string[] = ['AppClient']
    export const isAppClient = (obj?: { __typename?: any } | null): obj is AppClient => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAppClient"')
      return AppClient_possibleTypes.includes(obj.__typename)
    }
    


    const AppClientDebugParams_possibleTypes: string[] = ['AppClientDebugParams']
    export const isAppClientDebugParams = (obj?: { __typename?: any } | null): obj is AppClientDebugParams => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAppClientDebugParams"')
      return AppClientDebugParams_possibleTypes.includes(obj.__typename)
    }
    


    const Page_possibleTypes: string[] = ['Page']
    export const isPage = (obj?: { __typename?: any } | null): obj is Page => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPage"')
      return Page_possibleTypes.includes(obj.__typename)
    }
    


    const Section_possibleTypes: string[] = ['Section']
    export const isSection = (obj?: { __typename?: any } | null): obj is Section => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSection"')
      return Section_possibleTypes.includes(obj.__typename)
    }
    


    const ElementMeta_possibleTypes: string[] = ['ElementMeta']
    export const isElementMeta = (obj?: { __typename?: any } | null): obj is ElementMeta => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isElementMeta"')
      return ElementMeta_possibleTypes.includes(obj.__typename)
    }
    


    const PageProps_possibleTypes: string[] = ['PageProps']
    export const isPageProps = (obj?: { __typename?: any } | null): obj is PageProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageProps"')
      return PageProps_possibleTypes.includes(obj.__typename)
    }
    


    const ElementPropValueWithDesc_possibleTypes: string[] = ['ElementPropValueWithDesc']
    export const isElementPropValueWithDesc = (obj?: { __typename?: any } | null): obj is ElementPropValueWithDesc => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isElementPropValueWithDesc"')
      return ElementPropValueWithDesc_possibleTypes.includes(obj.__typename)
    }
    


    const PagePropsChunks_possibleTypes: string[] = ['PagePropsChunks']
    export const isPagePropsChunks = (obj?: { __typename?: any } | null): obj is PagePropsChunks => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPagePropsChunks"')
      return PagePropsChunks_possibleTypes.includes(obj.__typename)
    }
    


    const ElementPropValueHtml_possibleTypes: string[] = ['ElementPropValueHtml']
    export const isElementPropValueHtml = (obj?: { __typename?: any } | null): obj is ElementPropValueHtml => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isElementPropValueHtml"')
      return ElementPropValueHtml_possibleTypes.includes(obj.__typename)
    }
    


    const PageDataChunk_possibleTypes: string[] = ['PageDataChunk']
    export const isPageDataChunk = (obj?: { __typename?: any } | null): obj is PageDataChunk => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageDataChunk"')
      return PageDataChunk_possibleTypes.includes(obj.__typename)
    }
    


    const PageContentChunk_possibleTypes: string[] = ['PageContentChunk']
    export const isPageContentChunk = (obj?: { __typename?: any } | null): obj is PageContentChunk => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageContentChunk"')
      return PageContentChunk_possibleTypes.includes(obj.__typename)
    }
    


    const PageRecordset_possibleTypes: string[] = ['PageRecordset']
    export const isPageRecordset = (obj?: { __typename?: any } | null): obj is PageRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageRecordset"')
      return PageRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const QueryInfo_possibleTypes: string[] = ['QueryInfo']
    export const isQueryInfo = (obj?: { __typename?: any } | null): obj is QueryInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQueryInfo"')
      return QueryInfo_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyOffice_possibleTypes: string[] = ['CompanyOffice']
    export const isCompanyOffice = (obj?: { __typename?: any } | null): obj is CompanyOffice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyOffice"')
      return CompanyOffice_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyOfficeProps_possibleTypes: string[] = ['CompanyOfficeProps']
    export const isCompanyOfficeProps = (obj?: { __typename?: any } | null): obj is CompanyOfficeProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyOfficeProps"')
      return CompanyOfficeProps_possibleTypes.includes(obj.__typename)
    }
    


    const Coordinates_possibleTypes: string[] = ['Coordinates']
    export const isCoordinates = (obj?: { __typename?: any } | null): obj is Coordinates => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCoordinates"')
      return Coordinates_possibleTypes.includes(obj.__typename)
    }
    


    const ListValue_possibleTypes: string[] = ['ListValue']
    export const isListValue = (obj?: { __typename?: any } | null): obj is ListValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isListValue"')
      return ListValue_possibleTypes.includes(obj.__typename)
    }
    


    const OfficeRecordset_possibleTypes: string[] = ['OfficeRecordset']
    export const isOfficeRecordset = (obj?: { __typename?: any } | null): obj is OfficeRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOfficeRecordset"')
      return OfficeRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyVacancy_possibleTypes: string[] = ['CompanyVacancy']
    export const isCompanyVacancy = (obj?: { __typename?: any } | null): obj is CompanyVacancy => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyVacancy"')
      return CompanyVacancy_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyVacancyProps_possibleTypes: string[] = ['CompanyVacancyProps']
    export const isCompanyVacancyProps = (obj?: { __typename?: any } | null): obj is CompanyVacancyProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyVacancyProps"')
      return CompanyVacancyProps_possibleTypes.includes(obj.__typename)
    }
    


    const VacancyRecordset_possibleTypes: string[] = ['VacancyRecordset']
    export const isVacancyRecordset = (obj?: { __typename?: any } | null): obj is VacancyRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVacancyRecordset"')
      return VacancyRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const FaqQuestion_possibleTypes: string[] = ['FaqQuestion']
    export const isFaqQuestion = (obj?: { __typename?: any } | null): obj is FaqQuestion => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqQuestion"')
      return FaqQuestion_possibleTypes.includes(obj.__typename)
    }
    


    const FaqQuestionRecordset_possibleTypes: string[] = ['FaqQuestionRecordset']
    export const isFaqQuestionRecordset = (obj?: { __typename?: any } | null): obj is FaqQuestionRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqQuestionRecordset"')
      return FaqQuestionRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const GeoObject_possibleTypes: string[] = ['GeoObject']
    export const isGeoObject = (obj?: { __typename?: any } | null): obj is GeoObject => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGeoObject"')
      return GeoObject_possibleTypes.includes(obj.__typename)
    }
    


    const SearchSuggestion_possibleTypes: string[] = ['SearchSuggestion']
    export const isSearchSuggestion = (obj?: { __typename?: any } | null): obj is SearchSuggestion => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSearchSuggestion"')
      return SearchSuggestion_possibleTypes.includes(obj.__typename)
    }
    


    const SearchSuggestionData_possibleTypes: string[] = ['SearchSuggestionData']
    export const isSearchSuggestionData = (obj?: { __typename?: any } | null): obj is SearchSuggestionData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSearchSuggestionData"')
      return SearchSuggestionData_possibleTypes.includes(obj.__typename)
    }
    


    const Offer_possibleTypes: string[] = ['Offer']
    export const isOffer = (obj?: { __typename?: any } | null): obj is Offer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOffer"')
      return Offer_possibleTypes.includes(obj.__typename)
    }
    


    const OfferSlide_possibleTypes: string[] = ['OfferSlide']
    export const isOfferSlide = (obj?: { __typename?: any } | null): obj is OfferSlide => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOfferSlide"')
      return OfferSlide_possibleTypes.includes(obj.__typename)
    }
    


    const MenuItemMobile_possibleTypes: string[] = ['MenuItemMobile']
    export const isMenuItemMobile = (obj?: { __typename?: any } | null): obj is MenuItemMobile => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMenuItemMobile"')
      return MenuItemMobile_possibleTypes.includes(obj.__typename)
    }
    


    const ActionMobile_possibleTypes: string[] = ['ActionMobile']
    export const isActionMobile = (obj?: { __typename?: any } | null): obj is ActionMobile => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isActionMobile"')
      return ActionMobile_possibleTypes.includes(obj.__typename)
    }
    


    const Condition_possibleTypes: string[] = ['Condition']
    export const isCondition = (obj?: { __typename?: any } | null): obj is Condition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCondition"')
      return Condition_possibleTypes.includes(obj.__typename)
    }
    


    const OfferRecordset_possibleTypes: string[] = ['OfferRecordset']
    export const isOfferRecordset = (obj?: { __typename?: any } | null): obj is OfferRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOfferRecordset"')
      return OfferRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const PushSubscriber_possibleTypes: string[] = ['PushSubscriber']
    export const isPushSubscriber = (obj?: { __typename?: any } | null): obj is PushSubscriber => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushSubscriber"')
      return PushSubscriber_possibleTypes.includes(obj.__typename)
    }
    


    const FortunePrize_possibleTypes: string[] = ['FortunePrize']
    export const isFortunePrize = (obj?: { __typename?: any } | null): obj is FortunePrize => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFortunePrize"')
      return FortunePrize_possibleTypes.includes(obj.__typename)
    }
    


    const FortunePrizeProps_possibleTypes: string[] = ['FortunePrizeProps']
    export const isFortunePrizeProps = (obj?: { __typename?: any } | null): obj is FortunePrizeProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFortunePrizeProps"')
      return FortunePrizeProps_possibleTypes.includes(obj.__typename)
    }
    


    const Element_possibleTypes: string[] = ['Element']
    export const isElement = (obj?: { __typename?: any } | null): obj is Element => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isElement"')
      return Element_possibleTypes.includes(obj.__typename)
    }
    


    const FortuneUserPrize_possibleTypes: string[] = ['FortuneUserPrize']
    export const isFortuneUserPrize = (obj?: { __typename?: any } | null): obj is FortuneUserPrize => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFortuneUserPrize"')
      return FortuneUserPrize_possibleTypes.includes(obj.__typename)
    }
    


    const TelegramChat_possibleTypes: string[] = ['TelegramChat']
    export const isTelegramChat = (obj?: { __typename?: any } | null): obj is TelegramChat => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTelegramChat"')
      return TelegramChat_possibleTypes.includes(obj.__typename)
    }
    


    const TelegramChatRecordset_possibleTypes: string[] = ['TelegramChatRecordset']
    export const isTelegramChatRecordset = (obj?: { __typename?: any } | null): obj is TelegramChatRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTelegramChatRecordset"')
      return TelegramChatRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const Webcam_possibleTypes: string[] = ['Webcam']
    export const isWebcam = (obj?: { __typename?: any } | null): obj is Webcam => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWebcam"')
      return Webcam_possibleTypes.includes(obj.__typename)
    }
    


    const WebcamProps_possibleTypes: string[] = ['WebcamProps']
    export const isWebcamProps = (obj?: { __typename?: any } | null): obj is WebcamProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWebcamProps"')
      return WebcamProps_possibleTypes.includes(obj.__typename)
    }
    


    const Review_possibleTypes: string[] = ['Review']
    export const isReview = (obj?: { __typename?: any } | null): obj is Review => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReview"')
      return Review_possibleTypes.includes(obj.__typename)
    }
    


    const ReviewProps_possibleTypes: string[] = ['ReviewProps']
    export const isReviewProps = (obj?: { __typename?: any } | null): obj is ReviewProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReviewProps"')
      return ReviewProps_possibleTypes.includes(obj.__typename)
    }
    


    const Order_possibleTypes: string[] = ['Order']
    export const isOrder = (obj?: { __typename?: any } | null): obj is Order => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrder"')
      return Order_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryService_possibleTypes: string[] = ['DeliveryService']
    export const isDeliveryService = (obj?: { __typename?: any } | null): obj is DeliveryService => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryService"')
      return DeliveryService_possibleTypes.includes(obj.__typename)
    }
    


    const Paysystem_possibleTypes: string[] = ['Paysystem']
    export const isPaysystem = (obj?: { __typename?: any } | null): obj is Paysystem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaysystem"')
      return Paysystem_possibleTypes.includes(obj.__typename)
    }
    


    const BasketItem_possibleTypes: string[] = ['BasketItem']
    export const isBasketItem = (obj?: { __typename?: any } | null): obj is BasketItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketItem"')
      return BasketItem_possibleTypes.includes(obj.__typename)
    }
    


    const BasketItemDiscount_possibleTypes: string[] = ['BasketItemDiscount']
    export const isBasketItemDiscount = (obj?: { __typename?: any } | null): obj is BasketItemDiscount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketItemDiscount"')
      return BasketItemDiscount_possibleTypes.includes(obj.__typename)
    }
    


    const Product_possibleTypes: string[] = ['Product']
    export const isProduct = (obj?: { __typename?: any } | null): obj is Product => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProduct"')
      return Product_possibleTypes.includes(obj.__typename)
    }
    


    const ProductProps_possibleTypes: string[] = ['ProductProps']
    export const isProductProps = (obj?: { __typename?: any } | null): obj is ProductProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductProps"')
      return ProductProps_possibleTypes.includes(obj.__typename)
    }
    


    const ProductPropsSetItems_possibleTypes: string[] = ['ProductPropsSetItems']
    export const isProductPropsSetItems = (obj?: { __typename?: any } | null): obj is ProductPropsSetItems => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductPropsSetItems"')
      return ProductPropsSetItems_possibleTypes.includes(obj.__typename)
    }
    


    const ProductPrice_possibleTypes: string[] = ['ProductPrice']
    export const isProductPrice = (obj?: { __typename?: any } | null): obj is ProductPrice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductPrice"')
      return ProductPrice_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMeasure_possibleTypes: string[] = ['ProductMeasure']
    export const isProductMeasure = (obj?: { __typename?: any } | null): obj is ProductMeasure => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMeasure"')
      return ProductMeasure_possibleTypes.includes(obj.__typename)
    }
    


    const Ingredient_possibleTypes: string[] = ['Ingredient']
    export const isIngredient = (obj?: { __typename?: any } | null): obj is Ingredient => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIngredient"')
      return Ingredient_possibleTypes.includes(obj.__typename)
    }
    


    const BasketBuildItem_possibleTypes: string[] = ['BasketBuildItem']
    export const isBasketBuildItem = (obj?: { __typename?: any } | null): obj is BasketBuildItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketBuildItem"')
      return BasketBuildItem_possibleTypes.includes(obj.__typename)
    }
    


    const BasketItemProps_possibleTypes: string[] = ['BasketItemProps']
    export const isBasketItemProps = (obj?: { __typename?: any } | null): obj is BasketItemProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketItemProps"')
      return BasketItemProps_possibleTypes.includes(obj.__typename)
    }
    


    const OrderStatus_possibleTypes: string[] = ['OrderStatus']
    export const isOrderStatus = (obj?: { __typename?: any } | null): obj is OrderStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderStatus"')
      return OrderStatus_possibleTypes.includes(obj.__typename)
    }
    


    const Payment_possibleTypes: string[] = ['Payment']
    export const isPayment = (obj?: { __typename?: any } | null): obj is Payment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayment"')
      return Payment_possibleTypes.includes(obj.__typename)
    }
    


    const OrderScope_possibleTypes: string[] = ['OrderScope']
    export const isOrderScope = (obj?: { __typename?: any } | null): obj is OrderScope => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderScope"')
      return OrderScope_possibleTypes.includes(obj.__typename)
    }
    


    const Coupon_possibleTypes: string[] = ['Coupon']
    export const isCoupon = (obj?: { __typename?: any } | null): obj is Coupon => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCoupon"')
      return Coupon_possibleTypes.includes(obj.__typename)
    }
    


    const CourierState_possibleTypes: string[] = ['CourierState']
    export const isCourierState = (obj?: { __typename?: any } | null): obj is CourierState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCourierState"')
      return CourierState_possibleTypes.includes(obj.__typename)
    }
    


    const OrderCancelReason_possibleTypes: string[] = ['OrderCancelReason']
    export const isOrderCancelReason = (obj?: { __typename?: any } | null): obj is OrderCancelReason => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderCancelReason"')
      return OrderCancelReason_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAttributesValue_possibleTypes: string[] = ['OrderAttributesValue']
    export const isOrderAttributesValue = (obj?: { __typename?: any } | null): obj is OrderAttributesValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAttributesValue"')
      return OrderAttributesValue_possibleTypes.includes(obj.__typename)
    }
    


    const OrderData_possibleTypes: string[] = ['OrderData']
    export const isOrderData = (obj?: { __typename?: any } | null): obj is OrderData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderData"')
      return OrderData_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAttributesView_possibleTypes: string[] = ['OrderAttributesView']
    export const isOrderAttributesView = (obj?: { __typename?: any } | null): obj is OrderAttributesView => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAttributesView"')
      return OrderAttributesView_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAttribute_possibleTypes: string[] = ['OrderAttribute']
    export const isOrderAttribute = (obj?: { __typename?: any } | null): obj is OrderAttribute => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAttribute"')
      return OrderAttribute_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAttributeOption_possibleTypes: string[] = ['OrderAttributeOption']
    export const isOrderAttributeOption = (obj?: { __typename?: any } | null): obj is OrderAttributeOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAttributeOption"')
      return OrderAttributeOption_possibleTypes.includes(obj.__typename)
    }
    


    const AppProductRecordset_possibleTypes: string[] = ['AppProductRecordset']
    export const isAppProductRecordset = (obj?: { __typename?: any } | null): obj is AppProductRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAppProductRecordset"')
      return AppProductRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const SearchResult_possibleTypes: string[] = ['SearchResult']
    export const isSearchResult = (obj?: { __typename?: any } | null): obj is SearchResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSearchResult"')
      return SearchResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderCurrent_possibleTypes: string[] = ['VorderCurrent']
    export const isVorderCurrent = (obj?: { __typename?: any } | null): obj is VorderCurrent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderCurrent"')
      return VorderCurrent_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryPriceRule_possibleTypes: string[] = ['DeliveryPriceRule']
    export const isDeliveryPriceRule = (obj?: { __typename?: any } | null): obj is DeliveryPriceRule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryPriceRule"')
      return DeliveryPriceRule_possibleTypes.includes(obj.__typename)
    }
    


    const PersonType_possibleTypes: string[] = ['PersonType']
    export const isPersonType = (obj?: { __typename?: any } | null): obj is PersonType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPersonType"')
      return PersonType_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentType_possibleTypes: string[] = ['PaymentType']
    export const isPaymentType = (obj?: { __typename?: any } | null): obj is PaymentType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentType"')
      return PaymentType_possibleTypes.includes(obj.__typename)
    }
    


    const OrderProfile_possibleTypes: string[] = ['OrderProfile']
    export const isOrderProfile = (obj?: { __typename?: any } | null): obj is OrderProfile => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderProfile"')
      return OrderProfile_possibleTypes.includes(obj.__typename)
    }
    


    const OrderProfileAttributesValue_possibleTypes: string[] = ['OrderProfileAttributesValue']
    export const isOrderProfileAttributesValue = (obj?: { __typename?: any } | null): obj is OrderProfileAttributesValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderProfileAttributesValue"')
      return OrderProfileAttributesValue_possibleTypes.includes(obj.__typename)
    }
    


    const Discount_possibleTypes: string[] = ['Discount']
    export const isDiscount = (obj?: { __typename?: any } | null): obj is Discount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDiscount"')
      return Discount_possibleTypes.includes(obj.__typename)
    }
    


    const DiscountProps_possibleTypes: string[] = ['DiscountProps']
    export const isDiscountProps = (obj?: { __typename?: any } | null): obj is DiscountProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDiscountProps"')
      return DiscountProps_possibleTypes.includes(obj.__typename)
    }
    


    const OrderCondition_possibleTypes: string[] = ['OrderCondition']
    export const isOrderCondition = (obj?: { __typename?: any } | null): obj is OrderCondition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderCondition"')
      return OrderCondition_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryComputed_possibleTypes: string[] = ['DeliveryComputed']
    export const isDeliveryComputed = (obj?: { __typename?: any } | null): obj is DeliveryComputed => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryComputed"')
      return DeliveryComputed_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryWrapper_possibleTypes: string[] = ['DeliveryWrapper']
    export const isDeliveryWrapper = (obj?: { __typename?: any } | null): obj is DeliveryWrapper => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryWrapper"')
      return DeliveryWrapper_possibleTypes.includes(obj.__typename)
    }
    


    const TransportType_possibleTypes: string[] = ['TransportType']
    export const isTransportType = (obj?: { __typename?: any } | null): obj is TransportType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransportType"')
      return TransportType_possibleTypes.includes(obj.__typename)
    }
    


    const ResponseState_possibleTypes: string[] = ['ResponseState']
    export const isResponseState = (obj?: { __typename?: any } | null): obj is ResponseState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isResponseState"')
      return ResponseState_possibleTypes.includes(obj.__typename)
    }
    


    const Message_possibleTypes: string[] = ['Message']
    export const isMessage = (obj?: { __typename?: any } | null): obj is Message => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMessage"')
      return Message_possibleTypes.includes(obj.__typename)
    }
    


    const ResponseRate_possibleTypes: string[] = ['ResponseRate']
    export const isResponseRate = (obj?: { __typename?: any } | null): obj is ResponseRate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isResponseRate"')
      return ResponseRate_possibleTypes.includes(obj.__typename)
    }
    


    const ResponseRedirect_possibleTypes: string[] = ['ResponseRedirect']
    export const isResponseRedirect = (obj?: { __typename?: any } | null): obj is ResponseRedirect => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isResponseRedirect"')
      return ResponseRedirect_possibleTypes.includes(obj.__typename)
    }
    


    const BasketRule_possibleTypes: string[] = ['BasketRule']
    export const isBasketRule = (obj?: { __typename?: any } | null): obj is BasketRule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketRule"')
      return BasketRule_possibleTypes.includes(obj.__typename)
    }
    


    const BasketRuleProps_possibleTypes: string[] = ['BasketRuleProps']
    export const isBasketRuleProps = (obj?: { __typename?: any } | null): obj is BasketRuleProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketRuleProps"')
      return BasketRuleProps_possibleTypes.includes(obj.__typename)
    }
    


    const BasketRulePropsBenefits_possibleTypes: string[] = ['BasketRulePropsBenefits']
    export const isBasketRulePropsBenefits = (obj?: { __typename?: any } | null): obj is BasketRulePropsBenefits => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasketRulePropsBenefits"')
      return BasketRulePropsBenefits_possibleTypes.includes(obj.__typename)
    }
    


    const Basket_possibleTypes: string[] = ['Basket']
    export const isBasket = (obj?: { __typename?: any } | null): obj is Basket => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBasket"')
      return Basket_possibleTypes.includes(obj.__typename)
    }
    


    const SpecialOffer_possibleTypes: string[] = ['SpecialOffer']
    export const isSpecialOffer = (obj?: { __typename?: any } | null): obj is SpecialOffer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSpecialOffer"')
      return SpecialOffer_possibleTypes.includes(obj.__typename)
    }
    


    const SpecialOfferType_possibleTypes: string[] = ['SpecialOfferType']
    export const isSpecialOfferType = (obj?: { __typename?: any } | null): obj is SpecialOfferType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSpecialOfferType"')
      return SpecialOfferType_possibleTypes.includes(obj.__typename)
    }
    


    const VorderSummary_possibleTypes: string[] = ['VorderSummary']
    export const isVorderSummary = (obj?: { __typename?: any } | null): obj is VorderSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderSummary"')
      return VorderSummary_possibleTypes.includes(obj.__typename)
    }
    


    const OrderProfileRecordset_possibleTypes: string[] = ['OrderProfileRecordset']
    export const isOrderProfileRecordset = (obj?: { __typename?: any } | null): obj is OrderProfileRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderProfileRecordset"')
      return OrderProfileRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const SaleClientCard_possibleTypes: string[] = ['SaleClientCard']
    export const isSaleClientCard = (obj?: { __typename?: any } | null): obj is SaleClientCard => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleClientCard"')
      return SaleClientCard_possibleTypes.includes(obj.__typename)
    }
    


    const BonusLevel_possibleTypes: string[] = ['BonusLevel']
    export const isBonusLevel = (obj?: { __typename?: any } | null): obj is BonusLevel => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBonusLevel"')
      return BonusLevel_possibleTypes.includes(obj.__typename)
    }
    


    const BonusLevelProps_possibleTypes: string[] = ['BonusLevelProps']
    export const isBonusLevelProps = (obj?: { __typename?: any } | null): obj is BonusLevelProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBonusLevelProps"')
      return BonusLevelProps_possibleTypes.includes(obj.__typename)
    }
    


    const ClientCardRecordset_possibleTypes: string[] = ['ClientCardRecordset']
    export const isClientCardRecordset = (obj?: { __typename?: any } | null): obj is ClientCardRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClientCardRecordset"')
      return ClientCardRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryZone_possibleTypes: string[] = ['DeliveryZone']
    export const isDeliveryZone = (obj?: { __typename?: any } | null): obj is DeliveryZone => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryZone"')
      return DeliveryZone_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryZoneProps_possibleTypes: string[] = ['DeliveryZoneProps']
    export const isDeliveryZoneProps = (obj?: { __typename?: any } | null): obj is DeliveryZoneProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryZoneProps"')
      return DeliveryZoneProps_possibleTypes.includes(obj.__typename)
    }
    


    const ProductIngredient_possibleTypes: string[] = ['ProductIngredient']
    export const isProductIngredient = (obj?: { __typename?: any } | null): obj is ProductIngredient => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductIngredient"')
      return ProductIngredient_possibleTypes.includes(obj.__typename)
    }
    


    const ProductIngredientProps_possibleTypes: string[] = ['ProductIngredientProps']
    export const isProductIngredientProps = (obj?: { __typename?: any } | null): obj is ProductIngredientProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductIngredientProps"')
      return ProductIngredientProps_possibleTypes.includes(obj.__typename)
    }
    


    const Modificator_possibleTypes: string[] = ['Modificator']
    export const isModificator = (obj?: { __typename?: any } | null): obj is Modificator => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isModificator"')
      return Modificator_possibleTypes.includes(obj.__typename)
    }
    


    const ModificatorSection_possibleTypes: string[] = ['ModificatorSection']
    export const isModificatorSection = (obj?: { __typename?: any } | null): obj is ModificatorSection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isModificatorSection"')
      return ModificatorSection_possibleTypes.includes(obj.__typename)
    }
    


    const ModificatorSectionProps_possibleTypes: string[] = ['ModificatorSectionProps']
    export const isModificatorSectionProps = (obj?: { __typename?: any } | null): obj is ModificatorSectionProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isModificatorSectionProps"')
      return ModificatorSectionProps_possibleTypes.includes(obj.__typename)
    }
    


    const ModificatorOption_possibleTypes: string[] = ['ModificatorOption']
    export const isModificatorOption = (obj?: { __typename?: any } | null): obj is ModificatorOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isModificatorOption"')
      return ModificatorOption_possibleTypes.includes(obj.__typename)
    }
    


    const ModificatorProps_possibleTypes: string[] = ['ModificatorProps']
    export const isModificatorProps = (obj?: { __typename?: any } | null): obj is ModificatorProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isModificatorProps"')
      return ModificatorProps_possibleTypes.includes(obj.__typename)
    }
    


    const ModificatorPropsProducts_possibleTypes: string[] = ['ModificatorPropsProducts']
    export const isModificatorPropsProducts = (obj?: { __typename?: any } | null): obj is ModificatorPropsProducts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isModificatorPropsProducts"')
      return ModificatorPropsProducts_possibleTypes.includes(obj.__typename)
    }
    


    const ProductFlag_possibleTypes: string[] = ['ProductFlag']
    export const isProductFlag = (obj?: { __typename?: any } | null): obj is ProductFlag => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductFlag"')
      return ProductFlag_possibleTypes.includes(obj.__typename)
    }
    


    const ProductFlagProps_possibleTypes: string[] = ['ProductFlagProps']
    export const isProductFlagProps = (obj?: { __typename?: any } | null): obj is ProductFlagProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductFlagProps"')
      return ProductFlagProps_possibleTypes.includes(obj.__typename)
    }
    


    const OrderRestriction_possibleTypes: string[] = ['OrderRestriction']
    export const isOrderRestriction = (obj?: { __typename?: any } | null): obj is OrderRestriction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderRestriction"')
      return OrderRestriction_possibleTypes.includes(obj.__typename)
    }
    


    const OrderRestrictionProps_possibleTypes: string[] = ['OrderRestrictionProps']
    export const isOrderRestrictionProps = (obj?: { __typename?: any } | null): obj is OrderRestrictionProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderRestrictionProps"')
      return OrderRestrictionProps_possibleTypes.includes(obj.__typename)
    }
    


    const ProductSection_possibleTypes: string[] = ['ProductSection']
    export const isProductSection = (obj?: { __typename?: any } | null): obj is ProductSection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductSection"')
      return ProductSection_possibleTypes.includes(obj.__typename)
    }
    


    const ProductSectionProps_possibleTypes: string[] = ['ProductSectionProps']
    export const isProductSectionProps = (obj?: { __typename?: any } | null): obj is ProductSectionProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductSectionProps"')
      return ProductSectionProps_possibleTypes.includes(obj.__typename)
    }
    


    const ClientSegment_possibleTypes: string[] = ['ClientSegment']
    export const isClientSegment = (obj?: { __typename?: any } | null): obj is ClientSegment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClientSegment"')
      return ClientSegment_possibleTypes.includes(obj.__typename)
    }
    


    const ClientSegmentRecordset_possibleTypes: string[] = ['ClientSegmentRecordset']
    export const isClientSegmentRecordset = (obj?: { __typename?: any } | null): obj is ClientSegmentRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClientSegmentRecordset"')
      return ClientSegmentRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const Feature_possibleTypes: string[] = ['Feature']
    export const isFeature = (obj?: { __typename?: any } | null): obj is Feature => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFeature"')
      return Feature_possibleTypes.includes(obj.__typename)
    }
    


    const AvailableStatus_possibleTypes: string[] = ['AvailableStatus']
    export const isAvailableStatus = (obj?: { __typename?: any } | null): obj is AvailableStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAvailableStatus"')
      return AvailableStatus_possibleTypes.includes(obj.__typename)
    }
    


    const FeatureProps_possibleTypes: string[] = ['FeatureProps']
    export const isFeatureProps = (obj?: { __typename?: any } | null): obj is FeatureProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFeatureProps"')
      return FeatureProps_possibleTypes.includes(obj.__typename)
    }
    


    const FeatureRecordset_possibleTypes: string[] = ['FeatureRecordset']
    export const isFeatureRecordset = (obj?: { __typename?: any } | null): obj is FeatureRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFeatureRecordset"')
      return FeatureRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const CallTrackingPhone_possibleTypes: string[] = ['CallTrackingPhone']
    export const isCallTrackingPhone = (obj?: { __typename?: any } | null): obj is CallTrackingPhone => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCallTrackingPhone"')
      return CallTrackingPhone_possibleTypes.includes(obj.__typename)
    }
    


    const CallTrackingPhoneProps_possibleTypes: string[] = ['CallTrackingPhoneProps']
    export const isCallTrackingPhoneProps = (obj?: { __typename?: any } | null): obj is CallTrackingPhoneProps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCallTrackingPhoneProps"')
      return CallTrackingPhoneProps_possibleTypes.includes(obj.__typename)
    }
    


    const YandexMetricGoal_possibleTypes: string[] = ['YandexMetricGoal']
    export const isYandexMetricGoal = (obj?: { __typename?: any } | null): obj is YandexMetricGoal => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYandexMetricGoal"')
      return YandexMetricGoal_possibleTypes.includes(obj.__typename)
    }
    


    const YandexMetricGoalRecordset_possibleTypes: string[] = ['YandexMetricGoalRecordset']
    export const isYandexMetricGoalRecordset = (obj?: { __typename?: any } | null): obj is YandexMetricGoalRecordset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYandexMetricGoalRecordset"')
      return YandexMetricGoalRecordset_possibleTypes.includes(obj.__typename)
    }
    


    const Mutation_possibleTypes: string[] = ['Mutation']
    export const isMutation = (obj?: { __typename?: any } | null): obj is Mutation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMutation"')
      return Mutation_possibleTypes.includes(obj.__typename)
    }
    


    const TestmutationcreateResult_possibleTypes: string[] = ['TestmutationcreateResult']
    export const isTestmutationcreateResult = (obj?: { __typename?: any } | null): obj is TestmutationcreateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTestmutationcreateResult"')
      return TestmutationcreateResult_possibleTypes.includes(obj.__typename)
    }
    


    const TestmutationupdateResult_possibleTypes: string[] = ['TestmutationupdateResult']
    export const isTestmutationupdateResult = (obj?: { __typename?: any } | null): obj is TestmutationupdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTestmutationupdateResult"')
      return TestmutationupdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const Response_possibleTypes: string[] = ['Response']
    export const isResponse = (obj?: { __typename?: any } | null): obj is Response => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isResponse"')
      return Response_possibleTypes.includes(obj.__typename)
    }
    


    const NoticePubSyncReadedResult_possibleTypes: string[] = ['NoticePubSyncReadedResult']
    export const isNoticePubSyncReadedResult = (obj?: { __typename?: any } | null): obj is NoticePubSyncReadedResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoticePubSyncReadedResult"')
      return NoticePubSyncReadedResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthLoginStartResult_possibleTypes: string[] = ['UserAuthLoginStartResult']
    export const isUserAuthLoginStartResult = (obj?: { __typename?: any } | null): obj is UserAuthLoginStartResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthLoginStartResult"')
      return UserAuthLoginStartResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthLoginStartResultPayload_possibleTypes: string[] = ['UserAuthLoginStartResultPayload']
    export const isUserAuthLoginStartResultPayload = (obj?: { __typename?: any } | null): obj is UserAuthLoginStartResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthLoginStartResultPayload"')
      return UserAuthLoginStartResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthConfirm_possibleTypes: string[] = ['UserAuthConfirm']
    export const isUserAuthConfirm = (obj?: { __typename?: any } | null): obj is UserAuthConfirm => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthConfirm"')
      return UserAuthConfirm_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthConfirmStep_possibleTypes: string[] = ['UserAuthConfirmStep']
    export const isUserAuthConfirmStep = (obj?: { __typename?: any } | null): obj is UserAuthConfirmStep => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthConfirmStep"')
      return UserAuthConfirmStep_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthLoginRequestResult_possibleTypes: string[] = ['UserAuthLoginRequestResult']
    export const isUserAuthLoginRequestResult = (obj?: { __typename?: any } | null): obj is UserAuthLoginRequestResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthLoginRequestResult"')
      return UserAuthLoginRequestResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthLoginRequestResultPayload_possibleTypes: string[] = ['UserAuthLoginRequestResultPayload']
    export const isUserAuthLoginRequestResultPayload = (obj?: { __typename?: any } | null): obj is UserAuthLoginRequestResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthLoginRequestResultPayload"')
      return UserAuthLoginRequestResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthLoginConfirmResult_possibleTypes: string[] = ['UserAuthLoginConfirmResult']
    export const isUserAuthLoginConfirmResult = (obj?: { __typename?: any } | null): obj is UserAuthLoginConfirmResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthLoginConfirmResult"')
      return UserAuthLoginConfirmResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserAuthLoginConfirmResultPayload_possibleTypes: string[] = ['UserAuthLoginConfirmResultPayload']
    export const isUserAuthLoginConfirmResultPayload = (obj?: { __typename?: any } | null): obj is UserAuthLoginConfirmResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserAuthLoginConfirmResultPayload"')
      return UserAuthLoginConfirmResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const UserProfileNameResult_possibleTypes: string[] = ['UserProfileNameResult']
    export const isUserProfileNameResult = (obj?: { __typename?: any } | null): obj is UserProfileNameResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserProfileNameResult"')
      return UserProfileNameResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserProfileBirthdayResult_possibleTypes: string[] = ['UserProfileBirthdayResult']
    export const isUserProfileBirthdayResult = (obj?: { __typename?: any } | null): obj is UserProfileBirthdayResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserProfileBirthdayResult"')
      return UserProfileBirthdayResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserProfileEmailResult_possibleTypes: string[] = ['UserProfileEmailResult']
    export const isUserProfileEmailResult = (obj?: { __typename?: any } | null): obj is UserProfileEmailResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserProfileEmailResult"')
      return UserProfileEmailResult_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyOfficeUpdateResult_possibleTypes: string[] = ['CompanyOfficeUpdateResult']
    export const isCompanyOfficeUpdateResult = (obj?: { __typename?: any } | null): obj is CompanyOfficeUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyOfficeUpdateResult"')
      return CompanyOfficeUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const PushSubscribeResult_possibleTypes: string[] = ['PushSubscribeResult']
    export const isPushSubscribeResult = (obj?: { __typename?: any } | null): obj is PushSubscribeResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushSubscribeResult"')
      return PushSubscribeResult_possibleTypes.includes(obj.__typename)
    }
    


    const PushSubscribeResultPayload_possibleTypes: string[] = ['PushSubscribeResultPayload']
    export const isPushSubscribeResultPayload = (obj?: { __typename?: any } | null): obj is PushSubscribeResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushSubscribeResultPayload"')
      return PushSubscribeResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const PushUnsubscribeResult_possibleTypes: string[] = ['PushUnsubscribeResult']
    export const isPushUnsubscribeResult = (obj?: { __typename?: any } | null): obj is PushUnsubscribeResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushUnsubscribeResult"')
      return PushUnsubscribeResult_possibleTypes.includes(obj.__typename)
    }
    


    const PushUnsubscribeResultPayload_possibleTypes: string[] = ['PushUnsubscribeResultPayload']
    export const isPushUnsubscribeResultPayload = (obj?: { __typename?: any } | null): obj is PushUnsubscribeResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushUnsubscribeResultPayload"')
      return PushUnsubscribeResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const PushSendTestResult_possibleTypes: string[] = ['PushSendTestResult']
    export const isPushSendTestResult = (obj?: { __typename?: any } | null): obj is PushSendTestResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushSendTestResult"')
      return PushSendTestResult_possibleTypes.includes(obj.__typename)
    }
    


    const PushSendTestResultPayload_possibleTypes: string[] = ['PushSendTestResultPayload']
    export const isPushSendTestResultPayload = (obj?: { __typename?: any } | null): obj is PushSendTestResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPushSendTestResultPayload"')
      return PushSendTestResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const FortuneSpinResult_possibleTypes: string[] = ['FortuneSpinResult']
    export const isFortuneSpinResult = (obj?: { __typename?: any } | null): obj is FortuneSpinResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFortuneSpinResult"')
      return FortuneSpinResult_possibleTypes.includes(obj.__typename)
    }
    


    const FortuneSpinResultPayload_possibleTypes: string[] = ['FortuneSpinResultPayload']
    export const isFortuneSpinResultPayload = (obj?: { __typename?: any } | null): obj is FortuneSpinResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFortuneSpinResultPayload"')
      return FortuneSpinResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const TelegramCreateResult_possibleTypes: string[] = ['TelegramCreateResult']
    export const isTelegramCreateResult = (obj?: { __typename?: any } | null): obj is TelegramCreateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTelegramCreateResult"')
      return TelegramCreateResult_possibleTypes.includes(obj.__typename)
    }
    


    const TelegramUpdateResult_possibleTypes: string[] = ['TelegramUpdateResult']
    export const isTelegramUpdateResult = (obj?: { __typename?: any } | null): obj is TelegramUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTelegramUpdateResult"')
      return TelegramUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const TelegramAuthByPhoneResult_possibleTypes: string[] = ['TelegramAuthByPhoneResult']
    export const isTelegramAuthByPhoneResult = (obj?: { __typename?: any } | null): obj is TelegramAuthByPhoneResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTelegramAuthByPhoneResult"')
      return TelegramAuthByPhoneResult_possibleTypes.includes(obj.__typename)
    }
    


    const TelegramAuthByPhoneResultPayload_possibleTypes: string[] = ['TelegramAuthByPhoneResultPayload']
    export const isTelegramAuthByPhoneResultPayload = (obj?: { __typename?: any } | null): obj is TelegramAuthByPhoneResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTelegramAuthByPhoneResultPayload"')
      return TelegramAuthByPhoneResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const ReviewServiceReviewResult_possibleTypes: string[] = ['ReviewServiceReviewResult']
    export const isReviewServiceReviewResult = (obj?: { __typename?: any } | null): obj is ReviewServiceReviewResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReviewServiceReviewResult"')
      return ReviewServiceReviewResult_possibleTypes.includes(obj.__typename)
    }
    


    const ReviewOrderGuestReviewResult_possibleTypes: string[] = ['ReviewOrderGuestReviewResult']
    export const isReviewOrderGuestReviewResult = (obj?: { __typename?: any } | null): obj is ReviewOrderGuestReviewResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReviewOrderGuestReviewResult"')
      return ReviewOrderGuestReviewResult_possibleTypes.includes(obj.__typename)
    }
    


    const ReviewOrderGuestReviewResultPayload_possibleTypes: string[] = ['ReviewOrderGuestReviewResultPayload']
    export const isReviewOrderGuestReviewResultPayload = (obj?: { __typename?: any } | null): obj is ReviewOrderGuestReviewResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReviewOrderGuestReviewResultPayload"')
      return ReviewOrderGuestReviewResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrderTestResult_possibleTypes: string[] = ['SaleOrderTestResult']
    export const isSaleOrderTestResult = (obj?: { __typename?: any } | null): obj is SaleOrderTestResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrderTestResult"')
      return SaleOrderTestResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrderTestResultPayload_possibleTypes: string[] = ['SaleOrderTestResultPayload']
    export const isSaleOrderTestResultPayload = (obj?: { __typename?: any } | null): obj is SaleOrderTestResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrderTestResultPayload"')
      return SaleOrderTestResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrderPayOnlineResult_possibleTypes: string[] = ['SaleOrderPayOnlineResult']
    export const isSaleOrderPayOnlineResult = (obj?: { __typename?: any } | null): obj is SaleOrderPayOnlineResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrderPayOnlineResult"')
      return SaleOrderPayOnlineResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrderPayOnlineResultPayload_possibleTypes: string[] = ['SaleOrderPayOnlineResultPayload']
    export const isSaleOrderPayOnlineResultPayload = (obj?: { __typename?: any } | null): obj is SaleOrderPayOnlineResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrderPayOnlineResultPayload"')
      return SaleOrderPayOnlineResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrderRepeatResult_possibleTypes: string[] = ['SaleOrderRepeatResult']
    export const isSaleOrderRepeatResult = (obj?: { __typename?: any } | null): obj is SaleOrderRepeatResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrderRepeatResult"')
      return SaleOrderRepeatResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrderCancelResult_possibleTypes: string[] = ['SaleOrderCancelResult']
    export const isSaleOrderCancelResult = (obj?: { __typename?: any } | null): obj is SaleOrderCancelResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrderCancelResult"')
      return SaleOrderCancelResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderNewResult_possibleTypes: string[] = ['VorderNewResult']
    export const isVorderNewResult = (obj?: { __typename?: any } | null): obj is VorderNewResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderNewResult"')
      return VorderNewResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderNewResultPayload_possibleTypes: string[] = ['VorderNewResultPayload']
    export const isVorderNewResultPayload = (obj?: { __typename?: any } | null): obj is VorderNewResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderNewResultPayload"')
      return VorderNewResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const Vorder_possibleTypes: string[] = ['Vorder']
    export const isVorder = (obj?: { __typename?: any } | null): obj is Vorder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorder"')
      return Vorder_possibleTypes.includes(obj.__typename)
    }
    


    const VorderApplyResult_possibleTypes: string[] = ['VorderApplyResult']
    export const isVorderApplyResult = (obj?: { __typename?: any } | null): obj is VorderApplyResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderApplyResult"')
      return VorderApplyResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderApplyResultPayload_possibleTypes: string[] = ['VorderApplyResultPayload']
    export const isVorderApplyResultPayload = (obj?: { __typename?: any } | null): obj is VorderApplyResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderApplyResultPayload"')
      return VorderApplyResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const VorderBasketResult_possibleTypes: string[] = ['VorderBasketResult']
    export const isVorderBasketResult = (obj?: { __typename?: any } | null): obj is VorderBasketResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderBasketResult"')
      return VorderBasketResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderBasketResultPayload_possibleTypes: string[] = ['VorderBasketResultPayload']
    export const isVorderBasketResultPayload = (obj?: { __typename?: any } | null): obj is VorderBasketResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderBasketResultPayload"')
      return VorderBasketResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const VorderDeliveryCalculateResult_possibleTypes: string[] = ['VorderDeliveryCalculateResult']
    export const isVorderDeliveryCalculateResult = (obj?: { __typename?: any } | null): obj is VorderDeliveryCalculateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderDeliveryCalculateResult"')
      return VorderDeliveryCalculateResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderDeliveryCalculateResultPayload_possibleTypes: string[] = ['VorderDeliveryCalculateResultPayload']
    export const isVorderDeliveryCalculateResultPayload = (obj?: { __typename?: any } | null): obj is VorderDeliveryCalculateResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderDeliveryCalculateResultPayload"')
      return VorderDeliveryCalculateResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const DeliveryCalculate_possibleTypes: string[] = ['DeliveryCalculate']
    export const isDeliveryCalculate = (obj?: { __typename?: any } | null): obj is DeliveryCalculate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeliveryCalculate"')
      return DeliveryCalculate_possibleTypes.includes(obj.__typename)
    }
    


    const VorderCouponResult_possibleTypes: string[] = ['VorderCouponResult']
    export const isVorderCouponResult = (obj?: { __typename?: any } | null): obj is VorderCouponResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderCouponResult"')
      return VorderCouponResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderCouponResultPayload_possibleTypes: string[] = ['VorderCouponResultPayload']
    export const isVorderCouponResultPayload = (obj?: { __typename?: any } | null): obj is VorderCouponResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderCouponResultPayload"')
      return VorderCouponResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const VorderSubmitResult_possibleTypes: string[] = ['VorderSubmitResult']
    export const isVorderSubmitResult = (obj?: { __typename?: any } | null): obj is VorderSubmitResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderSubmitResult"')
      return VorderSubmitResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderSubmitResultPayload_possibleTypes: string[] = ['VorderSubmitResultPayload']
    export const isVorderSubmitResultPayload = (obj?: { __typename?: any } | null): obj is VorderSubmitResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderSubmitResultPayload"')
      return VorderSubmitResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const VorderSyncResult_possibleTypes: string[] = ['VorderSyncResult']
    export const isVorderSyncResult = (obj?: { __typename?: any } | null): obj is VorderSyncResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderSyncResult"')
      return VorderSyncResult_possibleTypes.includes(obj.__typename)
    }
    


    const VorderSyncResultPayload_possibleTypes: string[] = ['VorderSyncResultPayload']
    export const isVorderSyncResultPayload = (obj?: { __typename?: any } | null): obj is VorderSyncResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVorderSyncResultPayload"')
      return VorderSyncResultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const SaleProfileDefaultResult_possibleTypes: string[] = ['SaleProfileDefaultResult']
    export const isSaleProfileDefaultResult = (obj?: { __typename?: any } | null): obj is SaleProfileDefaultResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleProfileDefaultResult"')
      return SaleProfileDefaultResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleProfileDeleteResult_possibleTypes: string[] = ['SaleProfileDeleteResult']
    export const isSaleProfileDeleteResult = (obj?: { __typename?: any } | null): obj is SaleProfileDeleteResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleProfileDeleteResult"')
      return SaleProfileDeleteResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleProfileSaveResult_possibleTypes: string[] = ['SaleProfileSaveResult']
    export const isSaleProfileSaveResult = (obj?: { __typename?: any } | null): obj is SaleProfileSaveResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleProfileSaveResult"')
      return SaleProfileSaveResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleProfileCalcDeliveryResult_possibleTypes: string[] = ['SaleProfileCalcDeliveryResult']
    export const isSaleProfileCalcDeliveryResult = (obj?: { __typename?: any } | null): obj is SaleProfileCalcDeliveryResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleProfileCalcDeliveryResult"')
      return SaleProfileCalcDeliveryResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleClientCardCreateResult_possibleTypes: string[] = ['SaleClientCardCreateResult']
    export const isSaleClientCardCreateResult = (obj?: { __typename?: any } | null): obj is SaleClientCardCreateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleClientCardCreateResult"')
      return SaleClientCardCreateResult_possibleTypes.includes(obj.__typename)
    }
    


    const SaleClientCardUpdateResult_possibleTypes: string[] = ['SaleClientCardUpdateResult']
    export const isSaleClientCardUpdateResult = (obj?: { __typename?: any } | null): obj is SaleClientCardUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleClientCardUpdateResult"')
      return SaleClientCardUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const CallTrackingRequestPhoneResult_possibleTypes: string[] = ['CallTrackingRequestPhoneResult']
    export const isCallTrackingRequestPhoneResult = (obj?: { __typename?: any } | null): obj is CallTrackingRequestPhoneResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCallTrackingRequestPhoneResult"')
      return CallTrackingRequestPhoneResult_possibleTypes.includes(obj.__typename)
    }
    


    const CallTrackingRequestPhoneResultPayload_possibleTypes: string[] = ['CallTrackingRequestPhoneResultPayload']
    export const isCallTrackingRequestPhoneResultPayload = (obj?: { __typename?: any } | null): obj is CallTrackingRequestPhoneResultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCallTrackingRequestPhoneResultPayload"')
      return CallTrackingRequestPhoneResultPayload_possibleTypes.includes(obj.__typename)
    }
    

export const enumErrorTypeEnum = {
   common: 'common' as const,
   rate: 'rate' as const,
   otp: 'otp' as const,
   access: 'access' as const,
   form: 'form' as const,
   external_service: 'external_service' as const,
   protocol: 'protocol' as const,
   internal: 'internal' as const,
   user: 'user' as const,
   vorder: 'vorder' as const
}

export const enumErrorNameEnum = {
   common: 'common' as const,
   common_not_found: 'common_not_found' as const,
   common_input_error: 'common_input_error' as const,
   common_invalid_format: 'common_invalid_format' as const,
   rate_limited: 'rate_limited' as const,
   otp_common: 'otp_common' as const,
   otp_code_wrong: 'otp_code_wrong' as const,
   otp_attempts_limit: 'otp_attempts_limit' as const,
   access_not_authorized: 'access_not_authorized' as const,
   access_restricted: 'access_restricted' as const,
   form_field_format_invalid: 'form_field_format_invalid' as const,
   form_field_required: 'form_field_required' as const,
   es_blocked: 'es_blocked' as const,
   es_rate_limit: 'es_rate_limit' as const,
   es_rejected: 'es_rejected' as const,
   protocol_socket_fail: 'protocol_socket_fail' as const,
   protocol_request_fail: 'protocol_request_fail' as const,
   internal: 'internal' as const,
   user_common: 'user_common' as const,
   vorder_restriction: 'vorder_restriction' as const,
   vorder_field_required: 'vorder_field_required' as const,
   vorder_basket_item_restricted: 'vorder_basket_item_restricted' as const,
   vorder_basket_item_schedule: 'vorder_basket_item_schedule' as const,
   vorder_basket_empty: 'vorder_basket_empty' as const,
   vorder_time_busy: 'vorder_time_busy' as const,
   vorder_coupon_invalid: 'vorder_coupon_invalid' as const,
   vorder_coupon_min_price: 'vorder_coupon_min_price' as const,
   vorder_bonus_lager_then_max_percent: 'vorder_bonus_lager_then_max_percent' as const,
   vorder_submit_failed: 'vorder_submit_failed' as const,
   vorder_save_failed: 'vorder_save_failed' as const
}

export const enumBasketRuleBenefitTypeEnum = {
   discount: 'discount' as const,
   gift: 'gift' as const,
   special: 'special' as const
}

export const enumVOrderSectionEnum = {
   delivery_courier: 'delivery_courier' as const,
   delivery_pickup: 'delivery_pickup' as const,
   payment: 'payment' as const,
   time: 'time' as const,
   basket: 'basket' as const,
   basket_item: 'basket_item' as const,
   cultery: 'cultery' as const,
   comment: 'comment' as const,
   benefit: 'benefit' as const,
   benefit_prize: 'benefit_prize' as const,
   benefit_coupon: 'benefit_coupon' as const,
   benefit_bonus: 'benefit_bonus' as const,
   benefit_discount: 'benefit_discount' as const,
   benefit_gift: 'benefit_gift' as const,
   common: 'common' as const,
   operator: 'operator' as const
}

export const enumDateFormatEnum = {
   jstimestamp: 'jstimestamp' as const,
   timestamp: 'timestamp' as const,
   datetime: 'datetime' as const,
   date: 'date' as const
}

export const enumNoticeTargetEnum = {
   common: 'common' as const,
   private: 'private' as const
}

export const enumNoticeShowAsEnum = {
   alert: 'alert' as const,
   dialog: 'dialog' as const
}

export const enumPrizeTypeEnum = {
   gift: 'gift' as const,
   discount: 'discount' as const
}

export const enumDeliveryTransportTypeEnum = {
   courier: 'courier' as const,
   pickup: 'pickup' as const
}

export const enumBasketItemBenefitType = {
   gift: 'gift' as const,
   special: 'special' as const
}

export const enumBasketItemDiscountTarget = {
   basket: 'basket' as const,
   delivery: 'delivery' as const,
   total: 'total' as const,
   product: 'product' as const,
   section: 'section' as const
}

export const enumBasketItemDiscountType = {
   percent: 'percent' as const,
   fixed: 'fixed' as const
}

export const enumAttrTimeModeEnum = {
   nearest: 'nearest' as const,
   custom: 'custom' as const
}

export const enumAttrPaymentTypeEnum = {
   cash: 'cash' as const,
   card: 'card' as const,
   online: 'online' as const
}

export const enumBenefitTypeEnum = {
   prize: 'prize' as const,
   discount: 'discount' as const,
   bonus: 'bonus' as const,
   coupon: 'coupon' as const,
   gift: 'gift' as const
}

export const enumAttrTransportTypeEnum = {
   courier: 'courier' as const,
   pickup: 'pickup' as const
}

export const enumOrderAttributeKindEnum = {
   prop: 'prop' as const,
   field: 'field' as const
}

export const enumOrderAttributeTypeEnum = {
   boolean: 'boolean' as const,
   string: 'string' as const,
   enum: 'enum' as const,
   number: 'number' as const,
   location: 'location' as const,
   json: 'json' as const,
   date: 'date' as const
}

export const enumOrderAttributeCodeEnum = {
   DETAILS: 'DETAILS' as const,
   UUID: 'UUID' as const,
   FIO: 'FIO' as const,
   PHONE: 'PHONE' as const,
   EMAIL: 'EMAIL' as const,
   DELIVERY_TYPE: 'DELIVERY_TYPE' as const,
   DELIVERY_DEPARTMENT: 'DELIVERY_DEPARTMENT' as const,
   STREET_PATH: 'STREET_PATH' as const,
   CITY: 'CITY' as const,
   CITY_FIAS_ID: 'CITY_FIAS_ID' as const,
   SETTLEMENT: 'SETTLEMENT' as const,
   SETTLEMENT_FIAS_ID: 'SETTLEMENT_FIAS_ID' as const,
   STREET_FIAS_ID: 'STREET_FIAS_ID' as const,
   STREET_COORDS: 'STREET_COORDS' as const,
   HOUSE: 'HOUSE' as const,
   HOUSE_FIAS_ID: 'HOUSE_FIAS_ID' as const,
   HOUSE_COORDS: 'HOUSE_COORDS' as const,
   FLAT: 'FLAT' as const,
   LOCATION: 'LOCATION' as const,
   INTERCOM: 'INTERCOM' as const,
   FLOOR: 'FLOOR' as const,
   ENTRANCE: 'ENTRANCE' as const,
   PRIVATE_HOUSE: 'PRIVATE_HOUSE' as const,
   LIFT: 'LIFT' as const,
   PICKUP_DEPARTMENT: 'PICKUP_DEPARTMENT' as const,
   TIME_MODE: 'TIME_MODE' as const,
   DATE: 'DATE' as const,
   TIME: 'TIME' as const,
   PAYMENT_TYPE: 'PAYMENT_TYPE' as const,
   CASH_SUM: 'CASH_SUM' as const,
   BONUSES: 'BONUSES' as const,
   PROMOCODE: 'PROMOCODE' as const,
   DELIVERY_PRICE: 'DELIVERY_PRICE' as const,
   RECEIVER_NAME: 'RECEIVER_NAME' as const,
   RECEIVER_ANOTHER: 'RECEIVER_ANOTHER' as const,
   RECEIVER_PHONE: 'RECEIVER_PHONE' as const,
   PERSONS_NUMBER: 'PERSONS_NUMBER' as const,
   COMMENT: 'COMMENT' as const,
   GIFTS_LIST: 'GIFTS_LIST' as const,
   WITH_OPERATOR: 'WITH_OPERATOR' as const,
   ROISTAT: 'ROISTAT' as const,
   NEED_CONFIRM: 'NEED_CONFIRM' as const,
   PROFILE_COMMENT: 'PROFILE_COMMENT' as const,
   ADDRESS_SOURCE: 'ADDRESS_SOURCE' as const,
   PROFILE_ID: 'PROFILE_ID' as const,
   ADDRESS_IS_CUSTOM: 'ADDRESS_IS_CUSTOM' as const,
   PROFILE_DEFAULT: 'PROFILE_DEFAULT' as const,
   VORDER_ID: 'VORDER_ID' as const,
   SERVICE_SEND: 'SERVICE_SEND' as const,
   DATETIME: 'DATETIME' as const,
   SERVICE_SEND_START: 'SERVICE_SEND_START' as const,
   DATA: 'DATA' as const,
   RESERVE_SUCCESS_HASH: 'RESERVE_SUCCESS_HASH' as const,
   DISCOUNT_REASON: 'DISCOUNT_REASON' as const,
   DISCOUNT_PERCENT: 'DISCOUNT_PERCENT' as const,
   ADDRESS: 'ADDRESS' as const,
   BENEFIT_TYPE: 'BENEFIT_TYPE' as const,
   DELIVERY_FREE_FROM_PRICE: 'DELIVERY_FREE_FROM_PRICE' as const,
   STREET: 'STREET' as const,
   DEPARTMENT_SERVICE_ID: 'DEPARTMENT_SERVICE_ID' as const,
   DELIVERY_FREE_UPDATED_TIME: 'DELIVERY_FREE_UPDATED_TIME' as const,
   IS_ACCEPTED: 'IS_ACCEPTED' as const,
   TEST_TIME: 'TEST_TIME' as const,
   STRUCT: 'STRUCT' as const,
   TRANSPORT_TYPE: 'TRANSPORT_TYPE' as const,
   COUPON_ID: 'COUPON_ID' as const,
   PRIZE_ID: 'PRIZE_ID' as const,
   SESSION_ID: 'SESSION_ID' as const,
   PAYMENT_GIFT: 'PAYMENT_GIFT' as const,
   TEST_TIME_NEW: 'TEST_TIME_NEW' as const,
   APP_VERSION: 'APP_VERSION' as const,
   SOURCE: 'SOURCE' as const,
   RESERVE_REQUEST_TIME: 'RESERVE_REQUEST_TIME' as const,
   UTM_SOURCE: 'UTM_SOURCE' as const,
   RESERVE_AVAILABLE_TIME: 'RESERVE_AVAILABLE_TIME' as const,
   RESERVE_NEED_TIME: 'RESERVE_NEED_TIME' as const,
   RESERVE_STATUS: 'RESERVE_STATUS' as const,
   RESERVE_SUCCESS_REQUEST_TIME: 'RESERVE_SUCCESS_REQUEST_TIME' as const,
   UTM_MEDIUM: 'UTM_MEDIUM' as const,
   UTM_CAMPAIGN: 'UTM_CAMPAIGN' as const,
   UTM_TERM: 'UTM_TERM' as const,
   UTM_CONTENT: 'UTM_CONTENT' as const,
   UTM_LANDING_URL: 'UTM_LANDING_URL' as const,
   DELIVERY_ID: 'DELIVERY_ID' as const,
   PAY_SYSTEM_ID: 'PAY_SYSTEM_ID' as const,
   USER_DESCRIPTION: 'USER_DESCRIPTION' as const
}

export const enumPaymentTypeEnum = {
   cash: 'cash' as const,
   card: 'card' as const,
   online: 'online' as const
}

export const enumDiscountTargetEnum = {
   product: 'product' as const,
   basket: 'basket' as const,
   delivery: 'delivery' as const,
   total: 'total' as const
}

export const enumOfficeRoleEnum = {
   delivery: 'delivery' as const,
   pickup: 'pickup' as const,
   bar: 'bar' as const
}

export const enumMessageTypeEnum = {
   success: 'success' as const,
   error: 'error' as const,
   info: 'info' as const,
   warning: 'warning' as const
}

export const enumOfferRoleEnum = {
   banner: 'banner' as const,
   sticker: 'sticker' as const
}

export const enumBasketRuleTypeEnum = {
   discount: 'discount' as const,
   gift: 'gift' as const,
   common: 'common' as const,
   special: 'special' as const
}

export const enumModificatorTypeEnum = {
   gift: 'gift' as const,
   special: 'special' as const,
   additive: 'additive' as const,
   constructor: 'constructor' as const,
   feature: 'feature' as const
}

export const enumProductModificatorCardPositionEnum = {
   media: 'media' as const,
   title: 'title' as const,
   sale: 'sale' as const
}

export const enumProductModificatorOptionInfoTypeEnum = {
   product: 'product' as const
}

export const enumLogicEnum = {
   Y: 'Y' as const,
   N: 'N' as const
}

export const enumProductModificatorDetailPositionEnum = {
   media: 'media' as const,
   title: 'title' as const,
   sale: 'sale' as const
}

export const enumButtonStyleEnum = {
   flat: 'flat' as const,
   filled: 'filled' as const,
   outline: 'outline' as const
}

export const enumTimeModeEnum = {
   nearest: 'nearest' as const,
   custom: 'custom' as const
}

export const enumDeliveryCalcStatusEnum = {
   success: 'success' as const,
   time_busy: 'time_busy' as const,
   service_unavailable: 'service_unavailable' as const,
   address_not_found: 'address_not_found' as const
}


export interface QueryTestPublicpublicArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface QueryTestOptionalAuthlistArgs { 
    filter?: (TestItemFilterInput | null) 
}
export interface QueryTestRequiredAuthauthorizedArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface QueryTestAdminOnlyadminOnlyArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface QueryTestCombinedadminOnlyArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface QueryTestCombinedlistArgs { 
    filter?: (TestItemFilterInput | null) 
}
export interface QueryEntityOptionsArgs { 
    entityType?: (EntityQueryTargetInput | null), ids: Scalars['String'][], limit?: (Scalars['Int'] | null) 
}
export interface QueryEntityTypeListArgs { 
    filter?: (EntityQueryTargetInput | null) 
}
export interface QueryEntityTypeArgs { 
    filter?: (EntityQueryTargetInput | null) 
}
export interface QueryUserFetchArgs { 
    sessionWrite?: (Scalars['Boolean'] | null) 
}
export interface QueryPageSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryPageListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryPageRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryPageRouteArgs { 
    URL?: (Scalars['String'] | null) 
}
export interface QueryCompanyOfficeSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (OfficeFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryCompanyOfficeListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (OfficeFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCompanyOfficeRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (OfficeFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCompanyVacancySingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryCompanyVacancyListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCompanyVacancyRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryFaqElementSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryFaqElementListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryFaqElementRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryGeoGeocoderLocationsByCoordsArgs { 
    lat?: (Scalars['Float'] | null), lon?: (Scalars['Float'] | null) 
}
export interface QueryGeoGeocoderLocationByAddressArgs { 
    address?: (Scalars['String'] | null) 
}
export interface QuerySearchSuggestionsArgs { 
    query?: (Scalars['String'] | null) 
}
export interface QueryOfferSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryOfferListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryOfferRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryTelegramSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (HLEntityFilter | null), nav?: (QueryNavInput | null) 
}
export interface QueryTelegramListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (HLEntityFilter | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryTelegramRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (HLEntityFilter | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryTelegramChatByIdArgs { 
    chatId: Scalars['String'] 
}
export interface QueryTelegramActiveChatsArgs { 
    limit?: (Scalars['Int'] | null) 
}
export interface QueryCameraElementListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryReviewListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ProductFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryCatalogProductListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ProductFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ProductFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductAllArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ProductFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductFavListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ProductFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductFavList2Args { 
    type?: (Scalars['String'] | null) 
}
export interface QueryCatalogProductSearchArgs { 
    query?: (Scalars['String'] | null), elementDetail?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductSearchNewArgs { 
    query?: (Scalars['String'] | null), filterSuggestion?: (SearchSuggestionDataInput | null), elementDetail?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleOrderActiveListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (OrderFilter | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleOrderEnsurePaymentArgs { 
    id?: (Scalars['Int'] | null), hash?: (Scalars['String'] | null), paymentId?: (Scalars['Int'] | null) 
}
export interface QueryVorderCurrentArgs { 
    check?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleProfileSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QuerySaleProfileListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleProfileRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleClientCardSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ClientCardFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QuerySaleClientCardListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ClientCardFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleClientCardRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ClientCardFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleClientCardFetchArgs { 
    isScope?: (Scalars['Boolean'] | null), refetch?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleClientCardApplyByPhoneArgs { 
    phone?: (Scalars['String'] | null) 
}
export interface QueryBasketRuleListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QuerySaleBonusLevelListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryProductIngredientListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryProductFlagListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryOrderRestrictionListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryCatalogProductSectionListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (SectionFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryOrderHistoryArgs { 
    limit?: (Scalars['Int'] | null) 
}
export interface QueryClientSegmentSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryClientSegmentListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryClientSegmentRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryFeatureSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryFeatureListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryFeatureRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryFeatureListForUserArgs { 
    user_id?: (Scalars['Int'] | null) 
}
export interface QueryYandexMetricGoalSingleArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null) 
}
export interface QueryYandexMetricGoalListArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface QueryYandexMetricGoalRecordsetArgs { 
    id?: (Scalars['Int'] | null), where?: (Scalars['Json'] | null), filter?: (ElementListFilterInput | null), nav?: (QueryNavInput | null), computed?: (EntityComputedFieldInput[] | null), nocache?: (Scalars['Boolean'] | null) 
}
export interface ClientEmitCreatedAtArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface PageActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface PageActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface PageTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface PageDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface PagePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface PageDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface PageShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface SectionTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface SectionSearchableContentArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface SectionDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyOfficeActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyOfficeActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyOfficeTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyOfficeDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyOfficePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface CompanyOfficeDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface CompanyOfficeShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyVacancyActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyVacancyActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyVacancyTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyVacancyDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CompanyVacancyPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface CompanyVacancyDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface CompanyVacancyShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FaqQuestionActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FaqQuestionActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FaqQuestionTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FaqQuestionDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FaqQuestionPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface FaqQuestionDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface FaqQuestionShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OfferActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OfferActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OfferTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OfferDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OfferPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface OfferDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface OfferShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FortunePrizeActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FortunePrizeActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FortunePrizeTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FortunePrizeDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FortunePrizePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface FortunePrizeDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface FortunePrizeShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ElementActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ElementActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ElementTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ElementDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ElementPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ElementDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ElementShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface WebcamActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface WebcamActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface WebcamTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface WebcamDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface WebcamPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface WebcamDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface WebcamShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ReviewActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ReviewActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ReviewTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ReviewDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ReviewPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ReviewDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ReviewShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OrderDateInsertArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface OrderDateUpdateArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface OrderDatePayedArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface OrderDateFormattedArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface OrderDateTimeFormattedArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface OrderDeliveryDatetimeArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface ProductActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ProductActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ProductTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ProductDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ProductPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ProductDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ProductShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface PaymentDatePaidArgs { 
    format?: (Scalars['String'] | null), formatType?: (DateFormatEnum | null) 
}
export interface VorderCurrentBasketArgs { 
    recalc?: (Scalars['Boolean'] | null) 
}
export interface DiscountActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface DiscountActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface DiscountTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface DiscountDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface DiscountPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface DiscountDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface DiscountShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BasketRuleActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BasketRuleActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BasketRuleTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BasketRuleDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BasketRulePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface BasketRuleDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface BasketRuleShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BonusLevelActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BonusLevelActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BonusLevelTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BonusLevelDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface BonusLevelPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface BonusLevelDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface BonusLevelShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface DeliveryZonePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ModificatorSectionTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ModificatorSectionSearchableContentArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ModificatorSectionDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OrderRestrictionActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OrderRestrictionActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OrderRestrictionTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OrderRestrictionDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface OrderRestrictionPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface OrderRestrictionDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface OrderRestrictionShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ProductSectionTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ProductSectionSearchableContentArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ProductSectionDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ClientSegmentActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ClientSegmentActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ClientSegmentTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ClientSegmentDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface ClientSegmentPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ClientSegmentDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface ClientSegmentShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FeatureActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FeatureActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FeatureTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FeatureDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface FeaturePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface FeatureDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface FeatureShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CallTrackingPhoneActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CallTrackingPhoneActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CallTrackingPhoneTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CallTrackingPhoneDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface CallTrackingPhonePreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface CallTrackingPhoneDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface CallTrackingPhoneShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface YandexMetricGoalActiveFromArgs { 
    format?: (Scalars['String'] | null) 
}
export interface YandexMetricGoalActiveToArgs { 
    format?: (Scalars['String'] | null) 
}
export interface YandexMetricGoalTimestampXArgs { 
    format?: (Scalars['String'] | null) 
}
export interface YandexMetricGoalDateCreateArgs { 
    format?: (Scalars['String'] | null) 
}
export interface YandexMetricGoalPreviewTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface YandexMetricGoalDetailTextArgs { 
    format?: (Scalars['Boolean'] | null) 
}
export interface YandexMetricGoalShowCounterStartArgs { 
    format?: (Scalars['String'] | null) 
}
export interface MutationTestMutationcreateArgs { 
    model: TestItemInput 
}
export interface MutationTestMutationupdateArgs { 
    id: Scalars['Int'], model: TestItemInput 
}
export interface MutationTestMutationdeleteArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface MutationNoticePubSyncReadedArgs { 
    ids?: (Scalars['Json'] | null) 
}
export interface MutationNoticePubPushUpdateTokenArgs { 
    pushToken?: (Scalars['String'] | null) 
}
export interface MutationUserAuthCreateSaArgs { 
    phone?: (Scalars['String'] | null), clientIds?: (Scalars['Json'] | null), code?: (Scalars['String'] | null) 
}
export interface MutationUserAuthLoginStartArgs { 
    phone?: (Scalars['String'] | null), captcha?: (CaptchaInput | null) 
}
export interface MutationUserAuthLoginRequestArgs { 
    confirmMode?: (Scalars['String'] | null), phone?: (Scalars['String'] | null), captcha?: (CaptchaInput | null), token?: (Scalars['String'] | null) 
}
export interface MutationUserAuthLoginConfirmArgs { 
    confirmMode?: (Scalars['String'] | null), phone?: (Scalars['String'] | null), captcha?: (CaptchaInput | null), code?: (Scalars['String'] | null), sid?: (Scalars['String'] | null), clientId?: (Scalars['String'] | null), disableBasketTransfer?: (Scalars['Boolean'] | null), pushToken?: (Scalars['String'] | null) 
}
export interface MutationUserAppClientArgs { 
    debugParams?: (Scalars['Json'] | null), mobilePushToken?: (Scalars['String'] | null), webPushToken?: (Scalars['String'] | null) 
}
export interface MutationUserProfileSaveArgs { 
    form?: (Scalars['Json'] | null) 
}
export interface MutationUserProfileNameArgs { 
    name?: (Scalars['String'] | null) 
}
export interface MutationUserProfileBirthdayArgs { 
    birthday?: (Scalars['String'] | null) 
}
export interface MutationUserProfileEmailArgs { 
    action?: (Scalars['String'] | null), email?: (Scalars['String'] | null), code?: (Scalars['String'] | null) 
}
export interface MutationCompanyOfficeUpdateArgs { 
    id: Scalars['Int'], model: CompanyOfficeInput 
}
export interface MutationCompanyVacancyOrderArgs { 
    id?: (Scalars['Int'] | null), model?: (Scalars['Json'] | null) 
}
export interface MutationPushSubscribeArgs { 
    endpoint: Scalars['String'], p256dhKey: Scalars['String'], authToken: Scalars['String'] 
}
export interface MutationPushSendTestArgs { 
    title: Scalars['String'], body: Scalars['String'], data?: (Scalars['Json'] | null) 
}
export interface MutationTelegramCreateArgs { 
    model: TelegramChatInput 
}
export interface MutationTelegramUpdateArgs { 
    id: Scalars['Int'], model: TelegramChatInput 
}
export interface MutationTelegramDeleteArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface MutationTelegramAuthByPhoneArgs { 
    phone: Scalars['String'], chatId: Scalars['String'], telegramId: Scalars['String'] 
}
export interface MutationReviewServiceReviewArgs { 
    model?: (Scalars['Json'] | null) 
}
export interface MutationReviewOrderGuestReviewArgs { 
    type?: (Scalars['String'] | null), 
    /** Order service id */
    orderServiceId?: (Scalars['Int'] | null) 
}
export interface MutationCatalogProductOrderArgs { 
    elementId?: (Scalars['Int'] | null), model?: (Scalars['Json'] | null) 
}
export interface MutationSaleOrderPayOnlineArgs { 
    id?: (Scalars['Int'] | null), hash?: (Scalars['String'] | null), type?: (Scalars['String'] | null), savePaymentType?: (Scalars['Boolean'] | null) 
}
export interface MutationSaleOrderRepeatArgs { 
    id?: (Scalars['Int'] | null), hash?: (Scalars['String'] | null) 
}
export interface MutationSaleOrderCancelArgs { 
    id?: (Scalars['Int'] | null), hash?: (Scalars['String'] | null), reason?: (Scalars['String'] | null), comment?: (Scalars['String'] | null) 
}
export interface MutationVorderApplyArgs { 
    order?: (VorderInput | null), params?: (Scalars['Json'] | null) 
}
export interface MutationVorderBasketArgs { 
    order?: (VorderInput | null), action?: (Scalars['String'] | null), build?: (Scalars['Json'] | null) 
}
export interface MutationVorderDeliveryCalculateArgs { 
    order?: (VorderInput | null), calc?: (DeliveryCalculateInput | null) 
}
export interface MutationVorderCouponArgs { 
    order?: (VorderInput | null), action?: (Scalars['String'] | null), couponCode?: (Scalars['String'] | null), orderPrice?: (Scalars['Int'] | null) 
}
export interface MutationVorderSubmitArgs { 
    order?: (VorderInput | null) 
}
export interface MutationVorderSyncArgs { 
    order?: (VorderInput | null) 
}
export interface MutationSaleProfileDefaultArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface MutationSaleProfileDeleteArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface MutationSaleProfileSaveArgs { 
    id?: (Scalars['Int'] | null), attrs?: (OrderAttributesValueInput | null) 
}
export interface MutationSaleProfileCalcDeliveryArgs { 
    profileId?: (Scalars['Int'] | null), attrs?: (OrderAttributesValueInput | null), basket?: (Scalars['Json'] | null), timeMode?: (TimeModeEnum | null), timeNeed?: (Scalars['Int'] | null) 
}
export interface MutationSaleClientCardCreateArgs { 
    model: ElementInput 
}
export interface MutationSaleClientCardUpdateArgs { 
    id: Scalars['Int'], model: ElementInput 
}
export interface MutationSaleClientCardDeleteArgs { 
    id?: (Scalars['Int'] | null) 
}
export interface VorderBasketArgs { 
    recalc?: (Scalars['Boolean'] | null) 
}